/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: any;
  JSON: any;
  LearningScenario: any;
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: any;
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  LocalTime: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The NonNegativeInt scalar type represents a unsigned 32-bit numeric non-fractional value equal to or greater than 0. */
  NonNegativeInt: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  UUID: any;
};

export type AcceptInvitationError = InvitationError;

export type AcceptInvitationInput = {
  invitationId: Scalars['UUID'];
};

export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  errors?: Maybe<Array<AcceptInvitationError>>;
  result?: Maybe<Result>;
};

export type Action = {
  __typename?: 'Action';
  actionType: ActionType;
  channelActions: Array<ChannelAction>;
  channelType?: Maybe<ChannelTypeInternal>;
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  sourceGroupId?: Maybe<Scalars['UUID']>;
};

export type ActionConfigResponse = {
  destination?: Maybe<BindingAddress>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
};

export type ActionError = Error & {
  __typename?: 'ActionError';
  error: ActionErrorDictionary;
  message: Scalars['String'];
};

export enum ActionErrorDictionary {
  ActionDoesNotExist = 'ACTION_DOES_NOT_EXIST',
  CannotRemoveCentralAction = 'CANNOT_REMOVE_CENTRAL_ACTION',
  InvalidActionParameters = 'INVALID_ACTION_PARAMETERS',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION'
}

export type ActionFilterInput = {
  actionType?: InputMaybe<ActionTypeOperationFilterInput>;
  and?: InputMaybe<Array<ActionFilterInput>>;
  channelActions?: InputMaybe<ListFilterInputTypeOfChannelActionFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActionFilterInput>>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  sourceGroupId?: InputMaybe<UuidOperationFilterInput>;
};

export type ActionSortInput = {
  actionType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  sourceGroupId?: InputMaybe<SortEnumType>;
};

export enum ActionType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  Central = 'CENTRAL'
}

export type ActionTypeOperationFilterInput = {
  eq?: InputMaybe<ActionType>;
  in?: InputMaybe<Array<ActionType>>;
  neq?: InputMaybe<ActionType>;
  nin?: InputMaybe<Array<ActionType>>;
};

export type ActivateTriggerError = TriggerError;

export type ActivateTriggerInput = {
  installationId: Scalars['UUID'];
  triggerId: Scalars['UUID'];
};

export type ActivateTriggerPayload = {
  __typename?: 'ActivateTriggerPayload';
  errors?: Maybe<Array<ActivateTriggerError>>;
  result?: Maybe<Result>;
};

export enum ActivityType {
  ClientControlled = 'CLIENT_CONTROLLED',
  Close = 'CLOSE',
  Off = 'OFF',
  On = 'ON',
  Open = 'OPEN',
  SetDim = 'SET_DIM',
  SetLightColor = 'SET_LIGHT_COLOR',
  SetPosition = 'SET_POSITION',
  StepByStep = 'STEP_BY_STEP',
  Stop = 'STOP',
  Tilt = 'TILT'
}

export type ActivityTypeOperationFilterInput = {
  eq?: InputMaybe<ActivityType>;
  in?: InputMaybe<Array<ActivityType>>;
  neq?: InputMaybe<ActivityType>;
  nin?: InputMaybe<Array<ActivityType>>;
};

export type AdvancedActionChannelItemInput = {
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  order: Scalars['Int'];
  parameter: ChannelActionParameterInput;
};

export type AggregateVectorMeasurementRequestItemInput = {
  range: MeasurementDataRangeInternal;
  type: AggregateVectorParameterTypeInternal;
};

export type AggregateVectorMeasurementResponseItem = {
  __typename?: 'AggregateVectorMeasurementResponseItem';
  index: Scalars['Int'];
  range: MeasurementDataRangeInternal;
  tariff?: Maybe<TariffKindInternal>;
  type: AggregateVectorParameterTypeInternal;
  values: Array<Scalars['Float']>;
};

export enum AggregateVectorParameterTypeInternal {
  Cost = 'COST',
  DynamicEnergyMarketPrice = 'DYNAMIC_ENERGY_MARKET_PRICE',
  ForwardActiveEnergy = 'FORWARD_ACTIVE_ENERGY',
  ForwardReactiveEnergy = 'FORWARD_REACTIVE_ENERGY',
  PredictionForwardActiveEnergy = 'PREDICTION_FORWARD_ACTIVE_ENERGY',
  PredictionVectorBalancedActiveEnergy = 'PREDICTION_VECTOR_BALANCED_ACTIVE_ENERGY',
  Price = 'PRICE',
  ReverseActiveEnergy = 'REVERSE_ACTIVE_ENERGY',
  ReverseReactiveEnergy = 'REVERSE_REACTIVE_ENERGY',
  Unknown = 'UNKNOWN',
  VectorBalancedActiveEnergyIncoming = 'VECTOR_BALANCED_ACTIVE_ENERGY_INCOMING',
  VectorBalancedActiveEnergyOutgoing = 'VECTOR_BALANCED_ACTIVE_ENERGY_OUTGOING',
  VectorBalancedCost = 'VECTOR_BALANCED_COST',
  VoltageAvr = 'VOLTAGE_AVR',
  VoltageMax = 'VOLTAGE_MAX',
  VoltageMin = 'VOLTAGE_MIN'
}

/** A segment of a collection. */
export type AllUserNotificationsCollectionSegment = {
  __typename?: 'AllUserNotificationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type AllowedPrefix = {
  __typename?: 'AllowedPrefix';
  dateAdded: Scalars['DateTime'];
  prefix: Scalars['String'];
};

export enum AmpTransformersInternal {
  FourHundredsAmps = 'FOUR_HUNDREDS_AMPS',
  OneHundredAmps = 'ONE_HUNDRED_AMPS',
  OneThousandAmps = 'ONE_THOUSAND_AMPS',
  TwoHundredsAmps = 'TWO_HUNDREDS_AMPS',
  Unknown = 'UNKNOWN'
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type AssistantBinding = {
  __typename?: 'AssistantBinding';
  assistantType: AssistantType;
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type AssistantBindingError = Error & {
  __typename?: 'AssistantBindingError';
  error: AssistantBindingErrorDictionary;
  message: Scalars['String'];
};

export enum AssistantBindingErrorDictionary {
  ExactBindingAlreadyExist = 'EXACT_BINDING_ALREADY_EXIST',
  InstallationDoesNotExist = 'INSTALLATION_DOES_NOT_EXIST',
  Undefined = 'UNDEFINED'
}

export enum AssistantType {
  GoogleHome = 'GOOGLE_HOME',
  Undefined = 'UNDEFINED'
}

export type BaseChannelPayload = BinarySensorConfigurationChangePayload | BinarySensorValueChangePayload | BlindCalibrateStatusChangePayload | BlindDirectionChangePayload | BlindPositionChangePayload | ConfigurationTaintedPayload | GateCalibrateStatusChangePayload | GateConfigurationChangePayload | GatePositionChangePayload | GateStatusChangedPayload | GenericInputStateChangePayload | GenericInputStatusChangedPayload | HvacRegulatorModeChangePayload | HvacSensorFloorTemperatureChangePayload | HvacSensorHumidityChangePayload | HvacSensorTemperatureChangePayload | HvacTargetTemperatureChangePayload | HvacTemperatureUnitChangePayload | HvacWorkingModeChangePayload | LightStateChangedPayload | LightStateOnTimeChangePayload | OptimizerConfigurationTaintedPayload | OptimizerConfigurationUpdatedPayload | PartialConfigChangedPayload | SensorConfigurationChangePayload | SensorValueChangePayload | SupplyReturnBehaviorChangePayload | SwitchStateChangePayload | SwitchStateOnTimeChangePayload;

export type BasicActionChannelItemInput = {
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  order: Scalars['Int'];
};

export type BinarySensorChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'BinarySensorChannelStateResponse';
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  sensorType: BinarySensorTypeInternal;
  value?: Maybe<Scalars['Boolean']>;
};

export type BinarySensorConfigurationChangePayload = {
  __typename?: 'BinarySensorConfigurationChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  sensorType: BinarySensorTypeInternal;
};

export enum BinarySensorTypeInternal {
  Unknown = 'UNKNOWN'
}

export type BinarySensorValueChangePayload = {
  __typename?: 'BinarySensorValueChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  value: Scalars['Boolean'];
};

export type BindInstallationToAssistantError = AssistantBindingError;

export type BindInstallationToAssistantInput = {
  assistantType: AssistantType;
  installationId: Scalars['UUID'];
};

export type BindInstallationToAssistantPayload = {
  __typename?: 'BindInstallationToAssistantPayload';
  errors?: Maybe<Array<BindInstallationToAssistantError>>;
  result?: Maybe<Result>;
};

export type BindingAddress = {
  __typename?: 'BindingAddress';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
};

export type BlindActionConfigResponse = ActionConfigResponse & {
  __typename?: 'BlindActionConfigResponse';
  destination?: Maybe<BindingAddress>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  slot: BlindSupportedSlotsInternal;
};

export type BlindCalibrateStatusChangePayload = {
  __typename?: 'BlindCalibrateStatusChangePayload';
  channelId: Scalars['UUID'];
  closingMilliseconds: Scalars['Long'];
  deviceId: Scalars['UUID'];
  error?: Maybe<BlindChannelCalibrateErrorInternal>;
  installationId: Scalars['UUID'];
  openingMilliseconds: Scalars['Long'];
  progress?: Maybe<Scalars['Int']>;
  status: BlindCalibrateStatusTypePayload;
};

export enum BlindCalibrateStatusTypePayload {
  Data = 'DATA',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Started = 'STARTED'
}

export enum BlindChannelCalibrateErrorInternal {
  CurrentDetected = 'CURRENT_DETECTED',
  CurrentOnBothChannelDetected = 'CURRENT_ON_BOTH_CHANNEL_DETECTED',
  InterruptedByTheUser = 'INTERRUPTED_BY_THE_USER',
  NoCurrentDetected = 'NO_CURRENT_DETECTED',
  Timeout = 'TIMEOUT',
  Unknown = 'UNKNOWN'
}

export type BlindChannelCalibrateStateResponse = {
  __typename?: 'BlindChannelCalibrateStateResponse';
  closingMilliseconds: Scalars['NonNegativeInt'];
  error?: Maybe<BlindChannelCalibrateErrorInternal>;
  openingMilliseconds: Scalars['NonNegativeInt'];
  progress?: Maybe<Scalars['NonNegativeInt']>;
  started?: Maybe<Scalars['Boolean']>;
};

export type BlindChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'BlindChannelStateResponse';
  calibrateState?: Maybe<BlindChannelCalibrateStateResponse>;
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  direction: BlindStateDirectionInternal;
  measuredBy?: Maybe<MeasuredBy>;
  position?: Maybe<Scalars['NonNegativeInt']>;
  supportedSlots: Array<BlindSupportedSlotsInternal>;
};

export type BlindDirectionChangePayload = {
  __typename?: 'BlindDirectionChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  direction: BlindStateDirectionInternal;
  installationId: Scalars['UUID'];
};

export type BlindPositionChangePayload = {
  __typename?: 'BlindPositionChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  direction: BlindStateDirectionInternal;
  installationId: Scalars['UUID'];
  position: Scalars['Int'];
  predictedTimeInMs?: Maybe<Scalars['Int']>;
  slatsPredictedTimeInMs?: Maybe<Scalars['Int']>;
  targetPosition?: Maybe<Scalars['Int']>;
};

export enum BlindStateDirectionInternal {
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Unknown = 'UNKNOWN'
}

export enum BlindSupportedSlotsInternal {
  Advanced = 'ADVANCED',
  Close = 'CLOSE',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type BluetoothLogPayload = {
  __typename?: 'BluetoothLogPayload';
  loggingInfo: LoggingInfo;
  macAddress: Scalars['String'];
  messages: Array<Array<Scalars['Byte']>>;
  sessionId?: Maybe<Scalars['Long']>;
  validFrom?: Maybe<Scalars['Long']>;
  validTo?: Maybe<Scalars['Long']>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type BucketInfo = {
  __typename?: 'BucketInfo';
  from: Scalars['Int'];
  fromPrice: Scalars['Decimal'];
  fromPriceInKWh: Scalars['Decimal'];
  to: Scalars['Int'];
  toPrice: Scalars['Decimal'];
  toPriceInKWh: Scalars['Decimal'];
};

export type CacheInfo = {
  __typename?: 'CacheInfo';
  hash: Scalars['String'];
  installationId?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  validFrom: Scalars['DateTime'];
};

export type CacheResponses = {
  __typename?: 'CacheResponses';
  actionsCache?: Maybe<CacheInfo>;
  groupsCache?: Maybe<CacheInfo>;
  installationsCache?: Maybe<CacheInfo>;
  measurementMapCache?: Maybe<CacheInfo>;
  pushRegistrationsCache?: Maybe<CacheInfo>;
};

export type CancelInvitationError = InvitationError;

export type CancelInvitationInput = {
  invitationId: Scalars['UUID'];
};

export type CancelInvitationPayload = {
  __typename?: 'CancelInvitationPayload';
  errors?: Maybe<Array<CancelInvitationError>>;
  result?: Maybe<Result>;
};

export type ChangeChannelsVisibilityError = ChannelError;

export type ChangeChannelsVisibilityInput = {
  channels: Array<ChannelVisibilityDtoInput>;
};

export type ChangeChannelsVisibilityPayload = {
  __typename?: 'ChangeChannelsVisibilityPayload';
  errors?: Maybe<Array<ChangeChannelsVisibilityError>>;
  result?: Maybe<Result>;
};

export type ChangeGeolocationError = InstallationAttachmentError | InstallationError;

export type ChangeGeolocationInput = {
  coordinates?: InputMaybe<CoordinatesDtoInput>;
  installationId: Scalars['UUID'];
};

export type ChangeGeolocationPayload = {
  __typename?: 'ChangeGeolocationPayload';
  errors?: Maybe<Array<ChangeGeolocationError>>;
  result?: Maybe<Result>;
};

export type ChangeGroupItemsOrderRequestInput = {
  groupId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  items: Array<ItemWithOrderInput>;
};

export type ChangeGroupOrderRequestInput = {
  groups: Array<GroupWithOrderInput>;
  installationId: Scalars['UUID'];
};

export type ChangeInstallationColorError = InstallationError;

export type ChangeInstallationColorInput = {
  hexColor: Scalars['String'];
  installationId: Scalars['UUID'];
};

export type ChangeInstallationColorPayload = {
  __typename?: 'ChangeInstallationColorPayload';
  errors?: Maybe<Array<ChangeInstallationColorError>>;
  result?: Maybe<Result>;
};

export type ChangeInstallationIconError = InstallationError;

export type ChangeInstallationIconInput = {
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
};

export type ChangeInstallationIconPayload = {
  __typename?: 'ChangeInstallationIconPayload';
  errors?: Maybe<Array<ChangeInstallationIconError>>;
  result?: Maybe<Result>;
};

export type ChangeInstallationNameError = InstallationError;

export type ChangeInstallationNameInput = {
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type ChangeInstallationNamePayload = {
  __typename?: 'ChangeInstallationNamePayload';
  errors?: Maybe<Array<ChangeInstallationNameError>>;
  result?: Maybe<Result>;
};

export type ChangeInstallationsOrderItemInput = {
  installationId: Scalars['UUID'];
  order: Scalars['Int'];
};

export type ChangeInstallationsOrderRequestInput = {
  orders: Array<ChangeInstallationsOrderItemInput>;
};

export type ChangeOnEventActionError = ChannelError;

export type ChangeOnEventActionInput = {
  channelId: Scalars['UUID'];
  onEventAction?: InputMaybe<NotificationSenderType>;
};

export type ChangeOnEventActionPayload = {
  __typename?: 'ChangeOnEventActionPayload';
  errors?: Maybe<Array<ChangeOnEventActionError>>;
  result?: Maybe<Result>;
};

export type ChangePreviewTariffError = InstallationAttachmentError | InstallationError;

export type ChangePreviewTariffInput = {
  installationId: Scalars['UUID'];
  previewTariff: TariffKindInternal;
};

export type ChangePreviewTariffPayload = {
  __typename?: 'ChangePreviewTariffPayload';
  errors?: Maybe<Array<ChangePreviewTariffError>>;
  result?: Maybe<Result>;
};

export type ChangeTimeZoneError = InstallationAttachmentError | InstallationError;

export type ChangeTimeZoneInput = {
  installationId: Scalars['UUID'];
  zone: Scalars['String'];
};

export type ChangeTimeZonePayload = {
  __typename?: 'ChangeTimeZonePayload';
  errors?: Maybe<Array<ChangeTimeZoneError>>;
  result?: Maybe<Result>;
};

export type ChangeUserNameError = UserServiceError;

export type ChangeUserNameInput = {
  firstName: Scalars['String'];
};

export type ChangeUserNamePayload = {
  __typename?: 'ChangeUserNamePayload';
  errors?: Maybe<Array<ChangeUserNameError>>;
  result?: Maybe<Result>;
};

export type ChangeUserRoleError = InvitationError;

export type ChangeUserRoleInput = {
  accessType: InstallationAccessType;
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type ChangeUserRolePayload = {
  __typename?: 'ChangeUserRolePayload';
  errors?: Maybe<Array<ChangeUserRoleError>>;
  result?: Maybe<Result>;
};

export type ChannelAction = {
  __typename?: 'ChannelAction';
  activityType: ActivityType;
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  order: Scalars['Int'];
  value: Scalars['String'];
};

export type ChannelActionFilterInput = {
  activityType?: InputMaybe<ActivityTypeOperationFilterInput>;
  and?: InputMaybe<Array<ChannelActionFilterInput>>;
  channelId?: InputMaybe<UuidOperationFilterInput>;
  channelType?: InputMaybe<ChannelTypeInternalOperationFilterInput>;
  or?: InputMaybe<Array<ChannelActionFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ChannelActionParameterInput = {
  activityType: ActivityType;
  value: Scalars['String'];
};

export type ChannelError = Error & {
  __typename?: 'ChannelError';
  error: ChannelErrorDictionary;
  message: Scalars['String'];
};

export enum ChannelErrorDictionary {
  ChannelNotFound = 'CHANNEL_NOT_FOUND',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION',
  WrongChannelType = 'WRONG_CHANNEL_TYPE'
}

export type ChannelInfoModel = {
  __typename?: 'ChannelInfoModel';
  channelId: Scalars['UUID'];
  channelNumber: Scalars['Int'];
  channelType: ChannelTypeInternal;
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};

export type ChannelPersonalizationInput = {
  gate?: InputMaybe<GateChannelPersonalizationInput>;
  noPersonalization?: InputMaybe<Scalars['Boolean']>;
};

export type ChannelStateBaseResponse = {
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
};

export enum ChannelTypeInternal {
  BinarySensor = 'BINARY_SENSOR',
  Blind = 'BLIND',
  Door = 'DOOR',
  Gate = 'GATE',
  GenericInput = 'GENERIC_INPUT',
  Hvac = 'HVAC',
  Light = 'LIGHT',
  Meter = 'METER',
  Optimizer = 'OPTIMIZER',
  Sensor = 'SENSOR',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN'
}

export type ChannelTypeInternalOperationFilterInput = {
  eq?: InputMaybe<ChannelTypeInternal>;
  in?: InputMaybe<Array<ChannelTypeInternal>>;
  neq?: InputMaybe<ChannelTypeInternal>;
  nin?: InputMaybe<Array<ChannelTypeInternal>>;
};

export type ChannelVisibilityDtoInput = {
  channelId: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
};

export type CloudActionConfigResponse = ActionConfigResponse & {
  __typename?: 'CloudActionConfigResponse';
  destination?: Maybe<BindingAddress>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
  offSignalActionId?: Maybe<Scalars['String']>;
  onSignalActionId?: Maybe<Scalars['String']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type Color = {
  __typename?: 'Color';
  blue: Scalars['Byte'];
  green: Scalars['Byte'];
  red: Scalars['Byte'];
};

export type ColorInput = {
  blue: Scalars['Byte'];
  green: Scalars['Byte'];
  red: Scalars['Byte'];
};

export type ComfortConfig = {
  __typename?: 'ComfortConfig';
  heaterPowerLimit: Scalars['Float'];
  relaysConfig: Array<RelayConfig>;
  tariff?: Maybe<Tariff>;
  tempMax: Scalars['Float'];
  tempMin: Scalars['Float'];
  voltageThreshold: Array<VoltageThreshold>;
};

export type ConfigurationTaintedPayload = {
  __typename?: 'ConfigurationTaintedPayload';
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  deviceId: Scalars['UUID'];
  failures: Array<Scalars['String']>;
  installationId: Scalars['UUID'];
};

export enum ControlModeInternal {
  DynamicPrice = 'DYNAMIC_PRICE',
  Threshold = 'THRESHOLD',
  Unknown = 'UNKNOWN'
}

export enum ControlSourceType {
  External = 'EXTERNAL',
  Trigger = 'TRIGGER',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type ControlledBy = {
  __typename?: 'ControlledBy';
  controlSource: ControlSourceType;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['NonNegativeInt']>;
};

export type CoordinatesDtoInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CorrelationResponse = {
  __typename?: 'CorrelationResponse';
  correlationId: Scalars['UUID'];
  publishStatus: PublishStatus;
};

export type CreateAdvancedActionRequestInput = {
  channels: Array<AdvancedActionChannelItemInput>;
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type CreateBasicActionRequestInput = {
  channels: Array<BasicActionChannelItemInput>;
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type CreateExalusInstallationPayloadInput = {
  pin: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type CreateExternalInstallationPayloadInput = {
  exalusInstallationPayload?: InputMaybe<CreateExalusInstallationPayloadInput>;
};

export type CreateGroupError = GroupError;

export type CreateGroupInput = {
  groupItems: Array<GroupItemRequestItemInput>;
  iconName?: Scalars['String'];
  installationId: Scalars['UUID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  errors?: Maybe<Array<CreateGroupError>>;
  idResponse?: Maybe<IdResponse>;
};

export type CreateInstallationRequestInput = {
  coordinates?: InputMaybe<CoordinatesDtoInput>;
  externalInstallationPayload: CreateExternalInstallationPayloadInput;
  hexColor: Scalars['String'];
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
  integrationType: IntegrationType;
  name: Scalars['String'];
  timeZone: Scalars['String'];
};

export type CreatePriceAndTimeTriggerError = TriggerError;

export type CreatePriceAndTimeTriggerInput = {
  installationId: Scalars['UUID'];
  name: Scalars['String'];
  trigger: CreatePriceAndTimeTriggerRequestInput;
};

export type CreatePriceAndTimeTriggerPayload = {
  __typename?: 'CreatePriceAndTimeTriggerPayload';
  errors?: Maybe<Array<CreatePriceAndTimeTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type CreatePriceAndTimeTriggerRequestInput = {
  actions: Array<TriggerActionRequestInput>;
  onFailureMode: TriggerOnFailureMode;
  priceAndTimeCondition: TriggerPriceAndTimeConditionRequestInput;
  stateConditions: Array<TriggerStateConditionRequestInput>;
  triggerId: Scalars['UUID'];
};

export type CreateStateTriggerError = TriggerError;

export type CreateStateTriggerInput = {
  installationId: Scalars['UUID'];
  name: Scalars['String'];
  trigger: CreateStateTriggerRequestInput;
};

export type CreateStateTriggerPayload = {
  __typename?: 'CreateStateTriggerPayload';
  errors?: Maybe<Array<CreateStateTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type CreateStateTriggerRequestInput = {
  actions: Array<TriggerActionRequestInput>;
  onFailureMode: TriggerOnFailureMode;
  stateConditions: Array<TriggerStateConditionRequestInput>;
  triggerId: Scalars['UUID'];
};

export type CreateTimeTriggerError = TriggerError;

export type CreateTimeTriggerInput = {
  installationId: Scalars['UUID'];
  name: Scalars['String'];
  trigger: CreateTimeTriggerRequestInput;
};

export type CreateTimeTriggerPayload = {
  __typename?: 'CreateTimeTriggerPayload';
  errors?: Maybe<Array<CreateTimeTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type CreateTimeTriggerRequestInput = {
  actions: Array<TriggerActionRequestInput>;
  onFailureMode: TriggerOnFailureMode;
  stateConditions: Array<TriggerStateConditionRequestInput>;
  timeCondition: TriggerTimeConditionRequestInput;
  triggerId: Scalars['UUID'];
};

export type CurrentInstallation = {
  __typename?: 'CurrentInstallation';
  accessType: InstallationAccessType;
  brokerUrl: Scalars['String'];
  cacheResponses?: Maybe<CacheResponses>;
  hexColor: Scalars['String'];
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
  integrationType: IntegrationType;
  name: Scalars['String'];
  payload?: Maybe<InstallationModelResponse>;
  userId: Scalars['UUID'];
};

export enum DashboardItemType {
  Action = 'ACTION',
  Central = 'CENTRAL',
  Channel = 'CHANNEL'
}

export type DashboardItemTypeOperationFilterInput = {
  eq?: InputMaybe<DashboardItemType>;
  in?: InputMaybe<Array<DashboardItemType>>;
  neq?: InputMaybe<DashboardItemType>;
  nin?: InputMaybe<Array<DashboardItemType>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DayEntryResponse = {
  __typename?: 'DayEntryResponse';
  bucketInfos: Array<BucketInfo>;
  day: Scalars['String'];
  records: Array<PriceEntryResponse>;
};

export enum DayOfWeekInternal {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateTriggerError = TriggerError;

export type DeactivateTriggerInput = {
  installationId: Scalars['UUID'];
  triggerId: Scalars['UUID'];
};

export type DeactivateTriggerPayload = {
  __typename?: 'DeactivateTriggerPayload';
  errors?: Maybe<Array<DeactivateTriggerError>>;
  result?: Maybe<Result>;
};

export type DefaultActionConfigResponse = ActionConfigResponse & {
  __typename?: 'DefaultActionConfigResponse';
  destination?: Maybe<BindingAddress>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
};

export type DefaultMeterTypeMeasurementPayload = {
  __typename?: 'DefaultMeterTypeMeasurementPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
};

export type DeleteActionError = ActionError;

export type DeleteActionInput = {
  actionId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export type DeleteActionPayload = {
  __typename?: 'DeleteActionPayload';
  errors?: Maybe<Array<DeleteActionError>>;
  result?: Maybe<Result>;
};

export type DeleteInstallationError = InstallationError;

export type DeleteInstallationInput = {
  installationId: Scalars['UUID'];
};

export type DeleteInstallationPayload = {
  __typename?: 'DeleteInstallationPayload';
  errors?: Maybe<Array<DeleteInstallationError>>;
  result?: Maybe<Result>;
};

export type DeleteTriggerError = TriggerError;

export type DeleteTriggerInput = {
  installationId: Scalars['UUID'];
  triggerId: Scalars['UUID'];
};

export type DeleteTriggerPayload = {
  __typename?: 'DeleteTriggerPayload';
  errors?: Maybe<Array<DeleteTriggerError>>;
  result?: Maybe<Result>;
};

export type DependantChannelResponse = {
  __typename?: 'DependantChannelResponse';
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  index: Scalars['Int'];
};

export type DeviceConnectedToSsidUpdatedPayload = {
  __typename?: 'DeviceConnectedToSsidUpdatedPayload';
  connectedToSsid: Scalars['String'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export enum DeviceConnectionState {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Recovery = 'RECOVERY'
}

export type DeviceConnectionStateChangePayload = {
  __typename?: 'DeviceConnectionStateChangePayload';
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
};

export type DeviceError = Error & {
  __typename?: 'DeviceError';
  error: DeviceErrorDictionary;
  message: Scalars['String'];
};

export enum DeviceErrorDictionary {
  DeviceDoesNotExist = 'DEVICE_DOES_NOT_EXIST',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION'
}

export type DeviceErrorPayload = {
  __typename?: 'DeviceErrorPayload';
  code: Scalars['String'];
  description: Scalars['String'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export type DeviceFirmwareUpdatedPayload = {
  __typename?: 'DeviceFirmwareUpdatedPayload';
  currentFirmwareVersion: Scalars['String'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export enum DeviceMode {
  Negotation = 'NEGOTATION',
  Recovery = 'RECOVERY',
  Workload = 'WORKLOAD'
}

export type DeviceNameChangedPayload = {
  __typename?: 'DeviceNameChangedPayload';
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type DeviceStateModel = {
  __typename?: 'DeviceStateModel';
  channelInfos?: Maybe<Array<Maybe<ChannelInfoModel>>>;
  connectedToSsid: Scalars['String'];
  currentFirmwareVersion: Scalars['String'];
  deviceId: Scalars['UUID'];
  isUpdateAvailable?: Maybe<Scalars['Boolean']>;
  lastConnectedAtUtc: Scalars['DateTime'];
  macAddress: Scalars['String'];
  model: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  newestFirmwareVersion: Scalars['String'];
  registeredAtUtc: Scalars['DateTime'];
  timeZone: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type DeviceWifiNetworkPayload = {
  __typename?: 'DeviceWifiNetworkPayload';
  auth: Scalars['String'];
  channel: Scalars['Int'];
  connected: Scalars['Boolean'];
  remembered: Scalars['Boolean'];
  rssi: Scalars['Int'];
  ssid: Scalars['String'];
};

export type DeviceWifiNetworksReceivedPayload = {
  __typename?: 'DeviceWifiNetworksReceivedPayload';
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  wifiNetworks: Array<DeviceWifiNetworkPayload>;
};

export type DynamicPricesWithBuckets = {
  __typename?: 'DynamicPricesWithBuckets';
  bucketInfos: Array<BucketInfo>;
  days: Array<DayEntryResponse>;
};

export type EcoConfig = {
  __typename?: 'EcoConfig';
  relaysConfig: Array<RelayConfig>;
  tempMax: Scalars['Float'];
  voltageThreshold: Array<VoltageThreshold>;
};

export type EditActionChannelItemInput = {
  channelId: Scalars['UUID'];
  channelType: ChannelTypeInternal;
  order: Scalars['Int'];
  parameter?: InputMaybe<ChannelActionParameterInput>;
};

export type EditActionError = ActionError;

export type EditActionInput = {
  channels: Array<EditActionChannelItemInput>;
  iconName: Scalars['String'];
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type EditActionPayload = {
  __typename?: 'EditActionPayload';
  errors?: Maybe<Array<EditActionError>>;
  idResponse?: Maybe<IdResponse>;
};

export type EditPriceAndTimeTriggerError = TriggerError;

export type EditPriceAndTimeTriggerInput = {
  installationId: Scalars['UUID'];
  trigger: CreatePriceAndTimeTriggerRequestInput;
};

export type EditPriceAndTimeTriggerPayload = {
  __typename?: 'EditPriceAndTimeTriggerPayload';
  errors?: Maybe<Array<EditPriceAndTimeTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type EditStateTriggerError = TriggerError;

export type EditStateTriggerInput = {
  installationId: Scalars['UUID'];
  trigger: CreateStateTriggerRequestInput;
};

export type EditStateTriggerPayload = {
  __typename?: 'EditStateTriggerPayload';
  errors?: Maybe<Array<EditStateTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type EditTimeTriggerError = TriggerError;

export type EditTimeTriggerInput = {
  installationId: Scalars['UUID'];
  trigger: CreateTimeTriggerRequestInput;
};

export type EditTimeTriggerPayload = {
  __typename?: 'EditTimeTriggerPayload';
  errors?: Maybe<Array<EditTimeTriggerError>>;
  idResponse?: Maybe<IdResponse>;
};

export type EditUserChannelError = ChannelError;

export type EditUserChannelInput = {
  alias: Scalars['String'];
  channelId: Scalars['UUID'];
  iconName: Scalars['String'];
  isVisible: Scalars['Boolean'];
  personalization?: InputMaybe<ChannelPersonalizationInput>;
};

export type EditUserChannelPayload = {
  __typename?: 'EditUserChannelPayload';
  errors?: Maybe<Array<EditUserChannelError>>;
  result?: Maybe<Result>;
};

export type Error = {
  message: Scalars['String'];
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  description: Scalars['String'];
  errorCode: Scalars['String'];
};

export type EventingRuleState = {
  __typename?: 'EventingRuleState';
  action: TargetAction;
  controlMode: ControlModeInternal;
  enabled: Scalars['Boolean'];
  priceEvent?: Maybe<PriceEventState>;
  thresholdEvent?: Maybe<ThresholdEventState>;
};

export type ExalusInstallationPayload = ExternalInstallationPayload & {
  __typename?: 'ExalusInstallationPayload';
  installationId: Scalars['UUID'];
  pin: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type ExternalInstallationFilterInput = {
  and?: InputMaybe<Array<ExternalInstallationFilterInput>>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ExternalInstallationFilterInput>>;
  payload?: InputMaybe<ExternalInstallationPayloadFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type ExternalInstallationPayload = {
  installationId: Scalars['UUID'];
};

export type ExternalInstallationPayloadFilterInput = {
  and?: InputMaybe<Array<ExternalInstallationPayloadFilterInput>>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ExternalInstallationPayloadFilterInput>>;
};

export type ExternalInstallationPayloadSortInput = {
  installationId?: InputMaybe<SortEnumType>;
};

export type ExternalInstallationSortInput = {
  installationId?: InputMaybe<SortEnumType>;
  payload?: InputMaybe<ExternalInstallationPayloadSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type FavouritePosition = {
  favouritePositionType: FavouritePositionType;
};

export type FavouritePositionFilterInput = {
  and?: InputMaybe<Array<FavouritePositionFilterInput>>;
  favouritePositionType?: InputMaybe<FavouritePositionTypeOperationFilterInput>;
  or?: InputMaybe<Array<FavouritePositionFilterInput>>;
};

export type FavouritePositionItemInput = {
  brightness?: InputMaybe<Scalars['Float']>;
  color?: InputMaybe<ColorInput>;
  favouritePositionType: FavouritePositionType;
  value?: InputMaybe<Scalars['Float']>;
};

export enum FavouritePositionType {
  Lights = 'LIGHTS',
  Position = 'POSITION',
  Switch = 'SWITCH'
}

export type FavouritePositionTypeOperationFilterInput = {
  eq?: InputMaybe<FavouritePositionType>;
  in?: InputMaybe<Array<FavouritePositionType>>;
  neq?: InputMaybe<FavouritePositionType>;
  nin?: InputMaybe<Array<FavouritePositionType>>;
};

export type FavouritesItemRequestInput = {
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  itemType: DashboardItemType;
};

export type FeaturesByVersionMap = {
  __typename?: 'FeaturesByVersionMap';
  key: Scalars['String'];
  versionedFeatures: Array<VersionedFeatures>;
};

export type FloatValidation = {
  __typename?: 'FloatValidation';
  max: Scalars['Float'];
  min: Scalars['Float'];
  step: Scalars['Float'];
};

export type FullSelfConsumptionConfig = {
  __typename?: 'FullSelfConsumptionConfig';
  heaterPowerLimit: Scalars['Float'];
  relaysConfig: Array<RelayConfig>;
  tariff?: Maybe<Tariff>;
  tempMax: Scalars['Float'];
  tempMin: Scalars['Float'];
  tempMinEnabled: Scalars['Boolean'];
  tempSelfConsumption: Scalars['Float'];
  voltageThreshold: Array<VoltageThreshold>;
  workingHours: WorkingHours;
};

export type GateActionConfigResponse = ActionConfigResponse & {
  __typename?: 'GateActionConfigResponse';
  destination?: Maybe<BindingAddress>;
  dir?: Maybe<GateDirectionInternal>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  slot: GateSupportedSlotsInternal;
};

export type GateCalibrateStatusChangePayload = {
  __typename?: 'GateCalibrateStatusChangePayload';
  channelId: Scalars['UUID'];
  closingMilliseconds: Scalars['Long'];
  deviceId: Scalars['UUID'];
  error?: Maybe<GateChannelCalibrateErrorInternal>;
  installationId: Scalars['UUID'];
  openingMilliseconds: Scalars['Long'];
  progress?: Maybe<Scalars['Int']>;
  status: GateCalibrateStatusTypePayload;
};

export enum GateCalibrateStatusTypePayload {
  Data = 'DATA',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Started = 'STARTED'
}

export type GateChannelAlertConfigResponse = {
  __typename?: 'GateChannelAlertConfigResponse';
  barrierAlertEnabled: Scalars['Boolean'];
  externalSourceTriggeredAlertEnabled: Scalars['Boolean'];
  misdirectionAlertEnabled: Scalars['Boolean'];
  openedIntervalToNotifyInMs?: Maybe<Scalars['Int']>;
};

export enum GateChannelCalibrateErrorInternal {
  InterruptedByTheUser = 'INTERRUPTED_BY_THE_USER',
  Timeout = 'TIMEOUT',
  Unknown = 'UNKNOWN',
  WrongPosition = 'WRONG_POSITION'
}

export type GateChannelCalibrateStateResponse = {
  __typename?: 'GateChannelCalibrateStateResponse';
  closingMilliseconds: Scalars['NonNegativeInt'];
  error?: Maybe<GateChannelCalibrateErrorInternal>;
  openingMilliseconds: Scalars['NonNegativeInt'];
  progress?: Maybe<Scalars['NonNegativeInt']>;
  started?: Maybe<Scalars['Boolean']>;
};

export type GateChannelPersonalizationInput = {
  isDailyModeVisible: Scalars['Boolean'];
  isPartialControlModeVisible: Scalars['Boolean'];
  isQuickControl: Scalars['Boolean'];
  isVentVisible: Scalars['Boolean'];
};

export type GateChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'GateChannelStateResponse';
  alertConfig?: Maybe<GateChannelAlertConfigResponse>;
  calibrateState?: Maybe<GateChannelCalibrateStateResponse>;
  channelId: Scalars['UUID'];
  dailyModeStatus?: Maybe<Scalars['Boolean']>;
  dependantChannels: Array<DependantChannelResponse>;
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  direction: GateStateDirectionInternal;
  gateKind?: Maybe<GateKindInternal>;
  gateMode?: Maybe<GateModeInternal>;
  history?: Maybe<GateResponseOfGateHistory>;
  isNegativeOutput: Scalars['Boolean'];
  lockStatus?: Maybe<GateLockStateInternal>;
  partialControlModeStatus?: Maybe<Scalars['Boolean']>;
  partialSbsTimeInMs?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['NonNegativeInt']>;
  sbsSignalTimeInMs?: Maybe<Scalars['Int']>;
  supportedGateFeatures: Array<GateFeatureTypeInternal>;
  supportedSlots: Array<GateSupportedSlotsInternal>;
  tiltTimeInMs?: Maybe<Scalars['Int']>;
};


export type GateChannelStateResponseHistoryArgs = {
  count?: InputMaybe<Scalars['NonNegativeInt']>;
  offset?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type GateConfigurationChangePayload = {
  __typename?: 'GateConfigurationChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  supportedGateFeatures: Array<GateFeatureTypeInternal>;
};

export enum GateDirectionInternal {
  Close = 'CLOSE',
  Open = 'OPEN',
  Stop = 'STOP',
  Unknown = 'UNKNOWN'
}

export enum GateEventTypeInternal {
  Error = 'ERROR',
  InvokeMultiBox = 'INVOKE_MULTI_BOX',
  LockReport = 'LOCK_REPORT',
  Sbs = 'SBS',
  SetClose = 'SET_CLOSE',
  SetDailyModeOff = 'SET_DAILY_MODE_OFF',
  SetDailyModeOn = 'SET_DAILY_MODE_ON',
  SetOpen = 'SET_OPEN',
  SetPartialControlModeOff = 'SET_PARTIAL_CONTROL_MODE_OFF',
  SetPartialControlModeOn = 'SET_PARTIAL_CONTROL_MODE_ON',
  SetPartialOpen = 'SET_PARTIAL_OPEN',
  SetPosition = 'SET_POSITION',
  SetStop = 'SET_STOP',
  SetTilt = 'SET_TILT',
  Stop = 'STOP',
  Unknown = 'UNKNOWN',
  UnlockReport = 'UNLOCK_REPORT'
}

export enum GateFeatureTypeInternal {
  Calibrate = 'CALIBRATE',
  DailyMode = 'DAILY_MODE',
  ElectricStrike = 'ELECTRIC_STRIKE',
  LockReporting = 'LOCK_REPORTING',
  PartialControlMode = 'PARTIAL_CONTROL_MODE',
  SetDir = 'SET_DIR',
  SetNegativeOutput = 'SET_NEGATIVE_OUTPUT',
  SetPos = 'SET_POS',
  SetTiltTime = 'SET_TILT_TIME',
  StepByStep = 'STEP_BY_STEP',
  Tilt = 'TILT',
  Unknown = 'UNKNOWN'
}

export type GateHistory = {
  __typename?: 'GateHistory';
  entries: Array<GateHistoryEntry>;
  totalCount: Scalars['Int'];
};

export type GateHistoryEntry = {
  __typename?: 'GateHistoryEntry';
  controlledBy: ControlledBy;
  eventType: GateEventTypeInternal;
  id: Scalars['Int'];
  occuredAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Int']>;
};

export enum GateKindInternal {
  Barrier = 'BARRIER',
  Doors = 'DOORS',
  DoubleLeaf = 'DOUBLE_LEAF',
  Industrial = 'INDUSTRIAL',
  MultiBox = 'MULTI_BOX',
  OnePieceDoor = 'ONE_PIECE_DOOR',
  RollUp = 'ROLL_UP',
  Sectional = 'SECTIONAL',
  SideOpeningDoor = 'SIDE_OPENING_DOOR',
  Sliding = 'SLIDING',
  Unknown = 'UNKNOWN',
  Wicket = 'WICKET'
}

export enum GateLockStateInternal {
  DailyModeAndDoorClosed = 'DAILY_MODE_AND_DOOR_CLOSED',
  Locked = 'LOCKED',
  Opened = 'OPENED',
  Unknown = 'UNKNOWN'
}

export enum GateModeInternal {
  RollUp = 'ROLL_UP',
  StepByStep = 'STEP_BY_STEP',
  Unknown = 'UNKNOWN'
}

export type GatePersonalization = UserChannelPersonalization & {
  __typename?: 'GatePersonalization';
  isDailyModeVisible: Scalars['Boolean'];
  isPartialControlModeVisible: Scalars['Boolean'];
  isQuickControl: Scalars['Boolean'];
  isVentVisible: Scalars['Boolean'];
  onEventAction?: Maybe<NotificationSenderType>;
  type: ChannelTypeInternal;
};

export type GatePositionChangePayload = {
  __typename?: 'GatePositionChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  direction: GateStateDirectionInternal;
  installationId: Scalars['UUID'];
  position: Scalars['Int'];
  predictedTimeInMs?: Maybe<Scalars['Int']>;
  targetPosition?: Maybe<Scalars['Int']>;
};

export type GateResponseOfGateHistory = {
  __typename?: 'GateResponseOfGateHistory';
  data?: Maybe<GateHistory>;
  error?: Maybe<ErrorResponse>;
};

export enum GateStateDirectionInternal {
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Unknown = 'UNKNOWN'
}

export type GateStatusChangedPayload = {
  __typename?: 'GateStatusChangedPayload';
  channelId: Scalars['UUID'];
  dailyModeStatus?: Maybe<Scalars['Boolean']>;
  deviceId: Scalars['UUID'];
  direction: GateStateDirectionInternal;
  installationId: Scalars['UUID'];
  lockStatus?: Maybe<GateLockStateInternal>;
  partialControlModeStatus?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  predictedTimeInMs?: Maybe<Scalars['Int']>;
  targetPosition?: Maybe<Scalars['Int']>;
};

export enum GateSupportedSlotsInternal {
  Advanced = 'ADVANCED',
  Button = 'BUTTON',
  DoorDailyFuncButton = 'DOOR_DAILY_FUNC_BUTTON',
  LimitClose = 'LIMIT_CLOSE',
  LimitOpen = 'LIMIT_OPEN',
  LockSensor = 'LOCK_SENSOR',
  MultiLimitSwitch = 'MULTI_LIMIT_SWITCH',
  OpticBarrier = 'OPTIC_BARRIER',
  Unknown = 'UNKNOWN'
}

export enum GenericInputBistableModeInternal {
  Normal = 'NORMAL',
  TwoWay = 'TWO_WAY'
}

export type GenericInputChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'GenericInputChannelStateResponse';
  actionBindings: Array<ActionConfigResponse>;
  areCloudActionsSupported: Scalars['Boolean'];
  bistableMode?: Maybe<GenericInputBistableModeInternal>;
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  genericInputType: GenericInputTypeInternal;
  monostableMode?: Maybe<GenericInputMonostableModeInternal>;
};

export enum GenericInputMonostableModeInternal {
  Normal = 'NORMAL',
  Reversed = 'REVERSED'
}

export type GenericInputStateChangePayload = {
  __typename?: 'GenericInputStateChangePayload';
  bistableMode?: Maybe<GenericInputBistableModeInternal>;
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  genericInputType: GenericInputTypeInternal;
  installationId: Scalars['UUID'];
  monostableMode?: Maybe<GenericInputMonostableModeInternal>;
};

export type GenericInputStatusChangedPayload = {
  __typename?: 'GenericInputStatusChangedPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  value: Scalars['Boolean'];
};

export enum GenericInputTypeInternal {
  Bistable = 'BISTABLE',
  Monostable = 'MONOSTABLE',
  Unknown = 'UNKNOWN'
}

export type GetAggregateMeasurementsRequestInput = {
  aggregateVectorRequestItems: Array<AggregateVectorMeasurementRequestItemInput>;
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  indices: Array<Scalars['Int']>;
  tariffs?: InputMaybe<Array<TariffKindInternal>>;
};

export type GetAggregateVectorMeasurementResponse = {
  __typename?: 'GetAggregateVectorMeasurementResponse';
  aggregateVectorMeasurements: Array<AggregateVectorMeasurementResponseItem>;
};

export type GetCommonMeasurementsRequestInput = {
  advancedCommonMeasurements?: Scalars['Boolean'];
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  indices: Array<Scalars['Int']>;
  kind: MeasurementChannelKind;
  periods?: PeriodWeeklyPeriod;
};

export type GetCurrentMeasurementResponse = {
  __typename?: 'GetCurrentMeasurementResponse';
  scalarMeasurements: Array<ScalarMeasurementResponseItem>;
  vectorMeasurements: Array<VectorMeasurementResponseItem>;
};

export type GetCurrentMeasurementsRequestInput = {
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  indices: Array<Scalars['Int']>;
  kind: MeasurementChannelKind;
  scalarParameterTypes: Array<Scalars['Int']>;
  vectorParameterTypes: Array<Scalars['Int']>;
};

export type GetPersistedAggregateMeasurementsRequestInput = {
  aggregateVectorRequestItems: Array<AggregateVectorMeasurementRequestItemInput>;
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  from: Scalars['DateTime'];
  indices: Array<Scalars['Int']>;
  tariffs?: InputMaybe<Array<TariffKindInternal>>;
  to: Scalars['DateTime'];
};

export type GetPersistedVectorMeasurementResponse = {
  __typename?: 'GetPersistedVectorMeasurementResponse';
  from: Scalars['DateTime'];
  isSuccessfulFromDevice: Scalars['Boolean'];
  isSuccessfulFromStorage: Scalars['Boolean'];
  items: Array<MultiParameterAggregatedItem>;
  oldestAtUtc?: Maybe<Scalars['DateTime']>;
  to: Scalars['DateTime'];
};

export type Group = {
  __typename?: 'Group';
  groupItems: Array<GroupItem>;
  iconName: Scalars['String'];
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  isDefaultGroup: Scalars['Boolean'];
  isPublicGroup: Scalars['Boolean'];
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  userGroups: Array<UserGroup>;
};

export type GroupError = Error & {
  __typename?: 'GroupError';
  error: GroupErrorDictionary;
  message: Scalars['String'];
};

export enum GroupErrorDictionary {
  GroupNameAlreadyTaken = 'GROUP_NAME_ALREADY_TAKEN',
  GroupNotFound = 'GROUP_NOT_FOUND',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION',
  UserInstallationDoesNotExist = 'USER_INSTALLATION_DOES_NOT_EXIST'
}

export type GroupFilterInput = {
  and?: InputMaybe<Array<GroupFilterInput>>;
  groupItems?: InputMaybe<ListFilterInputTypeOfGroupItemFilterInput>;
  iconName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  isDefaultGroup?: InputMaybe<BooleanOperationFilterInput>;
  isPublicGroup?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GroupFilterInput>>;
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  userGroups?: InputMaybe<ListFilterInputTypeOfUserGroupFilterInput>;
};

export type GroupItem = {
  __typename?: 'GroupItem';
  group: Group;
  groupId: Scalars['UUID'];
  id: Scalars['UUID'];
  payload?: Maybe<GroupItemPayloadUnion>;
  resourceType: DashboardItemType;
};

export type GroupItemFilterInput = {
  and?: InputMaybe<Array<GroupItemFilterInput>>;
  group?: InputMaybe<GroupFilterInput>;
  groupId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<GroupItemFilterInput>>;
  resourceType?: InputMaybe<DashboardItemTypeOperationFilterInput>;
};

export type GroupItemPayloadUnion = UserAction | UserChannel;

export type GroupItemRequestItemInput = {
  itemId: Scalars['UUID'];
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardItemType;
};

export type GroupSortInput = {
  iconName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  isDefaultGroup?: InputMaybe<SortEnumType>;
  isPublicGroup?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
};

export type GroupWithOrderInput = {
  groupId: Scalars['UUID'];
  order: Scalars['Int'];
};

export enum HolidaysHandling {
  DoNotPerform = 'DO_NOT_PERFORM',
  Ignore = 'IGNORE',
  Perform = 'PERFORM'
}

export type HoursRange = {
  __typename?: 'HoursRange';
  from: Scalars['Int'];
  timeZoneKind: TimeZoneKindInternal;
  to: Scalars['Int'];
};

export type HvacRegulatorModeChangePayload = {
  __typename?: 'HvacRegulatorModeChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  regulatorMode: RegulatorModeTypeInternal;
};

export type HvacSensorFloorTemperatureChangePayload = {
  __typename?: 'HvacSensorFloorTemperatureChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  sensorFloorTemperature: Scalars['Float'];
};

export type HvacSensorHumidityChangePayload = {
  __typename?: 'HvacSensorHumidityChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  sensorHumidity: Scalars['Int'];
};

export type HvacSensorTemperatureChangePayload = {
  __typename?: 'HvacSensorTemperatureChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  sensorTemperature: Scalars['Float'];
};

export type HvacTargetTemperatureChangePayload = {
  __typename?: 'HvacTargetTemperatureChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  targetTemperature: Scalars['Float'];
};

export type HvacTemperatureUnitChangePayload = {
  __typename?: 'HvacTemperatureUnitChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  temperatureUnit: TemperatureUnitTypeInternal;
};

export type HvacWorkingModeChangePayload = {
  __typename?: 'HvacWorkingModeChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  workingMode: WorkingModeTypeInternal;
};

export type IMeasurementSubscriptionBaseResponse = MeasurementSubscriptionDeviceConnected | MeasurementSubscriptionDeviceDisconnected | MeasurementSubscriptionError | MeasurementSubscriptionResponse;

export type IdResponse = {
  __typename?: 'IdResponse';
  id: Scalars['UUID'];
};

export type Image = {
  __typename?: 'Image';
  extension: Scalars['String'];
  id: Scalars['UUID'];
  imageType: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export enum InputTriggerInternal {
  DoubleClick = 'DOUBLE_CLICK',
  SingleClick = 'SINGLE_CLICK'
}

export enum InstallationAccessType {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  Undefined = 'UNDEFINED',
  User = 'USER'
}

export type InstallationAccessTypeOperationFilterInput = {
  eq?: InputMaybe<InstallationAccessType>;
  in?: InputMaybe<Array<InstallationAccessType>>;
  neq?: InputMaybe<InstallationAccessType>;
  nin?: InputMaybe<Array<InstallationAccessType>>;
};

export type InstallationAttachmentError = Error & {
  __typename?: 'InstallationAttachmentError';
  installationId: Scalars['UUID'];
  message: Scalars['String'];
  validBrokerUrl?: Maybe<Scalars['String']>;
};

export type InstallationCoordinatesResponse = {
  __typename?: 'InstallationCoordinatesResponse';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type InstallationDetachPayload = {
  __typename?: 'InstallationDetachPayload';
  installationId: Scalars['UUID'];
  newBrokerUrl: Scalars['String'];
};

export type InstallationError = Error & {
  __typename?: 'InstallationError';
  error: InstallationErrorDictionary;
  message: Scalars['String'];
};

export enum InstallationErrorDictionary {
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION',
  UserInstallationDoesNotExist = 'USER_INSTALLATION_DOES_NOT_EXIST'
}

export type InstallationModelResponse = {
  __typename?: 'InstallationModelResponse';
  coordinates?: Maybe<InstallationCoordinatesResponse>;
  installationId: Scalars['UUID'];
  timeZone?: Maybe<Scalars['String']>;
};

export type InstallationPermissions = {
  __typename?: 'InstallationPermissions';
  installationId: Scalars['UUID'];
  userPermissions: Array<UserPermissionType>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type IntValidation = {
  __typename?: 'IntValidation';
  max: Scalars['Int'];
  min: Scalars['Int'];
  step: Scalars['Int'];
};

export enum IntegrationType {
  Exalus = 'EXALUS',
  Lavva = 'LAVVA',
  Undefined = 'UNDEFINED'
}

export type IntegrationTypeOperationFilterInput = {
  eq?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  neq?: InputMaybe<IntegrationType>;
  nin?: InputMaybe<Array<IntegrationType>>;
};

export type InternalMeasurementPayload = {
  __typename?: 'InternalMeasurementPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['UUID'];
  expirationDate: Scalars['DateTime'];
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  invitedUserEmail: Scalars['String'];
  invitedUserId?: Maybe<Scalars['UUID']>;
  sharingPayload: SharingPayload;
  status: InvitationStatus;
};

export type InvitationError = Error & {
  __typename?: 'InvitationError';
  error: InvitationErrorDictionary;
  message: Scalars['String'];
};

export enum InvitationErrorDictionary {
  InvitationDoesNotExist = 'INVITATION_DOES_NOT_EXIST',
  InvitationIsInNotPendingStatus = 'INVITATION_IS_IN_NOT_PENDING_STATUS',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION',
  UserDoesNotHavePermissionToAffectOwner = 'USER_DOES_NOT_HAVE_PERMISSION_TO_AFFECT_OWNER',
  UserInstallationDoesNotExist = 'USER_INSTALLATION_DOES_NOT_EXIST',
  UserIsNotInInstallation = 'USER_IS_NOT_IN_INSTALLATION'
}

export type InvitationFilterInput = {
  and?: InputMaybe<Array<InvitationFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdByUserId?: InputMaybe<UuidOperationFilterInput>;
  expirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  invitedUserEmail?: InputMaybe<StringOperationFilterInput>;
  invitedUserId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<InvitationFilterInput>>;
  sharingPayload?: InputMaybe<SharingPayloadFilterInput>;
  status?: InputMaybe<InvitationStatusOperationFilterInput>;
};

export type InvitationSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  createdByUserId?: InputMaybe<SortEnumType>;
  expirationDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  invitedUserEmail?: InputMaybe<SortEnumType>;
  invitedUserId?: InputMaybe<SortEnumType>;
  sharingPayload?: InputMaybe<SharingPayloadSortInput>;
  status?: InputMaybe<SortEnumType>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  TimedOut = 'TIMED_OUT'
}

export type InvitationStatusOperationFilterInput = {
  eq?: InputMaybe<InvitationStatus>;
  in?: InputMaybe<Array<InvitationStatus>>;
  neq?: InputMaybe<InvitationStatus>;
  nin?: InputMaybe<Array<InvitationStatus>>;
};

export type ItemComponentOfAggregateVectorParameterTypeInternal = {
  __typename?: 'ItemComponentOfAggregateVectorParameterTypeInternal';
  type: AggregateVectorParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemComponentOfOptimizerAggregateVectorParameterTypeInternal = {
  __typename?: 'ItemComponentOfOptimizerAggregateVectorParameterTypeInternal';
  type: OptimizerAggregateVectorParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemComponentOfOptimizerScalarParameterTypeInternal = {
  __typename?: 'ItemComponentOfOptimizerScalarParameterTypeInternal';
  type: OptimizerScalarParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemComponentOfOptimizerVectorParameterTypeInternal = {
  __typename?: 'ItemComponentOfOptimizerVectorParameterTypeInternal';
  type: OptimizerVectorParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemComponentOfScalarParameterTypeInternal = {
  __typename?: 'ItemComponentOfScalarParameterTypeInternal';
  type: ScalarParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemComponentOfVectorParameterTypeInternal = {
  __typename?: 'ItemComponentOfVectorParameterTypeInternal';
  type: VectorParameterTypeInternal;
  value: Scalars['Int'];
};

export type ItemWithOrderInput = {
  itemId: Scalars['UUID'];
  order: Scalars['Int'];
};

export type KeyedFloatValidation = {
  __typename?: 'KeyedFloatValidation';
  hysteresis: FloatValidation;
  key: SourceThresholdInternal;
  validation: FloatValidation;
};

export enum LearningScenarios {
  AddAction = 'ADD_ACTION',
  AddAutomation = 'ADD_AUTOMATION',
  AddCentralAction = 'ADD_CENTRAL_ACTION',
  AddDevice = 'ADD_DEVICE',
  None = 'NONE'
}

export type LightActionConfigResponse = ActionConfigResponse & {
  __typename?: 'LightActionConfigResponse';
  b?: Maybe<Scalars['Int']>;
  brightness?: Maybe<Scalars['Int']>;
  destination?: Maybe<BindingAddress>;
  g?: Maybe<Scalars['Int']>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
  r?: Maybe<Scalars['Int']>;
  setOnTimeValue?: Maybe<Scalars['Int']>;
  slot: LightSupportedSlotsInternal;
  temperature?: Maybe<Scalars['Int']>;
};

export type LightChannelColorStateResponse = {
  __typename?: 'LightChannelColorStateResponse';
  b?: Maybe<Scalars['NonNegativeInt']>;
  g?: Maybe<Scalars['NonNegativeInt']>;
  r?: Maybe<Scalars['NonNegativeInt']>;
};

export type LightChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'LightChannelStateResponse';
  brightness?: Maybe<Scalars['NonNegativeInt']>;
  channelId: Scalars['UUID'];
  color?: Maybe<LightChannelColorStateResponse>;
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  measuredBy?: Maybe<MeasuredBy>;
  supplyReturnBehavior: SupplyReturnBehaviorInternal;
  supportedModes: Array<LightModeTypeInternal>;
  supportedSlots: Array<LightSupportedSlotsInternal>;
  temperature?: Maybe<Scalars['NonNegativeInt']>;
  toggleValue: LightToggleValueInternal;
};

export type LightColorPayload = {
  __typename?: 'LightColorPayload';
  b: Scalars['Int'];
  g: Scalars['Int'];
  r: Scalars['Int'];
};

export enum LightModeTypeInternal {
  Brightness = 'BRIGHTNESS',
  Colors = 'COLORS',
  Temperature = 'TEMPERATURE',
  Toggle = 'TOGGLE',
  Unknown = 'UNKNOWN'
}

export type LightStateChangedPayload = {
  __typename?: 'LightStateChangedPayload';
  brightness?: Maybe<Scalars['Int']>;
  channelId: Scalars['UUID'];
  color?: Maybe<LightColorPayload>;
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  temperature?: Maybe<Scalars['Int']>;
  toggleValue: LightToggleValueInternal;
};

export type LightStateOnTimeChangePayload = {
  __typename?: 'LightStateOnTimeChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  timeInMilliseconds: Scalars['Int'];
};

export enum LightSupportedSlotsInternal {
  Advanced = 'ADVANCED',
  Toggle = 'TOGGLE',
  Unknown = 'UNKNOWN'
}

export enum LightToggleValueInternal {
  Off = 'OFF',
  On = 'ON',
  Unknown = 'UNKNOWN'
}

export type LightsFavourites = FavouritePosition & {
  __typename?: 'LightsFavourites';
  brightness: Scalars['Float'];
  color: Color;
  favouritePositionType: FavouritePositionType;
  value: Scalars['Float'];
};

export type ListFilterInputTypeOfChannelActionFilterInput = {
  all?: InputMaybe<ChannelActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ChannelActionFilterInput>;
  some?: InputMaybe<ChannelActionFilterInput>;
};

export type ListFilterInputTypeOfFavouritePositionFilterInput = {
  all?: InputMaybe<FavouritePositionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FavouritePositionFilterInput>;
  some?: InputMaybe<FavouritePositionFilterInput>;
};

export type ListFilterInputTypeOfGroupItemFilterInput = {
  all?: InputMaybe<GroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<GroupItemFilterInput>;
  some?: InputMaybe<GroupItemFilterInput>;
};

export type ListFilterInputTypeOfNotificationParamFilterInput = {
  all?: InputMaybe<NotificationParamFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<NotificationParamFilterInput>;
  some?: InputMaybe<NotificationParamFilterInput>;
};

export type ListFilterInputTypeOfSharedItemFilterInput = {
  all?: InputMaybe<SharedItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SharedItemFilterInput>;
  some?: InputMaybe<SharedItemFilterInput>;
};

export type ListFilterInputTypeOfUserGroupFilterInput = {
  all?: InputMaybe<UserGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserGroupFilterInput>;
  some?: InputMaybe<UserGroupFilterInput>;
};

export type ListFilterInputTypeOfUserGroupItemFilterInput = {
  all?: InputMaybe<UserGroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserGroupItemFilterInput>;
  some?: InputMaybe<UserGroupItemFilterInput>;
};

export enum LogLevel {
  Critical = 'CRITICAL',
  Debug = 'DEBUG',
  Error = 'ERROR',
  Information = 'INFORMATION',
  None = 'NONE',
  Trace = 'TRACE',
  Warning = 'WARNING'
}

export enum LoggingInfo {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  None = 'NONE',
  NotSupported = 'NOT_SUPPORTED',
  Supported = 'SUPPORTED'
}

export type MapItemOfOptimizerScalarParameterTypeInternalAndOptimizerVectorParameterTypeInternalAndOptimizerAggregateVectorParameterTypeInternal = {
  __typename?: 'MapItemOfOptimizerScalarParameterTypeInternalAndOptimizerVectorParameterTypeInternalAndOptimizerAggregateVectorParameterTypeInternal';
  aggregates: Array<ItemComponentOfOptimizerAggregateVectorParameterTypeInternal>;
  kind: MeasurementChannelKind;
  scalars: Array<ItemComponentOfOptimizerScalarParameterTypeInternal>;
  vectors: Array<ItemComponentOfOptimizerVectorParameterTypeInternal>;
};

export type MapItemOfScalarParameterTypeInternalAndVectorParameterTypeInternalAndAggregateVectorParameterTypeInternal = {
  __typename?: 'MapItemOfScalarParameterTypeInternalAndVectorParameterTypeInternalAndAggregateVectorParameterTypeInternal';
  aggregates: Array<ItemComponentOfAggregateVectorParameterTypeInternal>;
  kind: MeasurementChannelKind;
  scalars: Array<ItemComponentOfScalarParameterTypeInternal>;
  vectors: Array<ItemComponentOfVectorParameterTypeInternal>;
};

export type MarkLearningScenarioAsViewedError = UserProfileError;

export type MarkLearningScenarioAsViewedInput = {
  learningScenario: LearningScenarios;
};

export type MarkLearningScenarioAsViewedPayload = {
  __typename?: 'MarkLearningScenarioAsViewedPayload';
  errors?: Maybe<Array<MarkLearningScenarioAsViewedError>>;
  result?: Maybe<Result>;
};

export type Me = {
  __typename?: 'Me';
  permissions?: Maybe<Array<Maybe<InstallationPermissions>>>;
  profile?: Maybe<UserResponse>;
  profileImage?: Maybe<Image>;
};

export type MeasuredBy = {
  __typename?: 'MeasuredBy';
  meterChannelId: Scalars['UUID'];
  phase: Scalars['Int'];
};

export type MeasuredChannelResponse = {
  __typename?: 'MeasuredChannelResponse';
  channelId: Scalars['UUID'];
  phase: Scalars['Int'];
};

export enum MeasurementChannelKind {
  Meter = 'METER',
  Optimizer = 'OPTIMIZER',
  Unknown = 'UNKNOWN'
}

export enum MeasurementDataRangeInternal {
  InDays = 'IN_DAYS',
  InHours = 'IN_HOURS',
  InMonths = 'IN_MONTHS',
  InYears = 'IN_YEARS',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}

export type MeasurementMap = {
  __typename?: 'MeasurementMap';
  cacheInfo?: Maybe<CacheInfo>;
  meter: MapItemOfScalarParameterTypeInternalAndVectorParameterTypeInternalAndAggregateVectorParameterTypeInternal;
  optimizer: MapItemOfOptimizerScalarParameterTypeInternalAndOptimizerVectorParameterTypeInternalAndOptimizerAggregateVectorParameterTypeInternal;
};

export type MeasurementPayload = DefaultMeterTypeMeasurementPayload | InternalMeasurementPayload | StandaloneMeasurementPayload;

export type MeasurementResponseOfGetAggregateVectorMeasurementResponse = {
  __typename?: 'MeasurementResponseOfGetAggregateVectorMeasurementResponse';
  data?: Maybe<GetAggregateVectorMeasurementResponse>;
  error?: Maybe<ErrorResponse>;
};

export type MeasurementResponseOfGetCurrentMeasurementResponse = {
  __typename?: 'MeasurementResponseOfGetCurrentMeasurementResponse';
  data?: Maybe<GetCurrentMeasurementResponse>;
  error?: Maybe<ErrorResponse>;
};

export type MeasurementResponseOfGetPersistedVectorMeasurementResponse = {
  __typename?: 'MeasurementResponseOfGetPersistedVectorMeasurementResponse';
  data?: Maybe<GetPersistedVectorMeasurementResponse>;
  error?: Maybe<ErrorResponse>;
};

export type MeasurementSubResponse = {
  __typename?: 'MeasurementSubResponse';
  data: IMeasurementSubscriptionBaseResponse;
};

export type MeasurementSubscriptionDeviceConnected = {
  __typename?: 'MeasurementSubscriptionDeviceConnected';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  unixTimestamp: Scalars['Long'];
};

export type MeasurementSubscriptionDeviceDisconnected = {
  __typename?: 'MeasurementSubscriptionDeviceDisconnected';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  unixTimestamp: Scalars['Long'];
};

export type MeasurementSubscriptionError = {
  __typename?: 'MeasurementSubscriptionError';
  description: Scalars['String'];
  errorCode: Scalars['String'];
  unixTimestamp: Scalars['Long'];
};

export type MeasurementSubscriptionResponse = {
  __typename?: 'MeasurementSubscriptionResponse';
  scalarMeasurements: Array<ScalarMeasurementResponseItem>;
  unixTimestamp: Scalars['Long'];
  vectorMeasurements: Array<VectorMeasurementResponseItem>;
};

export type MeterChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'MeterChannelStateResponse';
  ampTransformers: AmpTransformersInternal;
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  effectiveSupportedAggregateVectorParameters: Array<Scalars['Int']>;
  eventing?: Maybe<MeterEventingState>;
  measuredChannels: Array<MeasuredChannelResponse>;
  meterPurpose: MeterPurposeInternal;
  meterType: MeterTypeInternal;
  originYear: Scalars['Int'];
  parentMeterId?: Maybe<Scalars['UUID']>;
  payload?: Maybe<MeasurementPayload>;
  supportedAggregateVectorParameters: Array<Scalars['Int']>;
  supportedScalarParameters: Array<Scalars['Int']>;
  supportedVectorParameters: Array<Scalars['Int']>;
  tariff?: Maybe<MeterTariffConfig>;
  validationRules: Array<KeyedFloatValidation>;
};

export type MeterEventingState = {
  __typename?: 'MeterEventingState';
  rules: Array<EventingRuleState>;
  supportedControlModes: Array<ControlModeInternal>;
  supportedRelaysIndices: Array<Scalars['Int']>;
  supportedSourceThresholds: Array<SourceThresholdInternal>;
};

export type MeterHoursRange = {
  __typename?: 'MeterHoursRange';
  from: Scalars['Int'];
  pricingTier: Scalars['Int'];
  timeZoneKind: TimeZoneKindInternal;
  to: Scalars['Int'];
};

export enum MeterPurposeInternal {
  Consumption = 'CONSUMPTION',
  EnergyStorage = 'ENERGY_STORAGE',
  Main = 'MAIN',
  Pv = 'PV',
  Unknown = 'UNKNOWN'
}

export type MeterSharedChannelSettings = SharedChannelSettings & {
  __typename?: 'MeterSharedChannelSettings';
  id: Scalars['UUID'];
  tariffConfigurations: Array<TariffConfiguration>;
};

export type MeterTariffConfig = {
  __typename?: 'MeterTariffConfig';
  hoursRanges: Array<MeterHoursRange>;
  ignoreSummerTimeChanges: Scalars['Boolean'];
  kind: TariffKindInternal;
  wholeHolidaysCheaper: Scalars['Boolean'];
  wholeWeekendCheaper: Scalars['Boolean'];
};

export enum MeterTypeInternal {
  Internal = 'INTERNAL',
  Standalone = 'STANDALONE',
  Unknown = 'UNKNOWN'
}

export type ModifyGroupItemInMultipleGroupsError = GroupError;

export type ModifyGroupItemInMultipleGroupsInput = {
  groupIdsToAdd: Array<Scalars['UUID']>;
  groupIdsToRemove: Array<Scalars['UUID']>;
  installationId: Scalars['UUID'];
  itemId: Scalars['UUID'];
  itemType: DashboardItemType;
};

export type ModifyGroupItemInMultipleGroupsPayload = {
  __typename?: 'ModifyGroupItemInMultipleGroupsPayload';
  errors?: Maybe<Array<ModifyGroupItemInMultipleGroupsError>>;
  result?: Maybe<Result>;
};

export type ModifyShareInfoChannelInput = {
  grantedUses?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  shareInfoModificationType: ShareInfoModificationType;
  sharedFrom?: InputMaybe<Scalars['DateTime']>;
  sharedUntil?: InputMaybe<Scalars['DateTime']>;
};

export type ModifyShareInfoItemBaseInput = {
  id: Scalars['UUID'];
  shareInfoModificationType: ShareInfoModificationType;
  sharedFrom?: InputMaybe<Scalars['DateTime']>;
  sharedUntil?: InputMaybe<Scalars['DateTime']>;
};

export type ModifyUserAccessesError = InvitationError;

export type ModifyUserAccessesInput = {
  channels: Array<ModifyShareInfoChannelInput>;
  groups: Array<ModifyShareInfoItemBaseInput>;
  installationId: Scalars['UUID'];
  sharedToUserId: Scalars['UUID'];
};

export type ModifyUserAccessesPayload = {
  __typename?: 'ModifyUserAccessesPayload';
  errors?: Maybe<Array<ModifyUserAccessesError>>;
  result?: Maybe<Result>;
};

export type MultiParameterAggregatedItem = {
  __typename?: 'MultiParameterAggregatedItem';
  dateAtUtc: Scalars['DateTime'];
  measurements?: Maybe<Scalars['JSON']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptInvitationPayload;
  activateTrigger: ActivateTriggerPayload;
  addMultipleInstallationsAfterMigration: Array<UserInstallation>;
  addToFavourites: IdResponse;
  bindInstallationToAssistant: BindInstallationToAssistantPayload;
  cancelInvitation: CancelInvitationPayload;
  changeChannelsVisibility: ChangeChannelsVisibilityPayload;
  changeDeviceName: CorrelationResponse;
  changeGeolocation: ChangeGeolocationPayload;
  changeGroupItemsOrder: IdResponse;
  changeGroupsOrder: IdResponse;
  changeInstallationColor: ChangeInstallationColorPayload;
  changeInstallationIcon: ChangeInstallationIconPayload;
  changeInstallationName: ChangeInstallationNamePayload;
  changeInstallationOrder: Result;
  changeOnEventAction: ChangeOnEventActionPayload;
  changePreviewTariff: ChangePreviewTariffPayload;
  changePushNotificationReceiverName: IdResponse;
  changeTimeZone: ChangeTimeZonePayload;
  changeUserName: ChangeUserNamePayload;
  changeUserRole: ChangeUserRolePayload;
  createAdvancedAction: IdResponse;
  createBasicAction: IdResponse;
  createGroup: CreateGroupPayload;
  createInstallation: UserInstallation;
  createPriceAndTimeTrigger: CreatePriceAndTimeTriggerPayload;
  createStateTrigger: CreateStateTriggerPayload;
  createTimeTrigger: CreateTimeTriggerPayload;
  deactivateTrigger: DeactivateTriggerPayload;
  deleteAction: DeleteActionPayload;
  deleteInstallation: DeleteInstallationPayload;
  deleteTrigger: DeleteTriggerPayload;
  demoPush: Scalars['String'];
  deregisterPushNotificationReceiverById: IdResponse;
  deregisterPushNotificationReceiverByName: IdResponse;
  deregisterPushNotificationReceiverByToken: IdResponse;
  editAction: EditActionPayload;
  editPriceAndTimeTrigger: EditPriceAndTimeTriggerPayload;
  editStateTrigger: EditStateTriggerPayload;
  editTimeTrigger: EditTimeTriggerPayload;
  editUserChannel: EditUserChannelPayload;
  hello: Scalars['String'];
  introduce: IdResponse;
  markActivity: Result;
  markAllAsDisplayed: Result;
  markAllAsHidden: Result;
  markAsDisplayed: Result;
  markAsHidden: Result;
  markLearningScenarioAsViewed: MarkLearningScenarioAsViewedPayload;
  modifyGroupItemInMultipleGroups: ModifyGroupItemInMultipleGroupsPayload;
  modifyUserAccesses: ModifyUserAccessesPayload;
  passOwnershipToInstallation: PassOwnershipToInstallationPayload;
  pushBluetoothLog: PushBluetoothLogPayload;
  registerPushNotificationReceiver: Result;
  rejectInvitation: RejectInvitationPayload;
  removeDevice: RemoveDevicePayload;
  removeFromFavourites: IdResponse;
  removeGroup: RemoveGroupPayload;
  removeProfileImage: Result;
  removeUserFromInstallation: RemoveUserFromInstallationPayload;
  runTrigger: RunTriggerPayload;
  schedulePriceNotification: SchedulePriceNotificationPayload;
  selectInstallation: CurrentInstallation;
  /** @deprecated Use EditUserChannel */
  setChannelAlias: SetChannelAliasPayload;
  /** @deprecated Use EditUserChannel */
  setChannelIconName: Result;
  setFavouriteActionPositions: Result;
  setFavouriteChannelPositions: Result;
  setQuickControl: SetQuickControlPayload;
  share: SharePayload;
  unschedulePriceNotification: UnschedulePriceNotificationPayload;
  updateGroup: UpdateGroupPayload;
  /** @deprecated Use UpdateNotificationSettings mutation. */
  updateNotificationPermissions: Result;
  updateNotificationSettings: UpdateNotificationSettingsPayload;
  updateTariffConfigurations: UpdateTariffConfigurationsPayload;
  updateTriggerName: UpdateTriggerNamePayload;
  updateUserLanguage: UpdateUserLanguagePayload;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationActivateTriggerArgs = {
  input: ActivateTriggerInput;
};


export type MutationAddMultipleInstallationsAfterMigrationArgs = {
  inputs: Array<CreateInstallationRequestInput>;
};


export type MutationAddToFavouritesArgs = {
  input: FavouritesItemRequestInput;
};


export type MutationBindInstallationToAssistantArgs = {
  input: BindInstallationToAssistantInput;
};


export type MutationCancelInvitationArgs = {
  input: CancelInvitationInput;
};


export type MutationChangeChannelsVisibilityArgs = {
  input: ChangeChannelsVisibilityInput;
};


export type MutationChangeDeviceNameArgs = {
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationChangeGeolocationArgs = {
  input: ChangeGeolocationInput;
};


export type MutationChangeGroupItemsOrderArgs = {
  input: ChangeGroupItemsOrderRequestInput;
};


export type MutationChangeGroupsOrderArgs = {
  input: ChangeGroupOrderRequestInput;
};


export type MutationChangeInstallationColorArgs = {
  input: ChangeInstallationColorInput;
};


export type MutationChangeInstallationIconArgs = {
  input: ChangeInstallationIconInput;
};


export type MutationChangeInstallationNameArgs = {
  input: ChangeInstallationNameInput;
};


export type MutationChangeInstallationOrderArgs = {
  input: ChangeInstallationsOrderRequestInput;
};


export type MutationChangeOnEventActionArgs = {
  input: ChangeOnEventActionInput;
};


export type MutationChangePreviewTariffArgs = {
  input: ChangePreviewTariffInput;
};


export type MutationChangePushNotificationReceiverNameArgs = {
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationChangeTimeZoneArgs = {
  input: ChangeTimeZoneInput;
};


export type MutationChangeUserNameArgs = {
  input: ChangeUserNameInput;
};


export type MutationChangeUserRoleArgs = {
  input: ChangeUserRoleInput;
};


export type MutationCreateAdvancedActionArgs = {
  input: CreateAdvancedActionRequestInput;
};


export type MutationCreateBasicActionArgs = {
  input: CreateBasicActionRequestInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateInstallationArgs = {
  input: CreateInstallationRequestInput;
};


export type MutationCreatePriceAndTimeTriggerArgs = {
  input: CreatePriceAndTimeTriggerInput;
};


export type MutationCreateStateTriggerArgs = {
  input: CreateStateTriggerInput;
};


export type MutationCreateTimeTriggerArgs = {
  input: CreateTimeTriggerInput;
};


export type MutationDeactivateTriggerArgs = {
  input: DeactivateTriggerInput;
};


export type MutationDeleteActionArgs = {
  input: DeleteActionInput;
};


export type MutationDeleteInstallationArgs = {
  input: DeleteInstallationInput;
};


export type MutationDeleteTriggerArgs = {
  input: DeleteTriggerInput;
};


export type MutationDeregisterPushNotificationReceiverByIdArgs = {
  id: Scalars['UUID'];
};


export type MutationDeregisterPushNotificationReceiverByNameArgs = {
  name: Scalars['String'];
};


export type MutationDeregisterPushNotificationReceiverByTokenArgs = {
  token: Scalars['String'];
};


export type MutationEditActionArgs = {
  input: EditActionInput;
};


export type MutationEditPriceAndTimeTriggerArgs = {
  input: EditPriceAndTimeTriggerInput;
};


export type MutationEditStateTriggerArgs = {
  input: EditStateTriggerInput;
};


export type MutationEditTimeTriggerArgs = {
  input: EditTimeTriggerInput;
};


export type MutationEditUserChannelArgs = {
  input: EditUserChannelInput;
};


export type MutationMarkAsDisplayedArgs = {
  correlationIds: Array<Scalars['UUID']>;
};


export type MutationMarkAsHiddenArgs = {
  correlationIds: Array<Scalars['UUID']>;
};


export type MutationMarkLearningScenarioAsViewedArgs = {
  input: MarkLearningScenarioAsViewedInput;
};


export type MutationModifyGroupItemInMultipleGroupsArgs = {
  input: ModifyGroupItemInMultipleGroupsInput;
};


export type MutationModifyUserAccessesArgs = {
  input: ModifyUserAccessesInput;
};


export type MutationPassOwnershipToInstallationArgs = {
  input: PassOwnershipToInstallationInput;
};


export type MutationPushBluetoothLogArgs = {
  input: PushBluetoothLogInput;
};


export type MutationRegisterPushNotificationReceiverArgs = {
  input: RegisterPushReceiverRequestInput;
};


export type MutationRejectInvitationArgs = {
  input: RejectInvitationInput;
};


export type MutationRemoveDeviceArgs = {
  input: RemoveDeviceInput;
};


export type MutationRemoveFromFavouritesArgs = {
  input: FavouritesItemRequestInput;
};


export type MutationRemoveGroupArgs = {
  input: RemoveGroupInput;
};


export type MutationRemoveUserFromInstallationArgs = {
  input: RemoveUserFromInstallationInput;
};


export type MutationRunTriggerArgs = {
  input: RunTriggerInput;
};


export type MutationSchedulePriceNotificationArgs = {
  input: SchedulePriceNotificationInput;
};


export type MutationSelectInstallationArgs = {
  installationId: Scalars['UUID'];
};


export type MutationSetChannelAliasArgs = {
  input: SetChannelAliasInput;
};


export type MutationSetChannelIconNameArgs = {
  channelId: Scalars['UUID'];
  iconName: Scalars['String'];
};


export type MutationSetFavouriteActionPositionsArgs = {
  input: SetActionFavouritePositionRequestInput;
};


export type MutationSetFavouriteChannelPositionsArgs = {
  input: SetChannelFavouritePositionRequestInput;
};


export type MutationSetQuickControlArgs = {
  input: SetQuickControlInput;
};


export type MutationShareArgs = {
  input: ShareInput;
};


export type MutationUnschedulePriceNotificationArgs = {
  input: UnschedulePriceNotificationInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateNotificationPermissionsArgs = {
  input: UpdateNotificationPermissionsRequestInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


export type MutationUpdateTariffConfigurationsArgs = {
  input: UpdateTariffConfigurationsInput;
};


export type MutationUpdateTriggerNameArgs = {
  input: UpdateTriggerNameInput;
};


export type MutationUpdateUserLanguageArgs = {
  input: UpdateUserLanguageInput;
};

export type NoPersonalization = UserChannelPersonalization & {
  __typename?: 'NoPersonalization';
  onEventAction?: Maybe<NotificationSenderType>;
  type: ChannelTypeInternal;
};

export type Notification = {
  __typename?: 'Notification';
  code: NotificationCode;
  correlationId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isHidden: Scalars['Boolean'];
  notifiedOn?: Maybe<Scalars['DateTime']>;
  params: Array<NotificationParam>;
  reason: Scalars['String'];
  receiverEmail?: Maybe<Scalars['String']>;
  receiverId?: Maybe<Scalars['UUID']>;
  senderType: NotificationSenderType;
  sourceBrokerId: Scalars['Int'];
  triedToSendTimes: Scalars['Int'];
  wasDisplayed: Scalars['Boolean'];
};

export enum NotificationCode {
  ActionCreated = 'ACTION_CREATED',
  ChannelsAccessAdded = 'CHANNELS_ACCESS_ADDED',
  ChannelsAccessExpired = 'CHANNELS_ACCESS_EXPIRED',
  ChannelsAccessRemoved = 'CHANNELS_ACCESS_REMOVED',
  ChannelsAdded = 'CHANNELS_ADDED',
  DeviceAdded = 'DEVICE_ADDED',
  DeviceRemovedOrFactoryReset = 'DEVICE_REMOVED_OR_FACTORY_RESET',
  GateAlert = 'GATE_ALERT',
  GroupsAccessExpired = 'GROUPS_ACCESS_EXPIRED',
  GroupAccessAdded = 'GROUP_ACCESS_ADDED',
  GroupAccessRemoved = 'GROUP_ACCESS_REMOVED',
  InstallationAccessChanged = 'INSTALLATION_ACCESS_CHANGED',
  InstallationPassed = 'INSTALLATION_PASSED',
  InvitationAcceptedByInvitee = 'INVITATION_ACCEPTED_BY_INVITEE',
  InvitationCanceledByCreator = 'INVITATION_CANCELED_BY_CREATOR',
  InvitationReceived = 'INVITATION_RECEIVED',
  InvitationRejectedByInvitee = 'INVITATION_REJECTED_BY_INVITEE',
  MeterAlert = 'METER_ALERT',
  PublicGroupAdded = 'PUBLIC_GROUP_ADDED',
  PublicGroupChanged = 'PUBLIC_GROUP_CHANGED',
  PublicGroupRemoved = 'PUBLIC_GROUP_REMOVED',
  RemovedFromInstallation = 'REMOVED_FROM_INSTALLATION',
  ResetToDefaults = 'RESET_TO_DEFAULTS',
  ResourceAccessModified = 'RESOURCE_ACCESS_MODIFIED',
  Undefined = 'UNDEFINED',
  UserInstallationExpired = 'USER_INSTALLATION_EXPIRED',
  UsesDepleted = 'USES_DEPLETED'
}

export type NotificationCodeOperationFilterInput = {
  eq?: InputMaybe<NotificationCode>;
  in?: InputMaybe<Array<NotificationCode>>;
  neq?: InputMaybe<NotificationCode>;
  nin?: InputMaybe<Array<NotificationCode>>;
};

export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  code?: InputMaybe<NotificationCodeOperationFilterInput>;
  correlationId?: InputMaybe<UuidOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  failureReason?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isHidden?: InputMaybe<BooleanOperationFilterInput>;
  notifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
  params?: InputMaybe<ListFilterInputTypeOfNotificationParamFilterInput>;
  reason?: InputMaybe<StringOperationFilterInput>;
  receiverEmail?: InputMaybe<StringOperationFilterInput>;
  receiverId?: InputMaybe<UuidOperationFilterInput>;
  senderType?: InputMaybe<NotificationSenderTypeOperationFilterInput>;
  sourceBrokerId?: InputMaybe<IntOperationFilterInput>;
  triedToSendTimes?: InputMaybe<IntOperationFilterInput>;
  wasDisplayed?: InputMaybe<BooleanOperationFilterInput>;
};

export type NotificationMapItem = {
  __typename?: 'NotificationMapItem';
  availableParameters: Array<Scalars['String']>;
  code: NotificationCode;
};

export type NotificationParam = {
  __typename?: 'NotificationParam';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type NotificationParamFilterInput = {
  and?: InputMaybe<Array<NotificationParamFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NotificationParamFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export enum NotificationSenderType {
  Push = 'PUSH',
  QueryOnly = 'QUERY_ONLY',
  Smtp = 'SMTP',
  Subscriptions = 'SUBSCRIPTIONS',
  Undefined = 'UNDEFINED'
}

export type NotificationSenderTypeOperationFilterInput = {
  eq?: InputMaybe<NotificationSenderType>;
  in?: InputMaybe<Array<NotificationSenderType>>;
  neq?: InputMaybe<NotificationSenderType>;
  nin?: InputMaybe<Array<NotificationSenderType>>;
};

export type NotificationSortInput = {
  code?: InputMaybe<SortEnumType>;
  correlationId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  failureReason?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isHidden?: InputMaybe<SortEnumType>;
  notifiedOn?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<SortEnumType>;
  receiverEmail?: InputMaybe<SortEnumType>;
  receiverId?: InputMaybe<SortEnumType>;
  senderType?: InputMaybe<SortEnumType>;
  sourceBrokerId?: InputMaybe<SortEnumType>;
  triedToSendTimes?: InputMaybe<SortEnumType>;
  wasDisplayed?: InputMaybe<SortEnumType>;
};

export type NullableOfNotificationSenderTypeOperationFilterInput = {
  eq?: InputMaybe<NotificationSenderType>;
  in?: InputMaybe<Array<InputMaybe<NotificationSenderType>>>;
  neq?: InputMaybe<NotificationSenderType>;
  nin?: InputMaybe<Array<InputMaybe<NotificationSenderType>>>;
};

export type NullableOfTariffKindInternalOperationFilterInput = {
  eq?: InputMaybe<TariffKindInternal>;
  in?: InputMaybe<Array<InputMaybe<TariffKindInternal>>>;
  neq?: InputMaybe<TariffKindInternal>;
  nin?: InputMaybe<Array<InputMaybe<TariffKindInternal>>>;
};

export enum OptimizerAggregateVectorParameterTypeInternal {
  Unknown = 'UNKNOWN'
}

export type OptimizerChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'OptimizerChannelStateResponse';
  channelId: Scalars['UUID'];
  comfort?: Maybe<ComfortConfig>;
  configValidation: OptimizerConfigValidation;
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  eco: EcoConfig;
  fullSelfConsumption: FullSelfConsumptionConfig;
  mode: OptimizerModeInternal;
  selfConsumptionWithPowerLimit: SelfConsumptionWithPowerLimitConfig;
  selfConsumptionWithRelays: SelfConsumptionWithRelaysConfig;
  supportedAggregateVectorParameters: Array<Scalars['Int']>;
  supportedScalarParameters: Array<Scalars['Int']>;
  supportedVectorParameters: Array<Scalars['Int']>;
  workingHours: WorkingHours;
};

export type OptimizerConfigValidation = {
  __typename?: 'OptimizerConfigValidation';
  heaterPowerLimit: FloatValidation;
  powerLimit: FloatValidation;
  relay: RelayValidation;
  tempMax: FloatValidation;
  tempMin: FloatValidation;
  tempSelfConsumptionMin: FloatValidation;
  voltageThreshold: FloatValidation;
};

export type OptimizerConfigurationTaintedPayload = {
  __typename?: 'OptimizerConfigurationTaintedPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  failures: Array<Scalars['String']>;
  installationId: Scalars['UUID'];
};

export type OptimizerConfigurationUpdatedPayload = {
  __typename?: 'OptimizerConfigurationUpdatedPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export enum OptimizerModeInternal {
  Comfort = 'COMFORT',
  Eco = 'ECO',
  FullSelfConsumption = 'FULL_SELF_CONSUMPTION',
  SelfConsumptionWithPowerLimit = 'SELF_CONSUMPTION_WITH_POWER_LIMIT',
  SelfConsumptionWithRelays = 'SELF_CONSUMPTION_WITH_RELAYS',
  TestMode = 'TEST_MODE',
  Unknown = 'UNKNOWN'
}

export enum OptimizerScalarParameterTypeInternal {
  Temperature = 'TEMPERATURE',
  Unknown = 'UNKNOWN'
}

export enum OptimizerVectorParameterTypeInternal {
  ActivePower = 'ACTIVE_POWER',
  Current = 'CURRENT',
  RelayState = 'RELAY_STATE',
  ScrFilling = 'SCR_FILLING',
  Unknown = 'UNKNOWN',
  Voltage = 'VOLTAGE'
}

export type OwnerInfo = {
  __typename?: 'OwnerInfo';
  owner?: Maybe<TrimmedUserResponse>;
  ownerId: Scalars['UUID'];
};

export type PartialConfigChangedPayload = {
  __typename?: 'PartialConfigChangedPayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  numericalProperties: Array<PartialConfigProperty>;
  stringProperties: Array<PartialConfigProperty>;
  updatedProperties: Array<Scalars['String']>;
};

export type PartialConfigProperty = {
  __typename?: 'PartialConfigProperty';
  property: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PassOwnershipToInstallationError = InvitationError;

export type PassOwnershipToInstallationInput = {
  installationId: Scalars['UUID'];
  newOwnerId: Scalars['UUID'];
};

export type PassOwnershipToInstallationPayload = {
  __typename?: 'PassOwnershipToInstallationPayload';
  errors?: Maybe<Array<PassOwnershipToInstallationError>>;
  result?: Maybe<Result>;
};

export enum PeriodWeeklyPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Total = 'TOTAL',
  Weekly = 'WEEKLY'
}

export type PositionFavourites = FavouritePosition & {
  __typename?: 'PositionFavourites';
  favouritePositionType: FavouritePositionType;
  value: Scalars['Float'];
};

export type PriceEntryResponse = {
  __typename?: 'PriceEntryResponse';
  priceInMWh: Scalars['Decimal'];
  priceInkWh: Scalars['Decimal'];
  startingHour: Scalars['Int'];
  time: Scalars['String'];
};

export enum PriceEvent {
  CheaperThanPercentAverageDaily = 'CHEAPER_THAN_PERCENT_AVERAGE_DAILY',
  CheaperThanValue = 'CHEAPER_THAN_VALUE',
  MoreExpensiveThanPercentAverageDaily = 'MORE_EXPENSIVE_THAN_PERCENT_AVERAGE_DAILY',
  MoreExpensiveThanValue = 'MORE_EXPENSIVE_THAN_VALUE',
  Unknown = 'UNKNOWN'
}

export type PriceEventState = {
  __typename?: 'PriceEventState';
  cheapestPeriods?: Maybe<Scalars['Int']>;
  endAt?: Maybe<Scalars['TimeSpan']>;
  maxPrice?: Maybe<Scalars['Float']>;
  minPrice?: Maybe<Scalars['Float']>;
  startAt?: Maybe<Scalars['TimeSpan']>;
};

export type PriceNotificationSchedule = {
  __typename?: 'PriceNotificationSchedule';
  createdAt: Scalars['DateTime'];
  eventType: PriceEvent;
  fcmToken: Scalars['String'];
  id: Scalars['UUID'];
  priceHourFromUtc: Scalars['LocalTime'];
  priceHourToUtc: Scalars['LocalTime'];
  priceOverPercentAverageDaily?: Maybe<Scalars['Float']>;
  priceOverValue?: Maybe<Scalars['Float']>;
  priceUnderPercentAverageDaily?: Maybe<Scalars['Float']>;
  priceUnderValue?: Maybe<Scalars['Float']>;
  userId: Scalars['UUID'];
};

export enum PriceTriggerSubType {
  Dynamic = 'DYNAMIC',
  G13S = 'G13S',
  Unknown = 'UNKNOWN'
}

export type PricesBySeasons = {
  __typename?: 'PricesBySeasons';
  bucketInfos: Array<BucketInfo>;
  movableHolidays: Array<Scalars['LocalDate']>;
  staticHolidays: Array<Scalars['LocalDate']>;
  summer: SeasonEntries;
  winter: SeasonEntries;
};

export type ProtoMessagePayload = {
  __typename?: 'ProtoMessagePayload';
  backendSendAt: Scalars['String'];
  deviceId: Scalars['UUID'];
  deviceMode: DeviceMode;
  installationId: Scalars['UUID'];
  payload: Scalars['String'];
  type: ProtoMessageType;
};

export enum ProtoMessageType {
  Connect = 'CONNECT',
  Disconnect = 'DISCONNECT',
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum PublishStatus {
  ContractNotSupported = 'CONTRACT_NOT_SUPPORTED',
  DeviceDisconnected = 'DEVICE_DISCONNECTED',
  DeviceOrChannelNotFound = 'DEVICE_OR_CHANNEL_NOT_FOUND',
  Ok = 'OK'
}

export type PushBluetoothLogInput = {
  installationId: Scalars['UUID'];
  loggingInfo: LoggingInfo;
  macAddress: Scalars['String'];
  messages: Array<Array<Scalars['Byte']>>;
  sessionId?: InputMaybe<Scalars['Long']>;
  validFrom?: InputMaybe<Scalars['Long']>;
  validTo?: InputMaybe<Scalars['Long']>;
};

export type PushBluetoothLogPayload = {
  __typename?: 'PushBluetoothLogPayload';
  boolean?: Maybe<Scalars['Boolean']>;
};

export type PushReceiverRegistration = {
  __typename?: 'PushReceiverRegistration';
  id: Scalars['UUID'];
  lastConnectedAt: Scalars['DateTime'];
  name: Scalars['String'];
  pushReceiverType: PushReceiverType;
  registeredAt: Scalars['DateTime'];
  token: Scalars['String'];
  userId: Scalars['UUID'];
};

export type PushReceiverRegistrationFilterInput = {
  and?: InputMaybe<Array<PushReceiverRegistrationFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lastConnectedAt?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PushReceiverRegistrationFilterInput>>;
  pushReceiverType?: InputMaybe<PushReceiverTypeOperationFilterInput>;
  registeredAt?: InputMaybe<DateTimeOperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type PushReceiverRegistrationSortInput = {
  id?: InputMaybe<SortEnumType>;
  lastConnectedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pushReceiverType?: InputMaybe<SortEnumType>;
  registeredAt?: InputMaybe<SortEnumType>;
  token?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export enum PushReceiverType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PushReceiverTypeOperationFilterInput = {
  eq?: InputMaybe<PushReceiverType>;
  in?: InputMaybe<Array<PushReceiverType>>;
  neq?: InputMaybe<PushReceiverType>;
  nin?: InputMaybe<Array<PushReceiverType>>;
};

/** A segment of a collection. */
export type PushReceiversRegistrationsCollectionSegment = {
  __typename?: 'PushReceiversRegistrationsCollectionSegment';
  cacheInfo?: Maybe<CacheInfo>;
  /** A flattened list of the items. */
  items?: Maybe<Array<PushReceiverRegistration>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type Query = {
  __typename?: 'Query';
  allAssistantBindings: Array<AssistantBinding>;
  allInvitations: Array<Invitation>;
  /** @deprecated Use AllUserNotifications */
  allNotifications: Array<Notification>;
  /** @deprecated Use PushReceiversRegistrations */
  allPushReceiversRegistrations: Array<PushReceiverRegistration>;
  allTriggers: Array<Trigger>;
  /** @deprecated Use UserActions */
  allUserActions: Array<UserAction>;
  allUserChannels: Array<UserChannel>;
  allUserDevices: Array<UserDevice>;
  /** @deprecated Use UserGroups */
  allUserGroups: Array<UserGroup>;
  /** @deprecated Use UserInstallations */
  allUserInstallations: Array<UserInstallation>;
  allUserNotifications?: Maybe<AllUserNotificationsCollectionSegment>;
  allowedPrefixes: Array<AllowedPrefix>;
  bluetoothLoggingEnabled: LogLevel;
  calculateFutureFireTimes: TriggerFutureFiresResponse;
  calculateNextTriggerFireTime: TriggerNextFireTimeResponse;
  currentInstallation?: Maybe<CurrentInstallation>;
  dynamicMarketPrice?: Maybe<DayEntryResponse>;
  dynamicMarketPrices: Array<DayEntryResponse>;
  dynamicMarketPricesWithBuckets: DynamicPricesWithBuckets;
  hello: Scalars['String'];
  me?: Maybe<Me>;
  measurementMap: MeasurementMap;
  meterAggregatedMeasurements: MeasurementResponseOfGetAggregateVectorMeasurementResponse;
  meterCommonMeasurements: MeasurementResponseOfGetCurrentMeasurementResponse;
  meterCurrentMeasurements: MeasurementResponseOfGetCurrentMeasurementResponse;
  notificationMap: Array<NotificationMapItem>;
  persistedMeterAggregatedMeasurements: MeasurementResponseOfGetPersistedVectorMeasurementResponse;
  priceNotificationSchedules: Array<PriceNotificationSchedule>;
  pushReceiversRegistrations?: Maybe<PushReceiversRegistrationsCollectionSegment>;
  rssi: RssiResponse;
  seasonPrices?: Maybe<PricesBySeasons>;
  selectedInstallation?: Maybe<UserInstallation>;
  sharingInfo?: Maybe<ShareInfo>;
  sharingInfosByInstallation: SharedInstallationInfo;
  supportedSlots?: Maybe<SupportedSlots>;
  trigger?: Maybe<Trigger>;
  user: TrimmedUserResponse;
  userAction?: Maybe<UserAction>;
  userActions?: Maybe<UserActionsCollectionSegment>;
  userChannel?: Maybe<UserChannel>;
  userDevice?: Maybe<UserDevice>;
  userGroups?: Maybe<UserGroupsCollectionSegment>;
  userInstallation?: Maybe<UserInstallation>;
  userInstallations?: Maybe<UserInstallationsCollectionSegment>;
  userNotification?: Maybe<Notification>;
  userProfile?: Maybe<UserProfile>;
  users: Array<TrimmedUserResponse>;
  versionMap: Array<FeaturesByVersionMap>;
};


export type QueryAllInvitationsArgs = {
  includeCreatedByMe: Scalars['Boolean'];
  includeInvitedMe: Scalars['Boolean'];
  order?: InputMaybe<Array<InvitationSortInput>>;
  where?: InputMaybe<InvitationFilterInput>;
};


export type QueryAllNotificationsArgs = {
  order?: InputMaybe<Array<NotificationSortInput>>;
  where?: InputMaybe<NotificationFilterInput>;
};


export type QueryAllPushReceiversRegistrationsArgs = {
  order?: InputMaybe<Array<PushReceiverRegistrationSortInput>>;
  where?: InputMaybe<PushReceiverRegistrationFilterInput>;
};


export type QueryAllTriggersArgs = {
  installationId: Scalars['UUID'];
};


export type QueryAllUserActionsArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserActionSortInput>>;
  where?: InputMaybe<UserActionFilterInput>;
};


export type QueryAllUserChannelsArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserChannelSortInput>>;
  where?: InputMaybe<UserChannelFilterInput>;
};


export type QueryAllUserDevicesArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserDeviceSortInput>>;
  where?: InputMaybe<UserDeviceFilterInput>;
};


export type QueryAllUserGroupsArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserGroupSortInput>>;
  where?: InputMaybe<UserGroupFilterInput>;
};


export type QueryAllUserInstallationsArgs = {
  order?: InputMaybe<Array<UserInstallationSortInput>>;
  where?: InputMaybe<UserInstallationFilterInput>;
};


export type QueryAllUserNotificationsArgs = {
  order?: InputMaybe<Array<NotificationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationFilterInput>;
};


export type QueryBluetoothLoggingEnabledArgs = {
  installationId: Scalars['UUID'];
};


export type QueryCalculateFutureFireTimesArgs = {
  installationId: Scalars['UUID'];
  trigger: TriggerPriceAndTimeConditionRequestInput;
};


export type QueryCalculateNextTriggerFireTimeArgs = {
  installationId: Scalars['UUID'];
  trigger: TriggerTimeConditionRequestInput;
};


export type QueryDynamicMarketPriceArgs = {
  date: Scalars['LocalDate'];
};


export type QueryHelloArgs = {
  installationId: Scalars['UUID'];
};


export type QueryMeterAggregatedMeasurementsArgs = {
  input?: InputMaybe<GetAggregateMeasurementsRequestInput>;
  installationId: Scalars['UUID'];
};


export type QueryMeterCommonMeasurementsArgs = {
  input?: InputMaybe<GetCommonMeasurementsRequestInput>;
  installationId: Scalars['UUID'];
};


export type QueryMeterCurrentMeasurementsArgs = {
  input: GetCurrentMeasurementsRequestInput;
  installationId: Scalars['UUID'];
};


export type QueryPersistedMeterAggregatedMeasurementsArgs = {
  input: GetPersistedAggregateMeasurementsRequestInput;
  installationId: Scalars['UUID'];
};


export type QueryPushReceiversRegistrationsArgs = {
  order?: InputMaybe<Array<PushReceiverRegistrationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PushReceiverRegistrationFilterInput>;
};


export type QueryRssiArgs = {
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};


export type QuerySeasonPricesArgs = {
  installationId: Scalars['UUID'];
};


export type QuerySharingInfoArgs = {
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type QuerySharingInfosByInstallationArgs = {
  installationId: Scalars['UUID'];
};


export type QueryTriggerArgs = {
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
};


export type QueryUserArgs = {
  id: Scalars['UUID'];
};


export type QueryUserActionArgs = {
  actionId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};


export type QueryUserActionsArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserActionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserActionFilterInput>;
};


export type QueryUserChannelArgs = {
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
};


export type QueryUserDeviceArgs = {
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
};


export type QueryUserGroupsArgs = {
  installationId: Scalars['UUID'];
  order?: InputMaybe<Array<UserGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserGroupFilterInput>;
};


export type QueryUserInstallationArgs = {
  where?: InputMaybe<UserInstallationFilterInput>;
};


export type QueryUserInstallationsArgs = {
  order?: InputMaybe<Array<UserInstallationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserInstallationFilterInput>;
};


export type QueryUserNotificationArgs = {
  order?: InputMaybe<Array<NotificationSortInput>>;
  where?: InputMaybe<NotificationFilterInput>;
};


export type QueryUsersArgs = {
  ids: Array<Scalars['UUID']>;
};

export enum RecoveryDeviceStatus {
  DownloadingFirmware = 'DOWNLOADING_FIRMWARE',
  FailedToDownload = 'FAILED_TO_DOWNLOAD',
  FirmwareDownloaded = 'FIRMWARE_DOWNLOADED',
  FirmwareIsUpToDate = 'FIRMWARE_IS_UP_TO_DATE',
  Unknown = 'UNKNOWN'
}

export type RecoveryDeviceStatusRecievedPayload = {
  __typename?: 'RecoveryDeviceStatusRecievedPayload';
  currentVersion: Scalars['String'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  newestCurrentVersion?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
  recoveryDeviceStatus: RecoveryDeviceStatus;
};

export type RegisterPushReceiverRequestInput = {
  pushReceiverName: Scalars['String'];
  pushReceiverType: PushReceiverType;
  token: Scalars['String'];
};

export enum RegulatorModeTypeInternal {
  Antifreezetimetable = 'ANTIFREEZETIMETABLE',
  Day = 'DAY',
  Holiday = 'HOLIDAY',
  Holidaytimetable = 'HOLIDAYTIMETABLE',
  Hometimetable = 'HOMETIMETABLE',
  Manual = 'MANUAL',
  Night = 'NIGHT',
  Off = 'OFF',
  Outsidehometimetable = 'OUTSIDEHOMETIMETABLE',
  Party = 'PARTY',
  Unknown = 'UNKNOWN'
}

export type RejectInvitationError = InvitationError;

export type RejectInvitationInput = {
  invitationId: Scalars['UUID'];
};

export type RejectInvitationPayload = {
  __typename?: 'RejectInvitationPayload';
  errors?: Maybe<Array<RejectInvitationError>>;
  result?: Maybe<Result>;
};

export type RelayConfig = {
  __typename?: 'RelayConfig';
  enabled: Scalars['Boolean'];
  index: Scalars['Int'];
  thresholdValue: Scalars['Float'];
  timeOff: Scalars['Int'];
  timeOn: Scalars['Int'];
};

export type RelayValidation = {
  __typename?: 'RelayValidation';
  thresholdPercent: FloatValidation;
  thresholdPower: FloatValidation;
  timeOff: IntValidation;
  timeOn: IntValidation;
};

export type RemoveDeviceError = DeviceError;

export type RemoveDeviceInput = {
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export type RemoveDevicePayload = {
  __typename?: 'RemoveDevicePayload';
  errors?: Maybe<Array<RemoveDeviceError>>;
  result?: Maybe<Result>;
};

export type RemoveGroupError = GroupError;

export type RemoveGroupInput = {
  groupId: Scalars['UUID'];
  installationId: Scalars['UUID'];
};

export type RemoveGroupPayload = {
  __typename?: 'RemoveGroupPayload';
  errors?: Maybe<Array<RemoveGroupError>>;
  result?: Maybe<Result>;
};

export type RemoveUserFromInstallationError = InvitationError;

export type RemoveUserFromInstallationInput = {
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RemoveUserFromInstallationPayload = {
  __typename?: 'RemoveUserFromInstallationPayload';
  errors?: Maybe<Array<RemoveUserFromInstallationError>>;
  result?: Maybe<Result>;
};

export type RequestAckPayload = {
  __typename?: 'RequestAckPayload';
  channelId?: Maybe<Scalars['UUID']>;
  correlationId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  status: RequestAckResultType;
};

export enum RequestAckResultType {
  Ok = 'OK',
  Timeout = 'TIMEOUT'
}

export type Result = {
  __typename?: 'Result';
  ok: Scalars['Boolean'];
};

export type RssiResponse = {
  __typename?: 'RssiResponse';
  rssi?: Maybe<Scalars['Int']>;
};

export type RunTriggerError = TriggerError;

export type RunTriggerInput = {
  ignoreStateConditions: Scalars['Boolean'];
  installationId: Scalars['UUID'];
  triggerId: Scalars['UUID'];
};

export type RunTriggerPayload = {
  __typename?: 'RunTriggerPayload';
  errors?: Maybe<Array<RunTriggerError>>;
  result?: Maybe<Result>;
};

export type ScalarMeasurementResponseItem = {
  __typename?: 'ScalarMeasurementResponseItem';
  type: Scalars['Int'];
  value: Scalars['Float'];
};

export enum ScalarParameterTypeInternal {
  AverageActivePower = 'AVERAGE_ACTIVE_POWER',
  AverageCurrent = 'AVERAGE_CURRENT',
  AverageFrequence = 'AVERAGE_FREQUENCE',
  AveragePhaseAngle = 'AVERAGE_PHASE_ANGLE',
  AveragePowerFactor = 'AVERAGE_POWER_FACTOR',
  AverageReactivePower = 'AVERAGE_REACTIVE_POWER',
  AverageVoltage = 'AVERAGE_VOLTAGE',
  EcoIndicator = 'ECO_INDICATOR',
  Frequence = 'FREQUENCE',
  MaxActivePower = 'MAX_ACTIVE_POWER',
  MaxCurrent = 'MAX_CURRENT',
  MaxFrequence = 'MAX_FREQUENCE',
  MaxPhaseAngle = 'MAX_PHASE_ANGLE',
  MaxPowerFactor = 'MAX_POWER_FACTOR',
  MaxReactivePower = 'MAX_REACTIVE_POWER',
  MaxVoltage = 'MAX_VOLTAGE',
  MinActivePower = 'MIN_ACTIVE_POWER',
  MinCurrent = 'MIN_CURRENT',
  MinFrequence = 'MIN_FREQUENCE',
  MinPhaseAngle = 'MIN_PHASE_ANGLE',
  MinPowerFactor = 'MIN_POWER_FACTOR',
  MinReactivePower = 'MIN_REACTIVE_POWER',
  MinVoltage = 'MIN_VOLTAGE',
  TotalArithmeticForwardActiveEnergy = 'TOTAL_ARITHMETIC_FORWARD_ACTIVE_ENERGY',
  TotalArithmeticReverseActiveEnergy = 'TOTAL_ARITHMETIC_REVERSE_ACTIVE_ENERGY',
  TotalVectorForwardActiveEnergy = 'TOTAL_VECTOR_FORWARD_ACTIVE_ENERGY',
  TotalVectorReverseActiveEnergy = 'TOTAL_VECTOR_REVERSE_ACTIVE_ENERGY',
  Unknown = 'UNKNOWN'
}

export type SchedulePriceNotificationError = ScheduledNotificationsError;

export type SchedulePriceNotificationInput = {
  priceEvent: PriceEvent;
  value: Scalars['Float'];
};

export type SchedulePriceNotificationPayload = {
  __typename?: 'SchedulePriceNotificationPayload';
  errors?: Maybe<Array<SchedulePriceNotificationError>>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type ScheduledNotificationsError = Error & {
  __typename?: 'ScheduledNotificationsError';
  error: ScheduledNotificationsErrorDictionary;
  message: Scalars['String'];
};

export enum ScheduledNotificationsErrorDictionary {
  Undefined = 'UNDEFINED',
  UserDoesNotHavePushToken = 'USER_DOES_NOT_HAVE_PUSH_TOKEN'
}

export type SeasonEntries = {
  __typename?: 'SeasonEntries';
  from: Scalars['LocalDate'];
  offFromWorkDayEntries: Array<PriceEntryResponse>;
  to: Scalars['LocalDate'];
  workingDayEntries: Array<PriceEntryResponse>;
};

export type SelectedBucket = {
  __typename?: 'SelectedBucket';
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type SelectedBucketInput = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type SelfConsumptionWithPowerLimitConfig = {
  __typename?: 'SelfConsumptionWithPowerLimitConfig';
  heaterPowerLimit: Scalars['Float'];
  powerLimit: Scalars['Float'];
  relaysConfig: Array<RelayConfig>;
  tariff?: Maybe<Tariff>;
  tempMax: Scalars['Float'];
  tempMin: Scalars['Float'];
  tempMinEnabled: Scalars['Boolean'];
  tempSelfConsumption: Scalars['Float'];
  voltageThreshold: Array<VoltageThreshold>;
  workingHours: WorkingHours;
};

export type SelfConsumptionWithRelaysConfig = {
  __typename?: 'SelfConsumptionWithRelaysConfig';
  relaysConfig: Array<RelayConfig>;
  workingHours: WorkingHours;
};

export type SensorChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'SensorChannelStateResponse';
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  sensorType: SensorTypeInternal;
  unit: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type SensorConfigurationChangePayload = {
  __typename?: 'SensorConfigurationChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  sensorType: SensorTypeInternal;
  unit: Scalars['String'];
};

export enum SensorTypeInternal {
  Humidity = 'HUMIDITY',
  Temperature = 'TEMPERATURE',
  Unknown = 'UNKNOWN'
}

export type SensorValueChangePayload = {
  __typename?: 'SensorValueChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  value: Scalars['Float'];
};

export type SetActionFavouritePositionRequestInput = {
  actionId: Scalars['UUID'];
  favouritePositions: Array<FavouritePositionItemInput>;
};

export type SetChannelAliasError = ChannelError;

export type SetChannelAliasInput = {
  alias: Scalars['String'];
  channelId: Scalars['UUID'];
};

export type SetChannelAliasPayload = {
  __typename?: 'SetChannelAliasPayload';
  errors?: Maybe<Array<SetChannelAliasError>>;
  result?: Maybe<Result>;
};

export type SetChannelFavouritePositionRequestInput = {
  channelId: Scalars['UUID'];
  favouritePositions: Array<FavouritePositionItemInput>;
};

export type SetOnTimeFavourites = FavouritePosition & {
  __typename?: 'SetOnTimeFavourites';
  favouritePositionType: FavouritePositionType;
  value: Scalars['Float'];
};

export type SetQuickControlError = ChannelError;

export type SetQuickControlInput = {
  channelId: Scalars['UUID'];
  value: Scalars['Boolean'];
};

export type SetQuickControlPayload = {
  __typename?: 'SetQuickControlPayload';
  errors?: Maybe<Array<SetQuickControlError>>;
  result?: Maybe<Result>;
};

export type ShareError = InvitationError;

export type ShareInfo = {
  __typename?: 'ShareInfo';
  actions: Array<ShareInfoItemBase>;
  channels: Array<ShareInfoChannel>;
  createdAt: Scalars['DateTime'];
  groups: Array<ShareInfoItemBase>;
  installation: ShareInfoInstallation;
  installationId: Scalars['UUID'];
  installationOwnerId: Scalars['UUID'];
  sharedToUser?: Maybe<TrimmedUserResponse>;
  sharedToUserId: Scalars['UUID'];
  sharingUser?: Maybe<TrimmedUserResponse>;
  sharingUserId: Scalars['UUID'];
};

export type ShareInfoChannel = {
  __typename?: 'ShareInfoChannel';
  grantedUses?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
};

export type ShareInfoInstallation = {
  __typename?: 'ShareInfoInstallation';
  accessType: InstallationAccessType;
  id: Scalars['UUID'];
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
  wholeInstallationShare: Scalars['Boolean'];
};

export type ShareInfoItemBase = {
  __typename?: 'ShareInfoItemBase';
  id: Scalars['UUID'];
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
};

export enum ShareInfoModificationType {
  Add = 'ADD',
  Modify = 'MODIFY',
  Remove = 'REMOVE',
  Undefined = 'UNDEFINED'
}

export type ShareInput = {
  accessType: InstallationAccessType;
  installationId: Scalars['UUID'];
  invitedUserEmail: Scalars['String'];
  sharedFrom?: InputMaybe<Scalars['DateTime']>;
  sharedItems: Array<SharedItemDtoInput>;
  sharedUntil?: InputMaybe<Scalars['DateTime']>;
  wholeInstallationShare: Scalars['Boolean'];
};

export type SharePayload = {
  __typename?: 'SharePayload';
  errors?: Maybe<Array<ShareError>>;
  result?: Maybe<Result>;
};

export type SharedChannelSettings = {
  id: Scalars['UUID'];
};

export type SharedChannelSettingsFilterInput = {
  and?: InputMaybe<Array<SharedChannelSettingsFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SharedChannelSettingsFilterInput>>;
};

export type SharedChannelSettingsSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type SharedInstallationInfo = {
  __typename?: 'SharedInstallationInfo';
  ownerInfo: OwnerInfo;
  shareInfos: Array<ShareInfo>;
};

export type SharedItem = {
  __typename?: 'SharedItem';
  grantedUses?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  itemType: SharingItemType;
  name: Scalars['String'];
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
};

export type SharedItemDtoInput = {
  grantedUses?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  itemType: SharingItemType;
  name: Scalars['String'];
  sharedFrom?: InputMaybe<Scalars['DateTime']>;
  sharedUntil?: InputMaybe<Scalars['DateTime']>;
};

export type SharedItemFilterInput = {
  and?: InputMaybe<Array<SharedItemFilterInput>>;
  grantedUses?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  itemType?: InputMaybe<SharingItemTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SharedItemFilterInput>>;
  sharedFrom?: InputMaybe<DateTimeOperationFilterInput>;
  sharedUntil?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum SharingItemType {
  Action = 'ACTION',
  Channel = 'CHANNEL',
  Group = 'GROUP',
  Undefined = 'UNDEFINED'
}

export type SharingItemTypeOperationFilterInput = {
  eq?: InputMaybe<SharingItemType>;
  in?: InputMaybe<Array<SharingItemType>>;
  neq?: InputMaybe<SharingItemType>;
  nin?: InputMaybe<Array<SharingItemType>>;
};

export type SharingPayload = {
  __typename?: 'SharingPayload';
  accessType: InstallationAccessType;
  installationId: Scalars['UUID'];
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedItems: Array<SharedItem>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
  wholeInstallationShare: Scalars['Boolean'];
};

export type SharingPayloadFilterInput = {
  accessType?: InputMaybe<InstallationAccessTypeOperationFilterInput>;
  and?: InputMaybe<Array<SharingPayloadFilterInput>>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SharingPayloadFilterInput>>;
  sharedFrom?: InputMaybe<DateTimeOperationFilterInput>;
  sharedItems?: InputMaybe<ListFilterInputTypeOfSharedItemFilterInput>;
  sharedUntil?: InputMaybe<DateTimeOperationFilterInput>;
  wholeInstallationShare?: InputMaybe<BooleanOperationFilterInput>;
};

export type SharingPayloadSortInput = {
  accessType?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  sharedFrom?: InputMaybe<SortEnumType>;
  sharedUntil?: InputMaybe<SortEnumType>;
  wholeInstallationShare?: InputMaybe<SortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceThresholdInternal {
  ActivePower = 'ACTIVE_POWER',
  ApparentPower = 'APPARENT_POWER',
  BalancedPower = 'BALANCED_POWER',
  Current = 'CURRENT',
  Frequency = 'FREQUENCY',
  PhaseAngle = 'PHASE_ANGLE',
  PowerFactor = 'POWER_FACTOR',
  ReactivePower = 'REACTIVE_POWER',
  Unknown = 'UNKNOWN',
  Voltage = 'VOLTAGE'
}

export type StandaloneMeasurementPayload = {
  __typename?: 'StandaloneMeasurementPayload';
  activeEnergy?: Maybe<Scalars['Float']>;
  averageActivePower?: Maybe<Scalars['Float']>;
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  maxActivePower?: Maybe<Scalars['Float']>;
  sumOfActivePower?: Maybe<Scalars['Float']>;
};

export type StateChangedPayload = {
  __typename?: 'StateChangedPayload';
  installationId: Scalars['UUID'];
  payload: BaseChannelPayload;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export enum SubPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN'
}

export type SubscribeForMeasurementInput = {
  channelId: Scalars['UUID'];
  indices: Array<Scalars['Int']>;
  kind: MeasurementChannelKind;
  priority?: InputMaybe<SubPriority>;
  scalarParameterTypes: Array<Scalars['Int']>;
  vectorParameterTypes: Array<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onBinarySensorConfigurationChange: BinarySensorConfigurationChangePayload;
  onBinarySensorValueChange: BinarySensorValueChangePayload;
  onBlindCalibrateStatusChange: BlindCalibrateStatusChangePayload;
  onBlindDirectionChange: BlindDirectionChangePayload;
  onBlindPositionChange: BlindPositionChangePayload;
  onBluetoothLog: BluetoothLogPayload;
  onCentralActionCreated: Scalars['UUID'];
  onCentralActionRemoved: Scalars['UUID'];
  onCentralActionUpdated: Scalars['UUID'];
  onConfigurationTaintedPayload: ConfigurationTaintedPayload;
  onDeviceConnectedToSsidUpdated: DeviceConnectedToSsidUpdatedPayload;
  onDeviceConnectionStateChange: DeviceConnectionStateChangePayload;
  onDeviceError: DeviceErrorPayload;
  onDeviceFirmwareUpdated: DeviceFirmwareUpdatedPayload;
  onDeviceNameChanged: DeviceNameChangedPayload;
  onDeviceWifiNetworksReceived: DeviceWifiNetworksReceivedPayload;
  onGateCalibrateStatusChange: GateCalibrateStatusChangePayload;
  onGateConfigurationChange: GateConfigurationChangePayload;
  /** @deprecated Use OnGateStatusChanged */
  onGatePositionChange: GatePositionChangePayload;
  onGateStatusChanged: GateStatusChangedPayload;
  onGenericInputStateChange: GenericInputStateChangePayload;
  onGenericInputStatusChanged: GenericInputStatusChangedPayload;
  onHelloQuery: Scalars['String'];
  onHvacRegulatorModeChange: HvacRegulatorModeChangePayload;
  onHvacSensorFloorTemperatureChange: HvacSensorFloorTemperatureChangePayload;
  onHvacSensorHumidityChange: HvacSensorHumidityChangePayload;
  onHvacSensorTemperatureChange: HvacSensorTemperatureChangePayload;
  onHvacTargetTemperatureChange: HvacTargetTemperatureChangePayload;
  onHvacTemperatureUnitChange: HvacTemperatureUnitChangePayload;
  onHvacWorkingModeChange: HvacWorkingModeChangePayload;
  onInstallationDetach: InstallationDetachPayload;
  onInvitationExpired: Scalars['UUID'];
  onLightSetOnTimeStateChange: LightStateOnTimeChangePayload;
  onLightStateChanged: LightStateChangedPayload;
  onMeasurement: MeasurementSubResponse;
  onNotified: Notification;
  onOptimizerConfigurationTaintedPayload: OptimizerConfigurationTaintedPayload;
  onOptimizerConfigurationUpdatedPayload: OptimizerConfigurationUpdatedPayload;
  onPartialConfigChanged: PartialConfigChangedPayload;
  onProtoMessage: ProtoMessagePayload;
  onRecoveryDeviceStatusRecievedPayload: RecoveryDeviceStatusRecievedPayload;
  onRequestAckReceived: RequestAckPayload;
  onSensorConfigurationChange: SensorConfigurationChangePayload;
  onSensorValueChange: SensorValueChangePayload;
  onStateChanged: StateChangedPayload;
  onSupplyReturnBehaviorChange: SupplyReturnBehaviorChangePayload;
  onSwitchSetOnTimeStateChange: SwitchStateOnTimeChangePayload;
  onSwitchStateChange: SwitchStateChangePayload;
  onTriggerExecuted: TriggerExecutedPayload;
  onUsesDepleted: Scalars['UUID'];
  subscribeToMeasurement?: Maybe<MeasurementSubResponse>;
};


export type SubscriptionOnBinarySensorConfigurationChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnBinarySensorValueChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnBlindCalibrateStatusChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnBlindDirectionChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnBlindPositionChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnBluetoothLogArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnCentralActionCreatedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnCentralActionRemovedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnCentralActionUpdatedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnConfigurationTaintedPayloadArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnDeviceConnectedToSsidUpdatedArgs = {
  deviceId: Scalars['UUID'];
};


export type SubscriptionOnDeviceConnectionStateChangeArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnDeviceErrorArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnDeviceFirmwareUpdatedArgs = {
  deviceId: Scalars['UUID'];
};


export type SubscriptionOnDeviceNameChangedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnDeviceWifiNetworksReceivedArgs = {
  deviceId: Scalars['UUID'];
};


export type SubscriptionOnGateCalibrateStatusChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnGateConfigurationChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnGatePositionChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnGateStatusChangedArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnGenericInputStateChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnGenericInputStatusChangedArgs = {
  deviceId: Scalars['UUID'];
};


export type SubscriptionOnHelloQueryArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnHvacRegulatorModeChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacSensorFloorTemperatureChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacSensorHumidityChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacSensorTemperatureChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacTargetTemperatureChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacTemperatureUnitChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnHvacWorkingModeChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnInstallationDetachArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnLightSetOnTimeStateChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnLightStateChangedArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnMeasurementArgs = {
  input: SubscribeForMeasurementInput;
};


export type SubscriptionOnOptimizerConfigurationTaintedPayloadArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnOptimizerConfigurationUpdatedPayloadArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnPartialConfigChangedArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnProtoMessageArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnRecoveryDeviceStatusRecievedPayloadArgs = {
  deviceId: Scalars['UUID'];
};


export type SubscriptionOnRequestAckReceivedArgs = {
  channelOrDeviceId: Scalars['UUID'];
};


export type SubscriptionOnSensorConfigurationChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnSensorValueChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnStateChangedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnSupplyReturnBehaviorChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnSwitchSetOnTimeStateChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnSwitchStateChangeArgs = {
  channelId: Scalars['UUID'];
};


export type SubscriptionOnTriggerExecutedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionOnUsesDepletedArgs = {
  installationId: Scalars['UUID'];
};


export type SubscriptionSubscribeToMeasurementArgs = {
  input: SubscribeForMeasurementInput;
};

export type SupplyReturnBehaviorChangePayload = {
  __typename?: 'SupplyReturnBehaviorChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  supplyReturnBehavior: SupplyReturnBehaviorInternal;
};

export enum SupplyReturnBehaviorInternal {
  AlwaysOff = 'ALWAYS_OFF',
  AlwaysOn = 'ALWAYS_ON',
  KeepState = 'KEEP_STATE'
}

export type SupportedSlots = {
  __typename?: 'SupportedSlots';
  blindValues: Array<BlindSupportedSlotsInternal>;
  gateValues: Array<GateSupportedSlotsInternal>;
  lightValues: Array<LightSupportedSlotsInternal>;
  switchValues: Array<SwitchSupportedSlotsInternal>;
};

export type SwitchActionConfigResponse = ActionConfigResponse & {
  __typename?: 'SwitchActionConfigResponse';
  destination?: Maybe<BindingAddress>;
  inputTrigger: InputTriggerInternal;
  isDefaultAction: Scalars['Boolean'];
  setOnTimeValue?: Maybe<Scalars['Int']>;
  slot: SwitchSupportedSlotsInternal;
};

export type SwitchChannelStateResponse = ChannelStateBaseResponse & {
  __typename?: 'SwitchChannelStateResponse';
  channelId: Scalars['UUID'];
  deviceConnectionState: DeviceConnectionState;
  deviceId: Scalars['UUID'];
  measuredBy?: Maybe<MeasuredBy>;
  state: SwitchStateInternal;
  supplyReturnBehavior: SupplyReturnBehaviorInternal;
  supportedSlots: Array<SwitchSupportedSlotsInternal>;
};

export type SwitchStateChangePayload = {
  __typename?: 'SwitchStateChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  state: SwitchStateInternal;
};

export enum SwitchStateInternal {
  Off = 'OFF',
  On = 'ON',
  Unknown = 'UNKNOWN'
}

export type SwitchStateOnTimeChangePayload = {
  __typename?: 'SwitchStateOnTimeChangePayload';
  channelId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  timeInMilliseconds: Scalars['Int'];
};

export enum SwitchSupportedSlotsInternal {
  Advanced = 'ADVANCED',
  Toggle = 'TOGGLE',
  Unknown = 'UNKNOWN'
}

export type TargetAction = {
  __typename?: 'TargetAction';
  index: Scalars['Int'];
  isDefaultAction: Scalars['Boolean'];
  isNotifyAction: Scalars['Boolean'];
};

export type Tariff = {
  __typename?: 'Tariff';
  hoursRanges: Array<HoursRange>;
  ignoreSummerTimeChanges: Scalars['Boolean'];
  kind: TariffKindInternal;
  wholeHolidaysCheaper: Scalars['Boolean'];
  wholeWeekendCheaper: Scalars['Boolean'];
};

export type TariffConfiguration = {
  __typename?: 'TariffConfiguration';
  prices: Array<TierPrice>;
  tariff: TariffKindInternal;
};

export type TariffConfigurationInput = {
  prices: Array<TierPriceInput>;
  tariff: TariffKindInternal;
};

export enum TariffKindInternal {
  Custom = 'CUSTOM',
  EneaDynamic = 'ENEA_DYNAMIC',
  EneaG11 = 'ENEA_G11',
  EneaG12 = 'ENEA_G12',
  EneaG12W = 'ENEA_G12_W',
  EnergaDynamic = 'ENERGA_DYNAMIC',
  EnergaG11 = 'ENERGA_G11',
  EnergaG12 = 'ENERGA_G12',
  EnergaG12R = 'ENERGA_G12_R',
  EnergaG12W = 'ENERGA_G12_W',
  EonDynamic = 'EON_DYNAMIC',
  EonG11 = 'EON_G11',
  EonG12 = 'EON_G12',
  EonG12As = 'EON_G12_AS',
  EonG12W = 'EON_G12_W',
  None = 'NONE',
  PgeDynamic = 'PGE_DYNAMIC',
  PgeG11 = 'PGE_G11',
  PgeG12 = 'PGE_G12',
  PgeG12As = 'PGE_G12_AS',
  PgeG12W = 'PGE_G12_W',
  TauronDynamic = 'TAURON_DYNAMIC',
  TauronG11 = 'TAURON_G11',
  TauronG12 = 'TAURON_G12',
  TauronG12W = 'TAURON_G12_W',
  TauronG13 = 'TAURON_G13',
  TauronG13S = 'TAURON_G13_S'
}

export enum TemperatureUnitTypeInternal {
  Celsius = 'CELSIUS',
  Fahrenheit = 'FAHRENHEIT',
  Unknown = 'UNKNOWN'
}

export type ThresholdEventState = {
  __typename?: 'ThresholdEventState';
  deadTimeInMs: Scalars['Int'];
  hysteresis: Scalars['Float'];
  maxValue?: Maybe<Scalars['Float']>;
  minValue?: Maybe<Scalars['Float']>;
  source: SourceThresholdInternal;
};

export type TierPrice = {
  __typename?: 'TierPrice';
  price: Scalars['Decimal'];
  pricingTier: Scalars['Int'];
};

export type TierPriceInput = {
  price: Scalars['Decimal'];
  pricingTier: Scalars['Int'];
};

export enum TimeZoneKindInternal {
  All = 'ALL',
  Summer = 'SUMMER',
  Unknown = 'UNKNOWN',
  Winter = 'WINTER'
}

export type Trigger = {
  __typename?: 'Trigger';
  actions: Array<TriggerActionRequest>;
  createdAt: TriggerDateTimeResponse;
  executionInfo: Array<TriggerExecutionInfoResponse>;
  installationId: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  onFailureMode: TriggerOnFailureMode;
  priceAndTimeCondition?: Maybe<TriggerPriceAndTimeConditionResponse>;
  stateConditions: Array<TriggerStateConditionRequest>;
  timeCondition?: Maybe<TriggerTimeConditionResponse>;
  triggerId: Scalars['UUID'];
  validationErrors: Array<TriggerValidationErrorModelResponse>;
};

export type TriggerActionRequest = {
  __typename?: 'TriggerActionRequest';
  actionType: TriggerActionType;
  booleanValue?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  integerValue?: Maybe<Scalars['Int']>;
  lightColorValue?: Maybe<TriggerLightColorRequest>;
};

export type TriggerActionRequestInput = {
  actionType: TriggerActionType;
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  integerValue?: InputMaybe<Scalars['Int']>;
  lightColorValue?: InputMaybe<TriggerLightColorRequestInput>;
};

export enum TriggerActionType {
  DelayInSeconds = 'DELAY_IN_SECONDS',
  GateSetDirection = 'GATE_SET_DIRECTION',
  GateSetPosition = 'GATE_SET_POSITION',
  GateTilt = 'GATE_TILT',
  SetBlindDirection = 'SET_BLIND_DIRECTION',
  SetBlindPosition = 'SET_BLIND_POSITION',
  SetGateStepByStep = 'SET_GATE_STEP_BY_STEP',
  SetLightBrightness = 'SET_LIGHT_BRIGHTNESS',
  SetLightColor = 'SET_LIGHT_COLOR',
  SetLightSetOnTime = 'SET_LIGHT_SET_ON_TIME',
  SetLightState = 'SET_LIGHT_STATE',
  SetSwitchSetOnTime = 'SET_SWITCH_SET_ON_TIME',
  SetSwitchState = 'SET_SWITCH_STATE'
}

export enum TriggerConditionType {
  BlindDirectionIs = 'BLIND_DIRECTION_IS',
  BlindPositionIsGreaterThanOrEqualTo = 'BLIND_POSITION_IS_GREATER_THAN_OR_EQUAL_TO',
  BlindPositionIsLessThanOrEqualTo = 'BLIND_POSITION_IS_LESS_THAN_OR_EQUAL_TO',
  GateDirectionIs = 'GATE_DIRECTION_IS',
  GatePositionIsGreaterThanOrEqualTo = 'GATE_POSITION_IS_GREATER_THAN_OR_EQUAL_TO',
  GatePositionIsLessThanOrEqualTo = 'GATE_POSITION_IS_LESS_THAN_OR_EQUAL_TO',
  IsInTimeInterval = 'IS_IN_TIME_INTERVAL',
  LightStateIs = 'LIGHT_STATE_IS',
  SwitchStateIs = 'SWITCH_STATE_IS'
}

export type TriggerDateTimeRequestInput = {
  date: Scalars['LocalDate'];
  time: Scalars['TimeSpan'];
};

export type TriggerDateTimeResponse = {
  __typename?: 'TriggerDateTimeResponse';
  date: Scalars['LocalDate'];
  time: Scalars['TimeSpan'];
};

export type TriggerError = Error & {
  __typename?: 'TriggerError';
  error: TriggerErrorDictionary;
  message: Scalars['String'];
};

export enum TriggerErrorDictionary {
  TriggerDoesNotExist = 'TRIGGER_DOES_NOT_EXIST',
  TriggerDoesNotExistOrCannotBeRun = 'TRIGGER_DOES_NOT_EXIST_OR_CANNOT_BE_RUN',
  Undefined = 'UNDEFINED',
  UserDoesNotHavePermission = 'USER_DOES_NOT_HAVE_PERMISSION'
}

export type TriggerExecutedActionPayload = {
  __typename?: 'TriggerExecutedActionPayload';
  actionType: TriggerActionType;
  id: Scalars['UUID'];
  value: Scalars['String'];
};

export type TriggerExecutedPayload = {
  __typename?: 'TriggerExecutedPayload';
  actions: Array<TriggerExecutedActionPayload>;
  installationId: Scalars['UUID'];
  triggerId: Scalars['UUID'];
};

export type TriggerExecutionActionResultResponse = {
  __typename?: 'TriggerExecutionActionResultResponse';
  actionType: TriggerActionType;
  id: Scalars['UUID'];
  isSuccessful: Scalars['Boolean'];
};

export type TriggerExecutionInfoResponse = {
  __typename?: 'TriggerExecutionInfoResponse';
  actionsResults?: Maybe<Array<TriggerExecutionActionResultResponse>>;
  executedAt?: Maybe<TriggerDateTimeResponse>;
  isSuccessful: Scalars['Boolean'];
  plannedExecutionAt?: Maybe<TriggerDateTimeResponse>;
};

export type TriggerFutureFiresResponse = {
  __typename?: 'TriggerFutureFiresResponse';
  futureFires: Array<TriggerDateTimeResponse>;
};

export type TriggerLightColorRequest = {
  __typename?: 'TriggerLightColorRequest';
  b: Scalars['Int'];
  g: Scalars['Int'];
  r: Scalars['Int'];
};

export type TriggerLightColorRequestInput = {
  b: Scalars['Int'];
  g: Scalars['Int'];
  r: Scalars['Int'];
};

export type TriggerNextFireTimeResponse = {
  __typename?: 'TriggerNextFireTimeResponse';
  nextFireTime?: Maybe<TriggerDateTimeResponse>;
};

export enum TriggerOnFailureMode {
  Continue = 'CONTINUE',
  StopExecution = 'STOP_EXECUTION',
  Undefined = 'UNDEFINED'
}

export type TriggerPriceAndTimeConditionRequestInput = {
  betweenHoursFromInclusive?: InputMaybe<Scalars['Int']>;
  betweenHoursToInclusive?: InputMaybe<Scalars['Int']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekInternal>>;
  endAt?: InputMaybe<TriggerDateTimeRequestInput>;
  everyMonth?: InputMaybe<Scalars['Boolean']>;
  everyYear?: InputMaybe<Scalars['Boolean']>;
  holidaysHandling: HolidaysHandling;
  numberOfCheapestPeriodsInDay?: InputMaybe<Scalars['Int']>;
  priceGreaterThanOrEqual?: InputMaybe<Scalars['Decimal']>;
  priceLesserThanOrEqual?: InputMaybe<Scalars['Decimal']>;
  selectedBuckets?: InputMaybe<Array<SelectedBucketInput>>;
  startAt: TriggerDateTimeRequestInput;
  subType: PriceTriggerSubType;
  targetExecutionCount?: InputMaybe<Scalars['Int']>;
};

export type TriggerPriceAndTimeConditionResponse = {
  __typename?: 'TriggerPriceAndTimeConditionResponse';
  betweenHoursFromInclusive?: Maybe<Scalars['Int']>;
  betweenHoursToInclusive?: Maybe<Scalars['Int']>;
  currentExecutionCount?: Maybe<Scalars['Int']>;
  daysOfWeek?: Maybe<Array<DayOfWeekInternal>>;
  endAt?: Maybe<TriggerDateTimeResponse>;
  everyMonth?: Maybe<Scalars['Boolean']>;
  everyYear?: Maybe<Scalars['Boolean']>;
  holidaysHandling: HolidaysHandling;
  nextFireTime?: Maybe<TriggerDateTimeResponse>;
  numberOfCheapestPeriodsInDay?: Maybe<Scalars['Int']>;
  priceGreaterThanOrEqual?: Maybe<Scalars['Decimal']>;
  priceLesserThanOrEqual?: Maybe<Scalars['Decimal']>;
  selectedBuckets?: Maybe<Array<SelectedBucket>>;
  startAt: TriggerDateTimeResponse;
  subType: PriceTriggerSubType;
  targetExecutionCount?: Maybe<Scalars['Int']>;
};

export type TriggerStateConditionRequest = {
  __typename?: 'TriggerStateConditionRequest';
  booleanValue?: Maybe<Scalars['Boolean']>;
  conditionType: TriggerConditionType;
  id: Scalars['UUID'];
  integerValue?: Maybe<Scalars['Int']>;
  timeIntervalValue?: Maybe<TriggerTimeIntervalRequest>;
};

export type TriggerStateConditionRequestInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  conditionType: TriggerConditionType;
  id: Scalars['UUID'];
  integerValue?: InputMaybe<Scalars['Int']>;
  timeIntervalValue?: InputMaybe<TriggerTimeIntervalRequestInput>;
};

export type TriggerTimeConditionRequestInput = {
  atSunrise?: InputMaybe<Scalars['Boolean']>;
  atSunset?: InputMaybe<Scalars['Boolean']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekInternal>>;
  endAt?: InputMaybe<TriggerDateTimeRequestInput>;
  everyMonth?: InputMaybe<Scalars['Boolean']>;
  everyYear?: InputMaybe<Scalars['Boolean']>;
  holidaysHandling: HolidaysHandling;
  startAt: TriggerDateTimeRequestInput;
  sunriseAdvance?: InputMaybe<Scalars['TimeSpan']>;
  sunriseDelay?: InputMaybe<Scalars['TimeSpan']>;
  sunsetAdvance?: InputMaybe<Scalars['TimeSpan']>;
  sunsetDelay?: InputMaybe<Scalars['TimeSpan']>;
  targetExecutionCount?: InputMaybe<Scalars['Int']>;
  timeOfDay?: InputMaybe<Scalars['TimeSpan']>;
};

export type TriggerTimeConditionResponse = {
  __typename?: 'TriggerTimeConditionResponse';
  atSunrise?: Maybe<Scalars['Boolean']>;
  atSunset?: Maybe<Scalars['Boolean']>;
  currentExecutionCount?: Maybe<Scalars['Int']>;
  daysOfWeek?: Maybe<Array<DayOfWeekInternal>>;
  endAt?: Maybe<TriggerDateTimeResponse>;
  everyMonth?: Maybe<Scalars['Boolean']>;
  everyYear?: Maybe<Scalars['Boolean']>;
  holidaysHandling: HolidaysHandling;
  nextFireTime?: Maybe<TriggerDateTimeResponse>;
  startAt: TriggerDateTimeResponse;
  sunriseAdvance?: Maybe<Scalars['TimeSpan']>;
  sunriseDelay?: Maybe<Scalars['TimeSpan']>;
  sunsetAdvance?: Maybe<Scalars['TimeSpan']>;
  sunsetDelay?: Maybe<Scalars['TimeSpan']>;
  targetExecutionCount?: Maybe<Scalars['Int']>;
  timeOfDay?: Maybe<Scalars['TimeSpan']>;
};

export type TriggerTimeIntervalRequest = {
  __typename?: 'TriggerTimeIntervalRequest';
  daysOfWeek?: Maybe<Array<DayOfWeekInternal>>;
  timeFrom?: Maybe<Scalars['TimeSpan']>;
  timeTo?: Maybe<Scalars['TimeSpan']>;
};

export type TriggerTimeIntervalRequestInput = {
  daysOfWeek?: InputMaybe<Array<DayOfWeekInternal>>;
  timeFrom?: InputMaybe<Scalars['TimeSpan']>;
  timeTo?: InputMaybe<Scalars['TimeSpan']>;
};

export type TriggerValidationErrorModelResponse = {
  __typename?: 'TriggerValidationErrorModelResponse';
  errorType: TriggerValidationErrorType;
  partType: TriggerValidationPartType;
  value: Scalars['String'];
};

export enum TriggerValidationErrorType {
  ChannelNotFound = 'CHANNEL_NOT_FOUND',
  CircularExecution = 'CIRCULAR_EXECUTION',
  General = 'GENERAL'
}

export enum TriggerValidationPartType {
  Action = 'ACTION',
  StateCondition = 'STATE_CONDITION'
}

export type TrimmedUserResponse = {
  __typename?: 'TrimmedUserResponse';
  email: Scalars['String'];
  exists: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastActivity?: Maybe<Scalars['DateTime']>;
  profileImage?: Maybe<Image>;
};

export type UnschedulePriceNotificationInput = {
  notificationScheduleId: Scalars['UUID'];
};

export type UnschedulePriceNotificationPayload = {
  __typename?: 'UnschedulePriceNotificationPayload';
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type UpdateGroupError = GroupError;

export type UpdateGroupInput = {
  groupId: Scalars['UUID'];
  groupItems: Array<GroupItemRequestItemInput>;
  iconName?: InputMaybe<Scalars['String']>;
  installationId: Scalars['UUID'];
  name: Scalars['String'];
};

export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  errors?: Maybe<Array<UpdateGroupError>>;
  result?: Maybe<Result>;
};

export type UpdateNotificationPermissionsRequestInput = {
  automationEmail: Scalars['Boolean'];
  automationInApp: Scalars['Boolean'];
  automationPush: Scalars['Boolean'];
  channelsEmail: Scalars['Boolean'];
  channelsInApp: Scalars['Boolean'];
  channelsPush: Scalars['Boolean'];
  sharingEmail: Scalars['Boolean'];
  sharingPush: Scalars['Boolean'];
};

export type UpdateNotificationSettingsInput = {
  appScopedPermissions: Scalars['Int'];
  emailNotificationsEnabled: Scalars['Boolean'];
  installationId: Scalars['UUID'];
  installationScopedPermissions: Scalars['Int'];
  pushNotificationsEnabled: Scalars['Boolean'];
};

export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  result?: Maybe<Result>;
};

export type UpdateTariffConfigurationsError = ChannelError;

export type UpdateTariffConfigurationsInput = {
  channelId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  tariffConfigurations: Array<TariffConfigurationInput>;
};

export type UpdateTariffConfigurationsPayload = {
  __typename?: 'UpdateTariffConfigurationsPayload';
  errors?: Maybe<Array<UpdateTariffConfigurationsError>>;
  meterSharedChannelSettings?: Maybe<MeterSharedChannelSettings>;
};

export type UpdateTriggerNameError = TriggerError;

export type UpdateTriggerNameInput = {
  installationId: Scalars['UUID'];
  name: Scalars['String'];
  triggerId: Scalars['UUID'];
};

export type UpdateTriggerNamePayload = {
  __typename?: 'UpdateTriggerNamePayload';
  errors?: Maybe<Array<UpdateTriggerNameError>>;
  result?: Maybe<Result>;
};

export type UpdateUserLanguageError = UserProfileError;

export type UpdateUserLanguageInput = {
  language: Scalars['String'];
};

export type UpdateUserLanguagePayload = {
  __typename?: 'UpdateUserLanguagePayload';
  errors?: Maybe<Array<UpdateUserLanguageError>>;
  result?: Maybe<Result>;
};

export type UserAction = {
  __typename?: 'UserAction';
  action: Action;
  favouritePositions?: Maybe<Array<FavouritePosition>>;
  iconName: Scalars['String'];
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type UserActionFilterInput = {
  action?: InputMaybe<ActionFilterInput>;
  and?: InputMaybe<Array<UserActionFilterInput>>;
  favouritePositions?: InputMaybe<ListFilterInputTypeOfFavouritePositionFilterInput>;
  iconName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserActionFilterInput>>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserActionSortInput = {
  action?: InputMaybe<ActionSortInput>;
  iconName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UserActionsCollectionSegment = {
  __typename?: 'UserActionsCollectionSegment';
  cacheInfo?: Maybe<CacheInfo>;
  /** A flattened list of the items. */
  items?: Maybe<Array<UserAction>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type UserChannel = {
  __typename?: 'UserChannel';
  alias: Scalars['String'];
  channelType: ChannelTypeInternal;
  currentFirmwareVersion?: Maybe<Scalars['String']>;
  deviceId: Scalars['UUID'];
  favouritePositions: Array<FavouritePosition>;
  grantedUses?: Maybe<Scalars['Int']>;
  iconName: Scalars['String'];
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  isVisible: Scalars['Boolean'];
  payload?: Maybe<ChannelStateBaseResponse>;
  personalization: UserChannelPersonalization;
  sharedChannelSettings?: Maybe<SharedChannelSettings>;
  sharedChannelSettingsId?: Maybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  usesCounter: Scalars['Int'];
};

export type UserChannelFilterInput = {
  alias?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<UserChannelFilterInput>>;
  channelType?: InputMaybe<ChannelTypeInternalOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  favouritePositions?: InputMaybe<ListFilterInputTypeOfFavouritePositionFilterInput>;
  iconName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  isSwitchFromGateOriginated?: InputMaybe<BooleanOperationFilterInput>;
  isVisible?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserChannelFilterInput>>;
  personalization?: InputMaybe<UserChannelPersonalizationFilterInput>;
  sharedChannelSettings?: InputMaybe<SharedChannelSettingsFilterInput>;
  sharedChannelSettingsId?: InputMaybe<UuidOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
  usesCounter?: InputMaybe<IntOperationFilterInput>;
};

export type UserChannelPersonalization = {
  onEventAction?: Maybe<NotificationSenderType>;
  type: ChannelTypeInternal;
};

export type UserChannelPersonalizationFilterInput = {
  and?: InputMaybe<Array<UserChannelPersonalizationFilterInput>>;
  onEventAction?: InputMaybe<NullableOfNotificationSenderTypeOperationFilterInput>;
  or?: InputMaybe<Array<UserChannelPersonalizationFilterInput>>;
  type?: InputMaybe<ChannelTypeInternalOperationFilterInput>;
};

export type UserChannelPersonalizationSortInput = {
  onEventAction?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type UserChannelSortInput = {
  alias?: InputMaybe<SortEnumType>;
  channelType?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  iconName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  isSwitchFromGateOriginated?: InputMaybe<SortEnumType>;
  isVisible?: InputMaybe<SortEnumType>;
  personalization?: InputMaybe<UserChannelPersonalizationSortInput>;
  sharedChannelSettings?: InputMaybe<SharedChannelSettingsSortInput>;
  sharedChannelSettingsId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  usesCounter?: InputMaybe<SortEnumType>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  payload?: Maybe<DeviceStateModel>;
  userId: Scalars['UUID'];
};

export type UserDeviceFilterInput = {
  and?: InputMaybe<Array<UserDeviceFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserDeviceFilterInput>>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserDeviceSortInput = {
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  group: Group;
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
  order: Scalars['Int'];
  userGroupItems: Array<UserGroupItem>;
  userId: Scalars['UUID'];
};

export type UserGroupFilterInput = {
  and?: InputMaybe<Array<UserGroupFilterInput>>;
  group?: InputMaybe<GroupFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserGroupFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  userGroupItems?: InputMaybe<ListFilterInputTypeOfUserGroupItemFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserGroupItem = {
  __typename?: 'UserGroupItem';
  groupId: Scalars['UUID'];
  installationId: Scalars['UUID'];
  itemId: Scalars['UUID'];
  order: Scalars['Int'];
  userId: Scalars['UUID'];
};

export type UserGroupItemFilterInput = {
  and?: InputMaybe<Array<UserGroupItemFilterInput>>;
  groupId?: InputMaybe<UuidOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  itemId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserGroupItemFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserGroupSortInput = {
  group?: InputMaybe<GroupSortInput>;
  id?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UserGroupsCollectionSegment = {
  __typename?: 'UserGroupsCollectionSegment';
  cacheInfo?: Maybe<CacheInfo>;
  /** A flattened list of the items. */
  items?: Maybe<Array<UserGroup>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type UserInstallation = {
  __typename?: 'UserInstallation';
  accessType: InstallationAccessType;
  createdAt: Scalars['DateTime'];
  externalPayload?: Maybe<ExternalInstallationPayload>;
  hexColor: Scalars['String'];
  iconName: Scalars['String'];
  installationId: Scalars['UUID'];
  integrationType: IntegrationType;
  isSelected: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  partialAccess: Scalars['Boolean'];
  payload?: Maybe<InstallationModelResponse>;
  previewTariff?: Maybe<TariffKindInternal>;
  sharedFrom?: Maybe<Scalars['DateTime']>;
  sharedUntil?: Maybe<Scalars['DateTime']>;
  userId: Scalars['UUID'];
};

export type UserInstallationFilterInput = {
  accessType?: InputMaybe<InstallationAccessTypeOperationFilterInput>;
  and?: InputMaybe<Array<UserInstallationFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  externalInstallation?: InputMaybe<ExternalInstallationFilterInput>;
  hexColor?: InputMaybe<StringOperationFilterInput>;
  iconName?: InputMaybe<StringOperationFilterInput>;
  installationId?: InputMaybe<UuidOperationFilterInput>;
  integrationType?: InputMaybe<IntegrationTypeOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserInstallationFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  partialAccess?: InputMaybe<BooleanOperationFilterInput>;
  previewTariff?: InputMaybe<NullableOfTariffKindInternalOperationFilterInput>;
  sharedFrom?: InputMaybe<DateTimeOperationFilterInput>;
  sharedUntil?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type UserInstallationSortInput = {
  accessType?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  externalInstallation?: InputMaybe<ExternalInstallationSortInput>;
  hexColor?: InputMaybe<SortEnumType>;
  iconName?: InputMaybe<SortEnumType>;
  installationId?: InputMaybe<SortEnumType>;
  integrationType?: InputMaybe<SortEnumType>;
  isSelected?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  partialAccess?: InputMaybe<SortEnumType>;
  previewTariff?: InputMaybe<SortEnumType>;
  sharedFrom?: InputMaybe<SortEnumType>;
  sharedUntil?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UserInstallationsCollectionSegment = {
  __typename?: 'UserInstallationsCollectionSegment';
  cacheInfo?: Maybe<CacheInfo>;
  /** A flattened list of the items. */
  items?: Maybe<Array<UserInstallation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export enum UserPermissionType {
  ActionsCreate = 'ACTIONS_CREATE',
  ActionsEdit = 'ACTIONS_EDIT',
  ActionsRemove = 'ACTIONS_REMOVE',
  AddRemoveChannelForMultipleGroups = 'ADD_REMOVE_CHANNEL_FOR_MULTIPLE_GROUPS',
  AddRemoveChannelForMultiplePublicGroups = 'ADD_REMOVE_CHANNEL_FOR_MULTIPLE_PUBLIC_GROUPS',
  ChangeGeolocation = 'CHANGE_GEOLOCATION',
  ChangeTimeZone = 'CHANGE_TIME_ZONE',
  ChangeUserRole = 'CHANGE_USER_ROLE',
  ChannelConfiguration = 'CHANNEL_CONFIGURATION',
  ChannelShare = 'CHANNEL_SHARE',
  ConfigureDashboardPreviewTariff = 'CONFIGURE_DASHBOARD_PREVIEW_TARIFF',
  DeleteInstallation = 'DELETE_INSTALLATION',
  DeviceAdd = 'DEVICE_ADD',
  DeviceList = 'DEVICE_LIST',
  DeviceRemove = 'DEVICE_REMOVE',
  GateHistory = 'GATE_HISTORY',
  GroupCreate = 'GROUP_CREATE',
  GroupEdit = 'GROUP_EDIT',
  GroupRemove = 'GROUP_REMOVE',
  GroupShare = 'GROUP_SHARE',
  OwnActionsEdit = 'OWN_ACTIONS_EDIT',
  OwnActionsRemove = 'OWN_ACTIONS_REMOVE',
  PassOwnership = 'PASS_OWNERSHIP',
  PublicGroupAdd = 'PUBLIC_GROUP_ADD',
  PublicGroupEdit = 'PUBLIC_GROUP_EDIT',
  PublicGroupRemove = 'PUBLIC_GROUP_REMOVE',
  RemoveUserFromInstallation = 'REMOVE_USER_FROM_INSTALLATION',
  ShareInstallation = 'SHARE_INSTALLATION',
  SignOffMyselfFromInstallation = 'SIGN_OFF_MYSELF_FROM_INSTALLATION',
  TriggersCreate = 'TRIGGERS_CREATE',
  TriggersDelete = 'TRIGGERS_DELETE',
  TriggersEdit = 'TRIGGERS_EDIT',
  Unknown = 'UNKNOWN'
}

export type UserProfile = {
  __typename?: 'UserProfile';
  appScopedNotificationsPermission?: Maybe<Scalars['Int']>;
  automationEmailNotificationPermission: Scalars['Boolean'];
  automationInAppNotificationPermission: Scalars['Boolean'];
  automationPushNotificationPermission: Scalars['Boolean'];
  channelsEmailNotificationPermission: Scalars['Boolean'];
  channelsInAppNotificationPermission: Scalars['Boolean'];
  channelsPushNotificationPermission: Scalars['Boolean'];
  countOfUnreadNotifications?: Maybe<Scalars['Int']>;
  currentInstallationScopedNotificationsPermission?: Maybe<Scalars['Int']>;
  defaultAppScopedValue: Scalars['Int'];
  defaultInstallationScopedValue: Scalars['Int'];
  displayedLearningScenarios?: Maybe<Scalars['LearningScenario']>;
  emailNotificationsEnabled: Scalars['Boolean'];
  pushNotificationsEnabled: Scalars['Boolean'];
  sharingEmailNotificationPermission: Scalars['Boolean'];
  sharingPushNotificationPermission: Scalars['Boolean'];
  userId: Scalars['UUID'];
  userLanguage: Scalars['String'];
};


export type UserProfileCurrentInstallationScopedNotificationsPermissionArgs = {
  installationId?: InputMaybe<Scalars['UUID']>;
};

export type UserProfileError = Error & {
  __typename?: 'UserProfileError';
  error: UserProfileErrorDictionary;
  message: Scalars['String'];
};

export enum UserProfileErrorDictionary {
  Undefined = 'UNDEFINED',
  UnsupportedLanguage = 'UNSUPPORTED_LANGUAGE',
  UserDoesNotExist = 'USER_DOES_NOT_EXIST'
}

export type UserResponse = {
  __typename?: 'UserResponse';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  profileImage?: Maybe<Image>;
  username: Scalars['String'];
};

export type UserServiceError = Error & {
  __typename?: 'UserServiceError';
  message: Scalars['String'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type VectorMeasurementResponseItem = {
  __typename?: 'VectorMeasurementResponseItem';
  index: Scalars['Int'];
  type: Scalars['Int'];
  value: Scalars['Float'];
};

export enum VectorParameterTypeInternal {
  ActivePower = 'ACTIVE_POWER',
  ApparentEnergy = 'APPARENT_ENERGY',
  ApparentPower = 'APPARENT_POWER',
  Current = 'CURRENT',
  ForwardActiveEnergy = 'FORWARD_ACTIVE_ENERGY',
  ForwardActiveEnergyDaily = 'FORWARD_ACTIVE_ENERGY_DAILY',
  ForwardActiveEnergyDailyPeriod1 = 'FORWARD_ACTIVE_ENERGY_DAILY_PERIOD1',
  ForwardActiveEnergyDailyPeriod2 = 'FORWARD_ACTIVE_ENERGY_DAILY_PERIOD2',
  ForwardActiveEnergyDailyPeriod3 = 'FORWARD_ACTIVE_ENERGY_DAILY_PERIOD3',
  ForwardActiveEnergyMonthly = 'FORWARD_ACTIVE_ENERGY_MONTHLY',
  ForwardActiveEnergyMonthlyPeriod1 = 'FORWARD_ACTIVE_ENERGY_MONTHLY_PERIOD1',
  ForwardActiveEnergyMonthlyPeriod2 = 'FORWARD_ACTIVE_ENERGY_MONTHLY_PERIOD2',
  ForwardActiveEnergyMonthlyPeriod3 = 'FORWARD_ACTIVE_ENERGY_MONTHLY_PERIOD3',
  ForwardActiveEnergyPeriod1 = 'FORWARD_ACTIVE_ENERGY_PERIOD1',
  ForwardActiveEnergyPeriod2 = 'FORWARD_ACTIVE_ENERGY_PERIOD2',
  ForwardActiveEnergyPeriod3 = 'FORWARD_ACTIVE_ENERGY_PERIOD3',
  ForwardActiveEnergyWeekly = 'FORWARD_ACTIVE_ENERGY_WEEKLY',
  ForwardActiveEnergyWeeklyPeriod1 = 'FORWARD_ACTIVE_ENERGY_WEEKLY_PERIOD1',
  ForwardActiveEnergyWeeklyPeriod2 = 'FORWARD_ACTIVE_ENERGY_WEEKLY_PERIOD2',
  ForwardActiveEnergyWeeklyPeriod3 = 'FORWARD_ACTIVE_ENERGY_WEEKLY_PERIOD3',
  ForwardReactiveEnergy = 'FORWARD_REACTIVE_ENERGY',
  FundamentalPower = 'FUNDAMENTAL_POWER',
  HarmonicPower = 'HARMONIC_POWER',
  PhaseAngle = 'PHASE_ANGLE',
  PowerFactor = 'POWER_FACTOR',
  ReactivePower = 'REACTIVE_POWER',
  ReverseActiveEnergy = 'REVERSE_ACTIVE_ENERGY',
  ReverseReactiveEnergy = 'REVERSE_REACTIVE_ENERGY',
  Unknown = 'UNKNOWN',
  Voltage = 'VOLTAGE'
}

export type Version = {
  __typename?: 'Version';
  asString?: Maybe<Scalars['String']>;
  build: Scalars['Int'];
  major: Scalars['Int'];
  minor: Scalars['Int'];
};

export enum VersionedFeatureType {
  DeviceBindingsV2 = 'DEVICE_BINDINGS_V2',
  GateAlerts = 'GATE_ALERTS',
  GetRssi = 'GET_RSSI',
  MonoBiModeConfig = 'MONO_BI_MODE_CONFIG',
  OptimizerTariffs = 'OPTIMIZER_TARIFFS',
  RestartSettingsToDefault = 'RESTART_SETTINGS_TO_DEFAULT',
  TariffPersistenceOnDevice = 'TARIFF_PERSISTENCE_ON_DEVICE',
  Unknown = 'UNKNOWN'
}

export type VersionedFeatures = {
  __typename?: 'VersionedFeatures';
  feature: VersionedFeatureType;
  minVersion: Version;
};

export type VoltageThreshold = {
  __typename?: 'VoltageThreshold';
  index: Scalars['Int'];
  value: Scalars['Float'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  from: Scalars['TimeSpan'];
  to: Scalars['TimeSpan'];
};

export enum WorkingModeTypeInternal {
  Cooling = 'COOLING',
  Heating = 'HEATING',
  Unknown = 'UNKNOWN'
}

export type SetFavouriteActionPositionsMutationVariables = Exact<{
  input: SetActionFavouritePositionRequestInput;
}>;


export type SetFavouriteActionPositionsMutation = { __typename?: 'Mutation', setFavouriteActionPositions: { __typename?: 'Result', ok: boolean } };

export type CreateBasicActionMutationVariables = Exact<{
  input: CreateBasicActionRequestInput;
}>;


export type CreateBasicActionMutation = { __typename?: 'Mutation', createBasicAction: { __typename?: 'IdResponse', id: any } };

export type CreateAdvancedActionMutationVariables = Exact<{
  input: CreateAdvancedActionRequestInput;
}>;


export type CreateAdvancedActionMutation = { __typename?: 'Mutation', createAdvancedAction: { __typename?: 'IdResponse', id: any } };

export type EditActionMutationVariables = Exact<{
  input: EditActionInput;
}>;


export type EditActionMutation = { __typename?: 'Mutation', editAction: { __typename?: 'EditActionPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'ActionError', error: ActionErrorDictionary, message: string }> | null } };

export type DeleteActionMutationVariables = Exact<{
  input: DeleteActionInput;
}>;


export type DeleteActionMutation = { __typename?: 'Mutation', deleteAction: { __typename?: 'DeleteActionPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'ActionError', error: ActionErrorDictionary, message: string }> | null } };

export type ChangeChannelsVisibilityMutationVariables = Exact<{
  input: ChangeChannelsVisibilityInput;
}>;


export type ChangeChannelsVisibilityMutation = { __typename?: 'Mutation', changeChannelsVisibility: { __typename?: 'ChangeChannelsVisibilityPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'ChannelError', error: ChannelErrorDictionary, message: string }> | null } };

export type SetFavouriteChannelPositionsMutationVariables = Exact<{
  input: SetChannelFavouritePositionRequestInput;
}>;


export type SetFavouriteChannelPositionsMutation = { __typename?: 'Mutation', setFavouriteChannelPositions: { __typename?: 'Result', ok: boolean } };

export type SetChannelIconNameMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  iconName: Scalars['String'];
}>;


export type SetChannelIconNameMutation = { __typename?: 'Mutation', setChannelIconName: { __typename?: 'Result', ok: boolean } };

export type EditUserChannelMutationVariables = Exact<{
  input: EditUserChannelInput;
}>;


export type EditUserChannelMutation = { __typename?: 'Mutation', editUserChannel: { __typename?: 'EditUserChannelPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'ChannelError', error: ChannelErrorDictionary, message: string }> | null } };

export type SetQuickControlMutationVariables = Exact<{
  input: SetQuickControlInput;
}>;


export type SetQuickControlMutation = { __typename?: 'Mutation', setQuickControl: { __typename?: 'SetQuickControlPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'ChannelError', error: ChannelErrorDictionary, message: string }> | null } };

export type UpdateTariffConfigurationsMutationVariables = Exact<{
  input: UpdateTariffConfigurationsInput;
}>;


export type UpdateTariffConfigurationsMutation = { __typename?: 'Mutation', updateTariffConfigurations: { __typename?: 'UpdateTariffConfigurationsPayload', meterSharedChannelSettings?: { __typename?: 'MeterSharedChannelSettings', id: any, tariffConfigurations: Array<{ __typename?: 'TariffConfiguration', tariff: TariffKindInternal, prices: Array<{ __typename?: 'TierPrice', price: any, pricingTier: number }> }> } | null, errors?: Array<{ __typename?: 'ChannelError', message: string, error: ChannelErrorDictionary }> | null } };

export type ChangeOnEventActionMutationVariables = Exact<{
  input: ChangeOnEventActionInput;
}>;


export type ChangeOnEventActionMutation = { __typename?: 'Mutation', changeOnEventAction: { __typename?: 'ChangeOnEventActionPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'ChannelError', error: ChannelErrorDictionary, message: string }> | null } };

export type RemoveDeviceMutationVariables = Exact<{
  input: RemoveDeviceInput;
}>;


export type RemoveDeviceMutation = { __typename?: 'Mutation', removeDevice: { __typename?: 'RemoveDevicePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'DeviceError', error: DeviceErrorDictionary, message: string }> | null } };

export type ChangeDeviceNameMutationVariables = Exact<{
  installationId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type ChangeDeviceNameMutation = { __typename?: 'Mutation', changeDeviceName: { __typename?: 'CorrelationResponse', publishStatus: PublishStatus, correlationId: any } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'CreateGroupPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'GroupError', error: GroupErrorDictionary, message: string }> | null } };

export type AddToFavouritesMutationVariables = Exact<{
  input: FavouritesItemRequestInput;
}>;


export type AddToFavouritesMutation = { __typename?: 'Mutation', addToFavourites: { __typename?: 'IdResponse', id: any } };

export type RemoveFromFavouritesMutationVariables = Exact<{
  input: FavouritesItemRequestInput;
}>;


export type RemoveFromFavouritesMutation = { __typename?: 'Mutation', removeFromFavourites: { __typename?: 'IdResponse', id: any } };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'UpdateGroupPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'GroupError', error: GroupErrorDictionary, message: string }> | null } };

export type RemoveGroupMutationVariables = Exact<{
  input: RemoveGroupInput;
}>;


export type RemoveGroupMutation = { __typename?: 'Mutation', removeGroup: { __typename?: 'RemoveGroupPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'GroupError', error: GroupErrorDictionary, message: string }> | null } };

export type ChangeGroupsOrderMutationVariables = Exact<{
  input: ChangeGroupOrderRequestInput;
}>;


export type ChangeGroupsOrderMutation = { __typename?: 'Mutation', changeGroupsOrder: { __typename?: 'IdResponse', id: any } };

export type ChangeGroupItemsOrderMutationVariables = Exact<{
  input: ChangeGroupItemsOrderRequestInput;
}>;


export type ChangeGroupItemsOrderMutation = { __typename?: 'Mutation', changeGroupItemsOrder: { __typename?: 'IdResponse', id: any } };

export type ModifyGroupItemInMultipleGroupsMutationVariables = Exact<{
  input: ModifyGroupItemInMultipleGroupsInput;
}>;


export type ModifyGroupItemInMultipleGroupsMutation = { __typename?: 'Mutation', modifyGroupItemInMultipleGroups: { __typename?: 'ModifyGroupItemInMultipleGroupsPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'GroupError', error: GroupErrorDictionary, message: string }> | null } };

export type CreateInstallationMutationVariables = Exact<{
  input: CreateInstallationRequestInput;
}>;


export type CreateInstallationMutation = { __typename?: 'Mutation', createInstallation: { __typename?: 'UserInstallation', installationId: any, name: string, hexColor: string, iconName: string, isSelected: boolean, accessType: InstallationAccessType, integrationType: IntegrationType, payload?: { __typename?: 'InstallationModelResponse', timeZone?: string | null, installationId: any, coordinates?: { __typename?: 'InstallationCoordinatesResponse', latitude: number, longitude: number } | null } | null, externalPayload?: { __typename?: 'ExalusInstallationPayload', installationId: any, pin: string, serialNumber: string } | null } };

export type AddMultipleInstallationsAfterMigrationMutationVariables = Exact<{
  inputs: Array<CreateInstallationRequestInput> | CreateInstallationRequestInput;
}>;


export type AddMultipleInstallationsAfterMigrationMutation = { __typename?: 'Mutation', addMultipleInstallationsAfterMigration: Array<{ __typename?: 'UserInstallation', installationId: any, name: string, hexColor: string, iconName: string, isSelected: boolean, accessType: InstallationAccessType, integrationType: IntegrationType, payload?: { __typename?: 'InstallationModelResponse', timeZone?: string | null, installationId: any, coordinates?: { __typename?: 'InstallationCoordinatesResponse', latitude: number, longitude: number } | null } | null, externalPayload?: { __typename?: 'ExalusInstallationPayload', installationId: any, pin: string, serialNumber: string } | null }> };

export type ChangeInstallationNameMutationVariables = Exact<{
  input: ChangeInstallationNameInput;
}>;


export type ChangeInstallationNameMutation = { __typename?: 'Mutation', changeInstallationName: { __typename?: 'ChangeInstallationNamePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InstallationError', error: InstallationErrorDictionary, message: string }> | null } };

export type ChangeInstallationIconMutationVariables = Exact<{
  input: ChangeInstallationIconInput;
}>;


export type ChangeInstallationIconMutation = { __typename?: 'Mutation', changeInstallationIcon: { __typename?: 'ChangeInstallationIconPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InstallationError', error: InstallationErrorDictionary, message: string }> | null } };

export type ChangeInstallationColorMutationVariables = Exact<{
  input: ChangeInstallationColorInput;
}>;


export type ChangeInstallationColorMutation = { __typename?: 'Mutation', changeInstallationColor: { __typename?: 'ChangeInstallationColorPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InstallationError', error: InstallationErrorDictionary, message: string }> | null } };

export type DeleteInstallationMutationVariables = Exact<{
  input: DeleteInstallationInput;
}>;


export type DeleteInstallationMutation = { __typename?: 'Mutation', deleteInstallation: { __typename?: 'DeleteInstallationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InstallationError', error: InstallationErrorDictionary, message: string }> | null } };

export type RemoveUserFromInstallationMutationVariables = Exact<{
  input: RemoveUserFromInstallationInput;
}>;


export type RemoveUserFromInstallationMutation = { __typename?: 'Mutation', removeUserFromInstallation: { __typename?: 'RemoveUserFromInstallationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', message: string, error: InvitationErrorDictionary }> | null } };

export type SelectInstallationMutationVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type SelectInstallationMutation = { __typename?: 'Mutation', selectInstallation: { __typename?: 'CurrentInstallation', installationId: any, brokerUrl: string } };

export type ChangeInstallationOrderMutationVariables = Exact<{
  input: ChangeInstallationsOrderRequestInput;
}>;


export type ChangeInstallationOrderMutation = { __typename?: 'Mutation', changeInstallationOrder: { __typename?: 'Result', ok: boolean } };

export type ChangeGeolocationMutationVariables = Exact<{
  input: ChangeGeolocationInput;
}>;


export type ChangeGeolocationMutation = { __typename?: 'Mutation', changeGeolocation: { __typename?: 'ChangeGeolocationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename: 'InstallationAttachmentError', message: string, installationId: any, validBrokerUrl?: string | null } | { __typename: 'InstallationError', message: string, error: InstallationErrorDictionary }> | null } };

export type ChangeTimeZoneMutationVariables = Exact<{
  input: ChangeTimeZoneInput;
}>;


export type ChangeTimeZoneMutation = { __typename?: 'Mutation', changeTimeZone: { __typename?: 'ChangeTimeZonePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename: 'InstallationAttachmentError', message: string, installationId: any, validBrokerUrl?: string | null } | { __typename: 'InstallationError', message: string, error: InstallationErrorDictionary }> | null } };

export type IntroduceMutationVariables = Exact<{ [key: string]: never; }>;


export type IntroduceMutation = { __typename?: 'Mutation', introduce: { __typename?: 'IdResponse', id: any } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'AcceptInvitationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type RejectInvitationMutationVariables = Exact<{
  input: RejectInvitationInput;
}>;


export type RejectInvitationMutation = { __typename?: 'Mutation', rejectInvitation: { __typename?: 'RejectInvitationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type CancelInvitationMutationVariables = Exact<{
  input: CancelInvitationInput;
}>;


export type CancelInvitationMutation = { __typename?: 'Mutation', cancelInvitation: { __typename?: 'CancelInvitationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type PushBluetoothLogMutationVariables = Exact<{
  input: PushBluetoothLogInput;
}>;


export type PushBluetoothLogMutation = { __typename?: 'Mutation', pushBluetoothLog: { __typename?: 'PushBluetoothLogPayload', boolean?: boolean | null } };

export type NotificationMarkAsDisplayedMutationVariables = Exact<{
  correlationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type NotificationMarkAsDisplayedMutation = { __typename?: 'Mutation', markAsDisplayed: { __typename?: 'Result', ok: boolean } };

export type NotificationMarkAllAsDisplayedMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationMarkAllAsDisplayedMutation = { __typename?: 'Mutation', markAllAsDisplayed: { __typename?: 'Result', ok: boolean } };

export type NotificationMarkAsHiddenMutationVariables = Exact<{
  correlationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type NotificationMarkAsHiddenMutation = { __typename?: 'Mutation', markAsHidden: { __typename?: 'Result', ok: boolean } };

export type NotificationMarkAllAsHiddenMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationMarkAllAsHiddenMutation = { __typename?: 'Mutation', markAllAsHidden: { __typename?: 'Result', ok: boolean } };

export type RegisterPushNotificationReceiverMutationVariables = Exact<{
  input: RegisterPushReceiverRequestInput;
}>;


export type RegisterPushNotificationReceiverMutation = { __typename?: 'Mutation', registerPushNotificationReceiver: { __typename?: 'Result', ok: boolean } };

export type DemoPushMutationVariables = Exact<{ [key: string]: never; }>;


export type DemoPushMutation = { __typename?: 'Mutation', demoPush: string };

export type ShareMutationVariables = Exact<{
  input: ShareInput;
}>;


export type ShareMutation = { __typename?: 'Mutation', share: { __typename?: 'SharePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type PassOwnershipToInstallationMutationVariables = Exact<{
  input: PassOwnershipToInstallationInput;
}>;


export type PassOwnershipToInstallationMutation = { __typename?: 'Mutation', passOwnershipToInstallation: { __typename?: 'PassOwnershipToInstallationPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type ChangeUserRoleMutationVariables = Exact<{
  input: ChangeUserRoleInput;
}>;


export type ChangeUserRoleMutation = { __typename?: 'Mutation', changeUserRole: { __typename?: 'ChangeUserRolePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', error: InvitationErrorDictionary, message: string }> | null } };

export type ModifyUserAccessesMutationVariables = Exact<{
  input: ModifyUserAccessesInput;
}>;


export type ModifyUserAccessesMutation = { __typename?: 'Mutation', modifyUserAccesses: { __typename?: 'ModifyUserAccessesPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'InvitationError', message: string, error: InvitationErrorDictionary }> | null } };

export type CreateTimeTriggerMutationVariables = Exact<{
  input: CreateTimeTriggerInput;
}>;


export type CreateTimeTriggerMutation = { __typename?: 'Mutation', createTimeTrigger: { __typename?: 'CreateTimeTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type CreateStateTriggerMutationVariables = Exact<{
  input: CreateStateTriggerInput;
}>;


export type CreateStateTriggerMutation = { __typename?: 'Mutation', createStateTrigger: { __typename?: 'CreateStateTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type CreatePriceAndTimeTriggerMutationVariables = Exact<{
  input: CreatePriceAndTimeTriggerInput;
}>;


export type CreatePriceAndTimeTriggerMutation = { __typename?: 'Mutation', createPriceAndTimeTrigger: { __typename?: 'CreatePriceAndTimeTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type ActivateTriggerMutationVariables = Exact<{
  input: ActivateTriggerInput;
}>;


export type ActivateTriggerMutation = { __typename?: 'Mutation', activateTrigger: { __typename?: 'ActivateTriggerPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type DeactivateTriggerMutationVariables = Exact<{
  input: DeactivateTriggerInput;
}>;


export type DeactivateTriggerMutation = { __typename?: 'Mutation', deactivateTrigger: { __typename?: 'DeactivateTriggerPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type DeleteTriggerMutationVariables = Exact<{
  input: DeleteTriggerInput;
}>;


export type DeleteTriggerMutation = { __typename?: 'Mutation', deleteTrigger: { __typename?: 'DeleteTriggerPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type EditTimeTriggerMutationVariables = Exact<{
  input: EditTimeTriggerInput;
}>;


export type EditTimeTriggerMutation = { __typename?: 'Mutation', editTimeTrigger: { __typename?: 'EditTimeTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type EditStateTriggerMutationVariables = Exact<{
  input: EditStateTriggerInput;
}>;


export type EditStateTriggerMutation = { __typename?: 'Mutation', editStateTrigger: { __typename?: 'EditStateTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type EditPriceAndTimeTriggerMutationVariables = Exact<{
  input: EditPriceAndTimeTriggerInput;
}>;


export type EditPriceAndTimeTriggerMutation = { __typename?: 'Mutation', editPriceAndTimeTrigger: { __typename?: 'EditPriceAndTimeTriggerPayload', idResponse?: { __typename?: 'IdResponse', id: any } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type UpdateTriggerNameMutationVariables = Exact<{
  input: UpdateTriggerNameInput;
}>;


export type UpdateTriggerNameMutation = { __typename?: 'Mutation', updateTriggerName: { __typename?: 'UpdateTriggerNamePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type RunTriggerMutationVariables = Exact<{
  input: RunTriggerInput;
}>;


export type RunTriggerMutation = { __typename?: 'Mutation', runTrigger: { __typename?: 'RunTriggerPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'TriggerError', error: TriggerErrorDictionary, message: string }> | null } };

export type ChangeUserNameMutationVariables = Exact<{
  input: ChangeUserNameInput;
}>;


export type ChangeUserNameMutation = { __typename?: 'Mutation', changeUserName: { __typename?: 'ChangeUserNamePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'UserServiceError', message: string }> | null } };

export type RemoveProfileImageMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveProfileImageMutation = { __typename?: 'Mutation', removeProfileImage: { __typename?: 'Result', ok: boolean } };

export type MarkActivityMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkActivityMutation = { __typename?: 'Mutation', markActivity: { __typename?: 'Result', ok: boolean } };

export type UpdateNotificationPermissionsMutationVariables = Exact<{
  input: UpdateNotificationPermissionsRequestInput;
}>;


export type UpdateNotificationPermissionsMutation = { __typename?: 'Mutation', updateNotificationPermissions: { __typename?: 'Result', ok: boolean } };

export type DeregisterPushNotificationReceiverByNameMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type DeregisterPushNotificationReceiverByNameMutation = { __typename?: 'Mutation', deregisterPushNotificationReceiverByName: { __typename?: 'IdResponse', id: any } };

export type UpdateUserLanguageMutationVariables = Exact<{
  input: UpdateUserLanguageInput;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUserLanguage: { __typename?: 'UpdateUserLanguagePayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'UserProfileError', error: UserProfileErrorDictionary, message: string }> | null } };

export type MarkLearningScenarioAsViewedMutationVariables = Exact<{
  input: MarkLearningScenarioAsViewedInput;
}>;


export type MarkLearningScenarioAsViewedMutation = { __typename?: 'Mutation', markLearningScenarioAsViewed: { __typename?: 'MarkLearningScenarioAsViewedPayload', result?: { __typename?: 'Result', ok: boolean } | null, errors?: Array<{ __typename?: 'UserProfileError', error: UserProfileErrorDictionary, message: string }> | null } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  input: UpdateNotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename?: 'UpdateNotificationSettingsPayload', result?: { __typename?: 'Result', ok: boolean } | null } };

export type AllActionsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type AllActionsQuery = { __typename?: 'Query', userActions?: { __typename?: 'UserActionsCollectionSegment', items?: Array<{ __typename?: 'UserAction', id: any, iconName: string, favouritePositions?: Array<{ __typename?: 'LightsFavourites', brightness: number, color: { __typename?: 'Color', red: any, green: any, blue: any } } | { __typename?: 'PositionFavourites', value: number } | { __typename?: 'SetOnTimeFavourites' }> | null, action: { __typename?: 'Action', id: any, sourceGroupId?: any | null, installationId: any, ownerId: any, actionType: ActionType, name: string, channelType?: ChannelTypeInternal | null, channelActions: Array<{ __typename?: 'ChannelAction', channelId: any, channelType: ChannelTypeInternal, activityType: ActivityType, order: number, value: string }> } }> | null, cacheInfo?: { __typename?: 'CacheInfo', installationId?: any | null, hash: string } | null } | null };

export type ActionDetailsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  actionId: Scalars['UUID'];
}>;


export type ActionDetailsQuery = { __typename?: 'Query', userAction?: { __typename?: 'UserAction', id: any, iconName: string, installationId: any, userId: any, favouritePositions?: Array<{ __typename?: 'LightsFavourites', brightness: number, color: { __typename?: 'Color', red: any, green: any, blue: any } } | { __typename?: 'PositionFavourites', value: number } | { __typename?: 'SetOnTimeFavourites' }> | null, action: { __typename?: 'Action', id: any, sourceGroupId?: any | null, installationId: any, ownerId: any, actionType: ActionType, name: string, channelType?: ChannelTypeInternal | null, channelActions: Array<{ __typename?: 'ChannelAction', channelId: any, channelType: ChannelTypeInternal, activityType: ActivityType, order: number, value: string }> } } | null };

export type ChannelsGetAllQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type ChannelsGetAllQuery = { __typename?: 'Query', allUserChannels: Array<{ __typename?: 'UserChannel', installationId: any, usesCounter: number, grantedUses?: number | null, alias: string, userId: any, iconName: string, isVisible: boolean, id: any, deviceId: any, channelType: ChannelTypeInternal, currentFirmwareVersion?: string | null, favouritePositions: Array<{ __typename?: 'LightsFavourites', value: number, brightness: number, color: { __typename?: 'Color', red: any, green: any, blue: any } } | { __typename?: 'PositionFavourites', value: number } | { __typename?: 'SetOnTimeFavourites', value: number }>, personalization: { __typename: 'GatePersonalization', isQuickControl: boolean, onEventAction?: NotificationSenderType | null, type: ChannelTypeInternal } | { __typename: 'NoPersonalization', type: ChannelTypeInternal }, payload?: { __typename?: 'BinarySensorChannelStateResponse', channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'BlindChannelStateResponse', position?: any | null, direction: BlindStateDirectionInternal, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, measuredBy?: { __typename?: 'MeasuredBy', meterChannelId: any, phase: number } | null, calibrateState?: { __typename?: 'BlindChannelCalibrateStateResponse', closingMilliseconds: any, openingMilliseconds: any, progress?: any | null, started?: boolean | null, calibrateBlindError?: BlindChannelCalibrateErrorInternal | null } | null } | { __typename?: 'GateChannelStateResponse', gateKind?: GateKindInternal | null, position?: any | null, partialControlModeStatus?: boolean | null, dailyModeStatus?: boolean | null, lockStatus?: GateLockStateInternal | null, gateMode?: GateModeInternal | null, supportedGateFeatures: Array<GateFeatureTypeInternal>, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, gateDirection: GateStateDirectionInternal, id: any, dependantChannels: Array<{ __typename?: 'DependantChannelResponse', channelId: any, channelType: ChannelTypeInternal, index: number }>, calibrateState?: { __typename?: 'GateChannelCalibrateStateResponse', closingMilliseconds: any, openingMilliseconds: any, progress?: any | null, started?: boolean | null, calibrateGateError?: GateChannelCalibrateErrorInternal | null } | null } | { __typename?: 'GenericInputChannelStateResponse', genericInputType: GenericInputTypeInternal, bistableMode?: GenericInputBistableModeInternal | null, monostableMode?: GenericInputMonostableModeInternal | null, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'LightChannelStateResponse', supportedModes: Array<LightModeTypeInternal>, toggleValue: LightToggleValueInternal, brightness?: any | null, temperature?: any | null, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, color?: { __typename?: 'LightChannelColorStateResponse', r?: any | null, g?: any | null, b?: any | null } | null } | { __typename?: 'MeterChannelStateResponse', meterType: MeterTypeInternal, supportedVectorParameters: Array<number>, supportedScalarParameters: Array<number>, effectiveSupportedAggregateVectorParameters: Array<number>, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, payload?: { __typename?: 'DefaultMeterTypeMeasurementPayload', channelId: any, id: any } | { __typename?: 'InternalMeasurementPayload', channelId: any, id: any } | { __typename?: 'StandaloneMeasurementPayload', channelId: any, activeEnergy?: number | null, maxActivePower?: number | null, averageActivePower?: number | null, id: any } | null } | { __typename: 'OptimizerChannelStateResponse', mode: OptimizerModeInternal, supportedVectorParameters: Array<number>, supportedScalarParameters: Array<number>, supportedAggregateVectorParameters: Array<number>, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'SensorChannelStateResponse', channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'SwitchChannelStateResponse', state: SwitchStateInternal, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, measuredBy?: { __typename?: 'MeasuredBy', meterChannelId: any, phase: number } | null } | null }> };

export type IntValidationFragmentFragment = { __typename?: 'IntValidation', min: number, max: number, step: number } & { ' $fragmentName'?: 'IntValidationFragmentFragment' };

export type FloatValidationFragmentFragment = { __typename?: 'FloatValidation', min: number, max: number, step: number } & { ' $fragmentName'?: 'FloatValidationFragmentFragment' };

export type RelayConfigFragmentFragment = { __typename?: 'RelayConfig', enabled: boolean, index: number, thresholdValue: number, timeOff: number, timeOn: number } & { ' $fragmentName'?: 'RelayConfigFragmentFragment' };

export type VoltageThresholdFragmentFragment = { __typename?: 'VoltageThreshold', index: number, value: number } & { ' $fragmentName'?: 'VoltageThresholdFragmentFragment' };

export type WorkingHoursFragmentFragment = { __typename?: 'WorkingHours', from: any, to: any } & { ' $fragmentName'?: 'WorkingHoursFragmentFragment' };

export type TariffFragmentFragment = { __typename?: 'Tariff', wholeWeekendCheaper: boolean, wholeHolidaysCheaper: boolean, ignoreSummerTimeChanges: boolean, kind: TariffKindInternal, hoursRanges: Array<{ __typename?: 'HoursRange', from: number, to: number, timeZoneKind: TimeZoneKindInternal }> } & { ' $fragmentName'?: 'TariffFragmentFragment' };

export type ChannelsDetailsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  channelId: Scalars['UUID'];
}>;


export type ChannelsDetailsQuery = { __typename?: 'Query', userChannel?: { __typename?: 'UserChannel', installationId: any, usesCounter: number, grantedUses?: number | null, alias: string, userId: any, iconName: string, isVisible: boolean, id: any, deviceId: any, channelType: ChannelTypeInternal, currentFirmwareVersion?: string | null, favouritePositions: Array<{ __typename?: 'LightsFavourites', value: number, brightness: number, color: { __typename?: 'Color', red: any, green: any, blue: any } } | { __typename?: 'PositionFavourites', value: number } | { __typename?: 'SetOnTimeFavourites', value: number }>, personalization: { __typename: 'GatePersonalization', isQuickControl: boolean, isPartialControlModeVisible: boolean, isDailyModeVisible: boolean, onEventAction?: NotificationSenderType | null, type: ChannelTypeInternal } | { __typename: 'NoPersonalization', type: ChannelTypeInternal }, payload?: { __typename?: 'BinarySensorChannelStateResponse', channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'BlindChannelStateResponse', position?: any | null, direction: BlindStateDirectionInternal, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, measuredBy?: { __typename?: 'MeasuredBy', meterChannelId: any, phase: number } | null, calibrateState?: { __typename?: 'BlindChannelCalibrateStateResponse', closingMilliseconds: any, openingMilliseconds: any, progress?: any | null, started?: boolean | null, calibrateBlindError?: BlindChannelCalibrateErrorInternal | null } | null } | { __typename?: 'GateChannelStateResponse', gateKind?: GateKindInternal | null, position?: any | null, partialControlModeStatus?: boolean | null, dailyModeStatus?: boolean | null, lockStatus?: GateLockStateInternal | null, isNegativeOutput: boolean, channelId: any, gateMode?: GateModeInternal | null, sbsSignalTimeInMs?: number | null, partialSbsTimeInMs?: number | null, tiltTimeInMs?: number | null, supportedGateFeatures: Array<GateFeatureTypeInternal>, deviceConnectionState: DeviceConnectionState, deviceId: any, gateDirection: GateStateDirectionInternal, id: any, alertConfig?: { __typename?: 'GateChannelAlertConfigResponse', barrierAlertEnabled: boolean, misdirectionAlertEnabled: boolean, externalSourceTriggeredAlertEnabled: boolean, openedIntervalToNotifyInMs?: number | null } | null, dependantChannels: Array<{ __typename?: 'DependantChannelResponse', channelId: any, channelType: ChannelTypeInternal, index: number }>, calibrateState?: { __typename?: 'GateChannelCalibrateStateResponse', closingMilliseconds: any, openingMilliseconds: any, progress?: any | null, started?: boolean | null, calibrateGateError?: GateChannelCalibrateErrorInternal | null } | null } | { __typename?: 'GenericInputChannelStateResponse', genericInputType: GenericInputTypeInternal, bistableMode?: GenericInputBistableModeInternal | null, monostableMode?: GenericInputMonostableModeInternal | null, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'LightChannelStateResponse', supportedModes: Array<LightModeTypeInternal>, supplyReturnBehavior: SupplyReturnBehaviorInternal, toggleValue: LightToggleValueInternal, brightness?: any | null, temperature?: any | null, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, color?: { __typename?: 'LightChannelColorStateResponse', r?: any | null, g?: any | null, b?: any | null } | null } | { __typename?: 'MeterChannelStateResponse', meterType: MeterTypeInternal, ampTransformers: AmpTransformersInternal, meterPurpose: MeterPurposeInternal, supportedVectorParameters: Array<number>, supportedScalarParameters: Array<number>, effectiveSupportedAggregateVectorParameters: Array<number>, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, validationRules: Array<{ __typename?: 'KeyedFloatValidation', key: SourceThresholdInternal, hysteresis: { __typename?: 'FloatValidation', min: number, max: number, step: number }, validation: { __typename?: 'FloatValidation', min: number, max: number, step: number } }>, measuredChannels: Array<{ __typename?: 'MeasuredChannelResponse', channelId: any, phase: number }>, tariff?: { __typename?: 'MeterTariffConfig', kind: TariffKindInternal, wholeWeekendCheaper: boolean, wholeHolidaysCheaper: boolean, ignoreSummerTimeChanges: boolean, hoursRanges: Array<{ __typename?: 'MeterHoursRange', from: number, to: number, timeZoneKind: TimeZoneKindInternal, pricingTier: number }> } | null, payload?: { __typename?: 'DefaultMeterTypeMeasurementPayload', channelId: any, id: any } | { __typename?: 'InternalMeasurementPayload', channelId: any, id: any } | { __typename?: 'StandaloneMeasurementPayload', channelId: any, activeEnergy?: number | null, maxActivePower?: number | null, averageActivePower?: number | null, id: any } | null, eventing?: { __typename?: 'MeterEventingState', supportedRelaysIndices: Array<number>, supportedSourceThresholds: Array<SourceThresholdInternal>, supportedControlModes: Array<ControlModeInternal>, rules: Array<{ __typename?: 'EventingRuleState', enabled: boolean, controlMode: ControlModeInternal, thresholdEvent?: { __typename?: 'ThresholdEventState', source: SourceThresholdInternal, deadTimeInMs: number, hysteresis: number, minValue?: number | null, maxValue?: number | null } | null, priceEvent?: { __typename?: 'PriceEventState', minPrice?: number | null, maxPrice?: number | null, startAt?: any | null, endAt?: any | null, cheapestPeriods?: number | null } | null, action: { __typename?: 'TargetAction', index: number, isDefaultAction: boolean, isNotifyAction: boolean } }> } | null } | { __typename: 'OptimizerChannelStateResponse', mode: OptimizerModeInternal, supportedVectorParameters: Array<number>, supportedScalarParameters: Array<number>, supportedAggregateVectorParameters: Array<number>, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, selfConsumptionWithPowerLimit: { __typename?: 'SelfConsumptionWithPowerLimitConfig', tempMin: number, heaterPowerLimit: number, tempMax: number, tempMinEnabled: boolean, tempSelfConsumption: number, powerLimit: number, workingHours: (
          { __typename?: 'WorkingHours' }
          & { ' $fragmentRefs'?: { 'WorkingHoursFragmentFragment': WorkingHoursFragmentFragment } }
        ), voltageThreshold: Array<(
          { __typename?: 'VoltageThreshold' }
          & { ' $fragmentRefs'?: { 'VoltageThresholdFragmentFragment': VoltageThresholdFragmentFragment } }
        )>, relaysConfig: Array<(
          { __typename?: 'RelayConfig' }
          & { ' $fragmentRefs'?: { 'RelayConfigFragmentFragment': RelayConfigFragmentFragment } }
        )>, tariff?: (
          { __typename?: 'Tariff' }
          & { ' $fragmentRefs'?: { 'TariffFragmentFragment': TariffFragmentFragment } }
        ) | null }, selfConsumptionWithRelays: { __typename?: 'SelfConsumptionWithRelaysConfig', workingHours: (
          { __typename?: 'WorkingHours' }
          & { ' $fragmentRefs'?: { 'WorkingHoursFragmentFragment': WorkingHoursFragmentFragment } }
        ), relaysConfig: Array<(
          { __typename?: 'RelayConfig' }
          & { ' $fragmentRefs'?: { 'RelayConfigFragmentFragment': RelayConfigFragmentFragment } }
        )> }, fullSelfConsumption: { __typename?: 'FullSelfConsumptionConfig', tempMin: number, heaterPowerLimit: number, tempMax: number, tempMinEnabled: boolean, tempSelfConsumption: number, workingHours: (
          { __typename?: 'WorkingHours' }
          & { ' $fragmentRefs'?: { 'WorkingHoursFragmentFragment': WorkingHoursFragmentFragment } }
        ), voltageThreshold: Array<(
          { __typename?: 'VoltageThreshold' }
          & { ' $fragmentRefs'?: { 'VoltageThresholdFragmentFragment': VoltageThresholdFragmentFragment } }
        )>, relaysConfig: Array<(
          { __typename?: 'RelayConfig' }
          & { ' $fragmentRefs'?: { 'RelayConfigFragmentFragment': RelayConfigFragmentFragment } }
        )>, tariff?: (
          { __typename?: 'Tariff' }
          & { ' $fragmentRefs'?: { 'TariffFragmentFragment': TariffFragmentFragment } }
        ) | null }, comfort?: { __typename?: 'ComfortConfig', tempMax: number, heaterPowerLimit: number, tempMin: number, voltageThreshold: Array<(
          { __typename?: 'VoltageThreshold' }
          & { ' $fragmentRefs'?: { 'VoltageThresholdFragmentFragment': VoltageThresholdFragmentFragment } }
        )>, relaysConfig: Array<(
          { __typename?: 'RelayConfig' }
          & { ' $fragmentRefs'?: { 'RelayConfigFragmentFragment': RelayConfigFragmentFragment } }
        )>, tariff?: (
          { __typename?: 'Tariff' }
          & { ' $fragmentRefs'?: { 'TariffFragmentFragment': TariffFragmentFragment } }
        ) | null } | null, eco: { __typename?: 'EcoConfig', tempMax: number, voltageThreshold: Array<(
          { __typename?: 'VoltageThreshold' }
          & { ' $fragmentRefs'?: { 'VoltageThresholdFragmentFragment': VoltageThresholdFragmentFragment } }
        )>, relaysConfig: Array<(
          { __typename?: 'RelayConfig' }
          & { ' $fragmentRefs'?: { 'RelayConfigFragmentFragment': RelayConfigFragmentFragment } }
        )> }, configValidation: { __typename: 'OptimizerConfigValidation', relay: { __typename: 'RelayValidation', thresholdPercent: (
            { __typename?: 'FloatValidation' }
            & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
          ), thresholdPower: (
            { __typename?: 'FloatValidation' }
            & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
          ), timeOn: (
            { __typename?: 'IntValidation' }
            & { ' $fragmentRefs'?: { 'IntValidationFragmentFragment': IntValidationFragmentFragment } }
          ), timeOff: (
            { __typename?: 'IntValidation' }
            & { ' $fragmentRefs'?: { 'IntValidationFragmentFragment': IntValidationFragmentFragment } }
          ) }, voltageThreshold: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ), tempMax: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ), tempMin: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ), tempSelfConsumptionMin: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ), heaterPowerLimit: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ), powerLimit: (
          { __typename?: 'FloatValidation' }
          & { ' $fragmentRefs'?: { 'FloatValidationFragmentFragment': FloatValidationFragmentFragment } }
        ) } } | { __typename?: 'SensorChannelStateResponse', channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any } | { __typename?: 'SwitchChannelStateResponse', state: SwitchStateInternal, supplyReturnBehavior: SupplyReturnBehaviorInternal, channelId: any, deviceConnectionState: DeviceConnectionState, deviceId: any, id: any, measuredBy?: { __typename?: 'MeasuredBy', meterChannelId: any, phase: number } | null } | null, sharedChannelSettings?: { __typename?: 'MeterSharedChannelSettings', id: any, tariffConfigurations: Array<{ __typename?: 'TariffConfiguration', tariff: TariffKindInternal, prices: Array<{ __typename?: 'TierPrice', pricingTier: number, price: any }> }> } | null } | null };

export type GateHistoryQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  channelId: Scalars['UUID'];
  count: Scalars['NonNegativeInt'];
  offset: Scalars['NonNegativeInt'];
}>;


export type GateHistoryQuery = { __typename?: 'Query', gateUserChannel?: { __typename?: 'UserChannel', installationId: any, id: any, deviceId: any, channelType: ChannelTypeInternal, payload?: { __typename?: 'BinarySensorChannelStateResponse', id: any } | { __typename?: 'BlindChannelStateResponse', id: any } | { __typename?: 'GateChannelStateResponse', id: any, history?: { __typename?: 'GateResponseOfGateHistory', error?: { __typename?: 'ErrorResponse', errorCode: string, description: string } | null, data?: { __typename?: 'GateHistory', totalCount: number, entries: Array<{ __typename?: 'GateHistoryEntry', id: number, eventType: GateEventTypeInternal, value?: number | null, occuredAt?: any | null, controlledBy: { __typename?: 'ControlledBy', sourceId?: any | null, id: any, controlSource: ControlSourceType, name?: string | null } }> } | null } | null } | { __typename?: 'GenericInputChannelStateResponse', id: any } | { __typename?: 'LightChannelStateResponse', id: any } | { __typename?: 'MeterChannelStateResponse', id: any } | { __typename?: 'OptimizerChannelStateResponse', id: any } | { __typename?: 'SensorChannelStateResponse', id: any } | { __typename?: 'SwitchChannelStateResponse', id: any } | null } | null };

export type DashboardItemsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DashboardItemsQuery = { __typename?: 'Query', userGroups?: { __typename?: 'UserGroupsCollectionSegment', items?: Array<{ __typename?: 'UserGroup', installationId: any, id: any, order: number, group: { __typename?: 'Group', name: string, id: any, iconName: string, isDefaultGroup: boolean, isPublicGroup: boolean, groupItems: Array<{ __typename?: 'GroupItem', id: any, resourceType: DashboardItemType, payload?: { __typename: 'UserAction', id: any, iconName: string, favouritePositions?: Array<{ __typename?: 'LightsFavourites', brightness: number, color: { __typename?: 'Color', red: any, green: any, blue: any } } | { __typename?: 'PositionFavourites', value: number } | { __typename?: 'SetOnTimeFavourites' }> | null, action: { __typename?: 'Action', installationId: any, actionType: ActionType, channelType?: ChannelTypeInternal | null, name: string, id: any, sourceGroupId?: any | null, channelActions: Array<{ __typename?: 'ChannelAction', channelId: any, channelType: ChannelTypeInternal, activityType: ActivityType, value: string }> } } | { __typename: 'UserChannel', id: any, grantedUses?: number | null, usesCounter: number } | null }> }, userGroupItems: Array<{ __typename?: 'UserGroupItem', itemId: any, order: number }> }> | null, cacheInfo?: { __typename?: 'CacheInfo', installationId?: any | null, hash: string } | null } | null };

export type DevicesGetAllQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type DevicesGetAllQuery = { __typename?: 'Query', allUserDevices: Array<{ __typename?: 'UserDevice', id: any, installationId: any, payload?: { __typename?: 'DeviceStateModel', deviceId: any, model: string, name?: string | null, connectedToSsid: string, currentFirmwareVersion: string, macAddress: string, lastConnectedAtUtc: any, registeredAtUtc: any, newestFirmwareVersion: string, timeZone: string, isUpdateAvailable?: boolean | null, id: any, channelInfos?: Array<{ __typename?: 'ChannelInfoModel', channelId: any, channelNumber: number, channelType: ChannelTypeInternal } | null> | null } | null }> };

export type DeviceDetailsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
}>;


export type DeviceDetailsQuery = { __typename?: 'Query', userDevice?: { __typename?: 'UserDevice', id: any, installationId: any, payload?: { __typename?: 'DeviceStateModel', deviceId: any, model: string, name?: string | null, connectedToSsid: string, currentFirmwareVersion: string, macAddress: string, lastConnectedAtUtc: any, registeredAtUtc: any, newestFirmwareVersion: string, timeZone: string, isUpdateAvailable?: boolean | null, id: any, channelInfos?: Array<{ __typename?: 'ChannelInfoModel', channelId: any, channelNumber: number, channelType: ChannelTypeInternal } | null> | null } | null } | null };

export type DeviceGetBindingsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
}>;


export type DeviceGetBindingsQuery = { __typename?: 'Query', channelBindings: Array<{ __typename?: 'UserChannel', id: any, alias: string, deviceId: any, channelType: ChannelTypeInternal, payload?: { __typename?: 'BinarySensorChannelStateResponse', deviceId: any, channelId: any, id: any } | { __typename?: 'BlindChannelStateResponse', deviceId: any, channelId: any, blindSupportedSlots: Array<BlindSupportedSlotsInternal>, id: any } | { __typename?: 'GateChannelStateResponse', deviceId: any, channelId: any, gateSupportedSlots: Array<GateSupportedSlotsInternal>, id: any } | { __typename?: 'GenericInputChannelStateResponse', deviceId: any, channelId: any, genericInputType: GenericInputTypeInternal, areCloudActionsSupported: boolean, id: any, actionBindings: Array<{ __typename?: 'BlindActionConfigResponse', position?: number | null, isDefaultAction: boolean, inputTrigger: InputTriggerInternal, blindSlot: BlindSupportedSlotsInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null } | { __typename?: 'CloudActionConfigResponse', onSignalActionId?: string | null, offSignalActionId?: string | null, isDefaultAction: boolean, inputTrigger: InputTriggerInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null } | { __typename?: 'DefaultActionConfigResponse', isDefaultAction: boolean, inputTrigger: InputTriggerInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null } | { __typename?: 'GateActionConfigResponse', position?: number | null, dir?: GateDirectionInternal | null, isDefaultAction: boolean, inputTrigger: InputTriggerInternal, gateSlot: GateSupportedSlotsInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null } | { __typename?: 'LightActionConfigResponse', setOnTimeValue?: number | null, brightness?: number | null, temperature?: number | null, r?: number | null, g?: number | null, b?: number | null, isDefaultAction: boolean, inputTrigger: InputTriggerInternal, lightSlot: LightSupportedSlotsInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null } | { __typename?: 'SwitchActionConfigResponse', setOnTimeValue?: number | null, isDefaultAction: boolean, inputTrigger: InputTriggerInternal, switchSlot: SwitchSupportedSlotsInternal, destination?: { __typename?: 'BindingAddress', deviceId: any, channelId: any } | null }> } | { __typename?: 'LightChannelStateResponse', deviceId: any, channelId: any, lightSupportedSlots: Array<LightSupportedSlotsInternal>, id: any } | { __typename?: 'MeterChannelStateResponse', deviceId: any, channelId: any, id: any } | { __typename?: 'OptimizerChannelStateResponse', deviceId: any, channelId: any, id: any } | { __typename?: 'SensorChannelStateResponse', deviceId: any, channelId: any, id: any } | { __typename?: 'SwitchChannelStateResponse', deviceId: any, channelId: any, switchSupportedSlots: Array<SwitchSupportedSlotsInternal>, id: any } | null }> };

export type VersionMapQueryVariables = Exact<{ [key: string]: never; }>;


export type VersionMapQuery = { __typename?: 'Query', versionMap: Array<{ __typename?: 'FeaturesByVersionMap', key: string, versionedFeatures: Array<{ __typename?: 'VersionedFeatures', feature: VersionedFeatureType, minVersion: { __typename?: 'Version', major: number, minor: number, build: number, asString?: string | null } }> }> };

export type RssiQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  deviceId: Scalars['UUID'];
}>;


export type RssiQuery = { __typename?: 'Query', rssi: { __typename?: 'RssiResponse', rssi?: number | null } };

export type InstallationSettingsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InstallationSettingsQuery = { __typename?: 'Query', userInstallation?: { __typename?: 'UserInstallation', installationId: any, name: string, hexColor: string, iconName: string, isSelected: boolean, accessType: InstallationAccessType, integrationType: IntegrationType, payload?: { __typename?: 'InstallationModelResponse', timeZone?: string | null, installationId: any, coordinates?: { __typename?: 'InstallationCoordinatesResponse', latitude: number, longitude: number } | null } | null, externalPayload?: { __typename?: 'ExalusInstallationPayload', installationId: any, pin: string, serialNumber: string } | null } | null };

export type InstallationGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type InstallationGetAllQuery = { __typename?: 'Query', userInstallations?: { __typename?: 'UserInstallationsCollectionSegment', items?: Array<{ __typename?: 'UserInstallation', installationId: any, name: string, hexColor: string, iconName: string, isSelected: boolean, accessType: InstallationAccessType, order: number, integrationType: IntegrationType, externalPayload?: { __typename?: 'ExalusInstallationPayload', installationId: any, pin: string, serialNumber: string } | null }> | null, cacheInfo?: { __typename?: 'CacheInfo', hash: string } | null } | null };

export type CurrentInstallationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentInstallationQuery = { __typename?: 'Query', currentInstallation?: { __typename?: 'CurrentInstallation', installationId: any, brokerUrl: string, payload?: { __typename?: 'InstallationModelResponse', timeZone?: string | null, coordinates?: { __typename?: 'InstallationCoordinatesResponse', latitude: number, longitude: number } | null } | null, cacheResponses?: { __typename?: 'CacheResponses', measurementMapCache?: { __typename?: 'CacheInfo', hash: string } | null, actionsCache?: { __typename?: 'CacheInfo', hash: string } | null, groupsCache?: { __typename?: 'CacheInfo', hash: string } | null, installationsCache?: { __typename?: 'CacheInfo', hash: string } | null } | null } | null };

export type AllInvitationsQueryVariables = Exact<{
  includeCreatedByMe: Scalars['Boolean'];
  includeInvitedMe: Scalars['Boolean'];
  installationId: Scalars['UUID'];
  createdByUserId: Scalars['UUID'];
}>;


export type AllInvitationsQuery = { __typename?: 'Query', allInvitations: Array<{ __typename?: 'Invitation', id: any, installationId: any, invitedUserEmail: string, createdByUserId: any, invitedUserId?: any | null, status: InvitationStatus, createdAt: any, sharingPayload: { __typename?: 'SharingPayload', wholeInstallationShare: boolean, accessType: InstallationAccessType, sharedItems: Array<{ __typename?: 'SharedItem', id: any, name: string, itemType: SharingItemType, grantedUses?: number | null }> } }> };

export type MeterAggregatedMeasurementsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  input: GetAggregateMeasurementsRequestInput;
}>;


export type MeterAggregatedMeasurementsQuery = { __typename?: 'Query', meterAggregatedMeasurements: { __typename?: 'MeasurementResponseOfGetAggregateVectorMeasurementResponse', data?: { __typename?: 'GetAggregateVectorMeasurementResponse', aggregateVectorMeasurements: Array<{ __typename?: 'AggregateVectorMeasurementResponseItem', type: AggregateVectorParameterTypeInternal, range: MeasurementDataRangeInternal, values: Array<number>, index: number, tariff?: TariffKindInternal | null }> } | null, error?: { __typename?: 'ErrorResponse', errorCode: string, description: string } | null } };

export type PersistedMeterAggregatedMeasurementsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  input: GetPersistedAggregateMeasurementsRequestInput;
}>;


export type PersistedMeterAggregatedMeasurementsQuery = { __typename?: 'Query', persistedMeterAggregatedMeasurements: { __typename?: 'MeasurementResponseOfGetPersistedVectorMeasurementResponse', data?: { __typename: 'GetPersistedVectorMeasurementResponse', from: any, to: any, oldestAtUtc?: any | null, items: Array<{ __typename: 'MultiParameterAggregatedItem', dateAtUtc: any, measurements?: any | null }> } | null, error?: { __typename?: 'ErrorResponse', errorCode: string, description: string } | null } };

export type MeterCommonMeasurementsQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  input: GetCommonMeasurementsRequestInput;
}>;


export type MeterCommonMeasurementsQuery = { __typename?: 'Query', meterCommonMeasurements: { __typename?: 'MeasurementResponseOfGetCurrentMeasurementResponse', data?: { __typename?: 'GetCurrentMeasurementResponse', vectorMeasurements: Array<{ __typename?: 'VectorMeasurementResponseItem', type: number, value: number, index: number }>, scalarMeasurements: Array<{ __typename?: 'ScalarMeasurementResponseItem', type: number, value: number }> } | null, error?: { __typename?: 'ErrorResponse', errorCode: string, description: string } | null } };

export type MeasurementMapQueryVariables = Exact<{ [key: string]: never; }>;


export type MeasurementMapQuery = { __typename?: 'Query', measurementMap: { __typename?: 'MeasurementMap', meter: { __typename?: 'MapItemOfScalarParameterTypeInternalAndVectorParameterTypeInternalAndAggregateVectorParameterTypeInternal', kind: MeasurementChannelKind, scalars: Array<{ __typename?: 'ItemComponentOfScalarParameterTypeInternal', type: ScalarParameterTypeInternal, value: number }>, vectors: Array<{ __typename?: 'ItemComponentOfVectorParameterTypeInternal', type: VectorParameterTypeInternal, value: number }>, aggregates: Array<{ __typename?: 'ItemComponentOfAggregateVectorParameterTypeInternal', type: AggregateVectorParameterTypeInternal, value: number }> }, optimizer: { __typename?: 'MapItemOfOptimizerScalarParameterTypeInternalAndOptimizerVectorParameterTypeInternalAndOptimizerAggregateVectorParameterTypeInternal', kind: MeasurementChannelKind, scalars: Array<{ __typename?: 'ItemComponentOfOptimizerScalarParameterTypeInternal', type: OptimizerScalarParameterTypeInternal, value: number }>, vectors: Array<{ __typename?: 'ItemComponentOfOptimizerVectorParameterTypeInternal', type: OptimizerVectorParameterTypeInternal, value: number }>, aggregates: Array<{ __typename?: 'ItemComponentOfOptimizerAggregateVectorParameterTypeInternal', type: OptimizerAggregateVectorParameterTypeInternal, value: number }> }, cacheInfo?: { __typename?: 'CacheInfo', hash: string } | null } };

export type DynamicMarketPricesWithBucketsQueryVariables = Exact<{ [key: string]: never; }>;


export type DynamicMarketPricesWithBucketsQuery = { __typename?: 'Query', dynamicMarketPricesWithBuckets: { __typename?: 'DynamicPricesWithBuckets', bucketInfos: Array<{ __typename?: 'BucketInfo', fromPriceInKWh: any, toPriceInKWh: any }>, days: Array<{ __typename?: 'DayEntryResponse', day: string, records: Array<{ __typename?: 'PriceEntryResponse', time: string, priceInMWh: any, priceInkWh: any, startingHour: number }> }> } };

export type SeasonPricesQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type SeasonPricesQuery = { __typename?: 'Query', seasonPrices?: { __typename?: 'PricesBySeasons', staticHolidays: Array<any>, movableHolidays: Array<any>, summer: { __typename?: 'SeasonEntries', from: any, to: any, workingDayEntries: Array<{ __typename?: 'PriceEntryResponse', time: string, priceInMWh: any, priceInkWh: any, startingHour: number }>, offFromWorkDayEntries: Array<{ __typename?: 'PriceEntryResponse', time: string, priceInMWh: any, priceInkWh: any, startingHour: number }> }, winter: { __typename?: 'SeasonEntries', from: any, to: any, workingDayEntries: Array<{ __typename?: 'PriceEntryResponse', time: string, priceInMWh: any, priceInkWh: any, startingHour: number }>, offFromWorkDayEntries: Array<{ __typename?: 'PriceEntryResponse', time: string, priceInMWh: any, priceInkWh: any, startingHour: number }> }, bucketInfos: Array<{ __typename?: 'BucketInfo', fromPriceInKWh: any, toPriceInKWh: any }> } | null };

export type AllUserNotificationsQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  where: NotificationFilterInput;
}>;


export type AllUserNotificationsQuery = { __typename?: 'Query', allUserNotifications?: { __typename?: 'AllUserNotificationsCollectionSegment', items?: Array<{ __typename?: 'Notification', correlationId: any, code: NotificationCode, wasDisplayed: boolean, isHidden: boolean, createdAt: any, params: Array<{ __typename?: 'NotificationParam', name: string, value?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UserNotificationQueryVariables = Exact<{
  correlationId: Scalars['UUID'];
}>;


export type UserNotificationQuery = { __typename?: 'Query', userNotification?: { __typename?: 'Notification', correlationId: any, code: NotificationCode, wasDisplayed: boolean, isHidden: boolean, createdAt: any, params: Array<{ __typename?: 'NotificationParam', name: string, value?: string | null }> } | null };

export type BluetoothLoggingEnabledQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type BluetoothLoggingEnabledQuery = { __typename?: 'Query', bluetoothLoggingEnabled: LogLevel };

export type UserSharingInfoQueryVariables = Exact<{
  installationId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type UserSharingInfoQuery = { __typename?: 'Query', sharingInfo?: { __typename?: 'ShareInfo', createdAt: any, sharedToUserId: any, sharingUserId: any, sharedToUser?: { __typename?: 'TrimmedUserResponse', id: string, firstName: string, email: string, lastActivity?: any | null, profileImage?: { __typename?: 'Image', imageUrl?: string | null } | null } | null, sharingUser?: { __typename?: 'TrimmedUserResponse', id: string, firstName: string, email: string, profileImage?: { __typename?: 'Image', imageUrl?: string | null } | null } | null, groups: Array<{ __typename?: 'ShareInfoItemBase', id: any, sharedFrom?: any | null, sharedUntil?: any | null }>, channels: Array<{ __typename?: 'ShareInfoChannel', id: any, grantedUses?: number | null, sharedFrom?: any | null, sharedUntil?: any | null }>, installation: { __typename?: 'ShareInfoInstallation', id: any, accessType: InstallationAccessType, wholeInstallationShare: boolean, sharedFrom?: any | null, sharedUntil?: any | null } } | null };

export type SharingInfosByInstallationQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type SharingInfosByInstallationQuery = { __typename?: 'Query', sharingInfosByInstallation: { __typename?: 'SharedInstallationInfo', ownerInfo: { __typename?: 'OwnerInfo', ownerId: any, owner?: { __typename?: 'TrimmedUserResponse', id: string, firstName: string, email: string, profileImage?: { __typename?: 'Image', imageUrl?: string | null } | null } | null }, shareInfos: Array<{ __typename?: 'ShareInfo', sharedToUserId: any, sharedToUser?: { __typename?: 'TrimmedUserResponse', id: string, firstName: string, email: string, lastActivity?: any | null, profileImage?: { __typename?: 'Image', imageUrl?: string | null } | null } | null, groups: Array<{ __typename?: 'ShareInfoItemBase', id: any, sharedFrom?: any | null, sharedUntil?: any | null }>, channels: Array<{ __typename?: 'ShareInfoChannel', id: any, grantedUses?: number | null, sharedFrom?: any | null, sharedUntil?: any | null }>, installation: { __typename?: 'ShareInfoInstallation', id: any, accessType: InstallationAccessType, wholeInstallationShare: boolean, sharedFrom?: any | null, sharedUntil?: any | null } }> } };

export type CalculateNextTriggerFireTimeQueryVariables = Exact<{
  trigger: TriggerTimeConditionRequestInput;
  installationId: Scalars['UUID'];
}>;


export type CalculateNextTriggerFireTimeQuery = { __typename?: 'Query', calculateNextTriggerFireTime: { __typename?: 'TriggerNextFireTimeResponse', nextFireTime?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null } };

export type CalculateFutureFireTimesQueryVariables = Exact<{
  trigger: TriggerPriceAndTimeConditionRequestInput;
  installationId: Scalars['UUID'];
}>;


export type CalculateFutureFireTimesQuery = { __typename?: 'Query', calculateFutureFireTimes: { __typename?: 'TriggerFutureFiresResponse', futureFires: Array<{ __typename?: 'TriggerDateTimeResponse', date: any, time: any }> } };

export type AllTriggersQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type AllTriggersQuery = { __typename?: 'Query', allTriggers: Array<{ __typename?: 'Trigger', triggerId: any, installationId: any, onFailureMode: TriggerOnFailureMode, isValid: boolean, isActive: boolean, name?: string | null, timeCondition?: { __typename?: 'TriggerTimeConditionResponse', atSunrise?: boolean | null, sunriseAdvance?: any | null, sunriseDelay?: any | null, atSunset?: boolean | null, sunsetAdvance?: any | null, sunsetDelay?: any | null, timeOfDay?: any | null, daysOfWeek?: Array<DayOfWeekInternal> | null, everyMonth?: boolean | null, everyYear?: boolean | null, currentExecutionCount?: number | null, targetExecutionCount?: number | null, startAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, endAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, nextFireTime?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null } | null, stateConditions: Array<{ __typename?: 'TriggerStateConditionRequest', id: any, booleanValue?: boolean | null, integerValue?: number | null, conditionType: TriggerConditionType, timeIntervalValue?: { __typename?: 'TriggerTimeIntervalRequest', daysOfWeek?: Array<DayOfWeekInternal> | null, timeFrom?: any | null, timeTo?: any | null } | null }>, priceAndTimeCondition?: { __typename?: 'TriggerPriceAndTimeConditionResponse', priceGreaterThanOrEqual?: any | null, priceLesserThanOrEqual?: any | null, numberOfCheapestPeriodsInDay?: number | null, betweenHoursFromInclusive?: number | null, betweenHoursToInclusive?: number | null, currentExecutionCount?: number | null, targetExecutionCount?: number | null, daysOfWeek?: Array<DayOfWeekInternal> | null, startAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, endAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, nextFireTime?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null } | null, actions: Array<{ __typename?: 'TriggerActionRequest', actionType: TriggerActionType, id: any, integerValue?: number | null, booleanValue?: boolean | null, lightColorValue?: { __typename?: 'TriggerLightColorRequest', r: number, g: number, b: number } | null }>, executionInfo: Array<{ __typename?: 'TriggerExecutionInfoResponse', isSuccessful: boolean, executedAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, plannedExecutionAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, actionsResults?: Array<{ __typename?: 'TriggerExecutionActionResultResponse', actionType: TriggerActionType, id: any, isSuccessful: boolean }> | null }>, createdAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, validationErrors: Array<{ __typename?: 'TriggerValidationErrorModelResponse', partType: TriggerValidationPartType, errorType: TriggerValidationErrorType, value: string }> }> };

export type TriggerDetailsQueryVariables = Exact<{
  id: Scalars['UUID'];
  installationId: Scalars['UUID'];
}>;


export type TriggerDetailsQuery = { __typename?: 'Query', trigger?: { __typename?: 'Trigger', triggerId: any, installationId: any, onFailureMode: TriggerOnFailureMode, isValid: boolean, isActive: boolean, name?: string | null, timeCondition?: { __typename?: 'TriggerTimeConditionResponse', holidaysHandling: HolidaysHandling, atSunrise?: boolean | null, sunriseAdvance?: any | null, sunriseDelay?: any | null, atSunset?: boolean | null, sunsetAdvance?: any | null, sunsetDelay?: any | null, timeOfDay?: any | null, daysOfWeek?: Array<DayOfWeekInternal> | null, everyMonth?: boolean | null, everyYear?: boolean | null, currentExecutionCount?: number | null, targetExecutionCount?: number | null, startAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, endAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, nextFireTime?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null } | null, stateConditions: Array<{ __typename?: 'TriggerStateConditionRequest', id: any, booleanValue?: boolean | null, integerValue?: number | null, conditionType: TriggerConditionType, timeIntervalValue?: { __typename?: 'TriggerTimeIntervalRequest', daysOfWeek?: Array<DayOfWeekInternal> | null, timeFrom?: any | null, timeTo?: any | null } | null }>, priceAndTimeCondition?: { __typename?: 'TriggerPriceAndTimeConditionResponse', subType: PriceTriggerSubType, holidaysHandling: HolidaysHandling, priceGreaterThanOrEqual?: any | null, priceLesserThanOrEqual?: any | null, numberOfCheapestPeriodsInDay?: number | null, betweenHoursFromInclusive?: number | null, betweenHoursToInclusive?: number | null, currentExecutionCount?: number | null, targetExecutionCount?: number | null, daysOfWeek?: Array<DayOfWeekInternal> | null, startAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, endAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, nextFireTime?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null } | null, actions: Array<{ __typename?: 'TriggerActionRequest', actionType: TriggerActionType, id: any, integerValue?: number | null, booleanValue?: boolean | null, lightColorValue?: { __typename?: 'TriggerLightColorRequest', r: number, g: number, b: number } | null }>, executionInfo: Array<{ __typename?: 'TriggerExecutionInfoResponse', isSuccessful: boolean, executedAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, plannedExecutionAt?: { __typename?: 'TriggerDateTimeResponse', date: any, time: any } | null, actionsResults?: Array<{ __typename?: 'TriggerExecutionActionResultResponse', actionType: TriggerActionType, id: any, isSuccessful: boolean }> | null }>, createdAt: { __typename?: 'TriggerDateTimeResponse', date: any, time: any }, validationErrors: Array<{ __typename?: 'TriggerValidationErrorModelResponse', partType: TriggerValidationPartType, errorType: TriggerValidationErrorType, value: string }> } | null };

export type UserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', profileImage?: { __typename?: 'Image', imageUrl?: string | null } | null, profile?: { __typename?: 'UserResponse', id: string, firstName: string, email: string } | null, permissions?: Array<{ __typename?: 'InstallationPermissions', installationId: any, userPermissions: Array<UserPermissionType> } | null> | null } | null };

export type UserProfileQueryVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'UserProfile', userLanguage: string, automationEmailNotificationPermission: boolean, automationInAppNotificationPermission: boolean, automationPushNotificationPermission: boolean, channelsEmailNotificationPermission: boolean, channelsInAppNotificationPermission: boolean, channelsPushNotificationPermission: boolean, sharingEmailNotificationPermission: boolean, sharingPushNotificationPermission: boolean, userId: any, displayedLearningScenarios?: any | null, appScopedNotificationsPermission?: number | null, defaultAppScopedValue: number, defaultInstallationScopedValue: number, pushNotificationsEnabled: boolean, emailNotificationsEnabled: boolean, countOfUnreadNotifications?: number | null, currentInstallationScopedNotificationsPermission?: number | null } | null };

export type OnSwitchStateChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnSwitchStateChangeSubscription = { __typename?: 'Subscription', onSwitchStateChange: { __typename?: 'SwitchStateChangePayload', channelId: any, state: SwitchStateInternal } };

export type OnBlindPositionChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnBlindPositionChangeSubscription = { __typename?: 'Subscription', onBlindPositionChange: { __typename?: 'BlindPositionChangePayload', channelId: any, position: number, direction: BlindStateDirectionInternal, predictedTimeInMs?: number | null, targetPosition?: number | null, slatsPredictedTimeInMs?: number | null } };

export type OnGateStatusChangedSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnGateStatusChangedSubscription = { __typename?: 'Subscription', onGateStatusChanged: { __typename?: 'GateStatusChangedPayload', channelId: any, dailyModeStatus?: boolean | null, deviceId: any, direction: GateStateDirectionInternal, installationId: any, lockStatus?: GateLockStateInternal | null, partialControlModeStatus?: boolean | null, position: number, predictedTimeInMs?: number | null, targetPosition?: number | null } };

export type OnLightStateChangedSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnLightStateChangedSubscription = { __typename?: 'Subscription', onLightStateChanged: { __typename?: 'LightStateChangedPayload', channelId: any, toggleValue: LightToggleValueInternal, brightness?: number | null, temperature?: number | null, color?: { __typename?: 'LightColorPayload', r: number, g: number, b: number } | null } };

export type OnRequestAckReceivedSubscriptionVariables = Exact<{
  channelOrDeviceId: Scalars['UUID'];
}>;


export type OnRequestAckReceivedSubscription = { __typename?: 'Subscription', onRequestAckReceived: { __typename?: 'RequestAckPayload', deviceId: any, status: RequestAckResultType } };

export type OnDeviceConnectionStateChangeSubscriptionVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type OnDeviceConnectionStateChangeSubscription = { __typename?: 'Subscription', onDeviceConnectionStateChange: { __typename?: 'DeviceConnectionStateChangePayload', deviceId: any, deviceConnectionState: DeviceConnectionState } };

export type OnBlindCalibrateStatusChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnBlindCalibrateStatusChangeSubscription = { __typename?: 'Subscription', onBlindCalibrateStatusChange: { __typename?: 'BlindCalibrateStatusChangePayload', channelId: any, progress?: number | null, status: BlindCalibrateStatusTypePayload, openingMilliseconds: any, closingMilliseconds: any, error?: BlindChannelCalibrateErrorInternal | null } };

export type OnDeviceFirmwareUpdatedSubscriptionVariables = Exact<{
  deviceId: Scalars['UUID'];
}>;


export type OnDeviceFirmwareUpdatedSubscription = { __typename?: 'Subscription', onDeviceFirmwareUpdated: { __typename?: 'DeviceFirmwareUpdatedPayload', currentFirmwareVersion: string, deviceId: any } };

export type OnRecoveryDeviceStatusReceivedPayloadSubscriptionVariables = Exact<{
  deviceId: Scalars['UUID'];
}>;


export type OnRecoveryDeviceStatusReceivedPayloadSubscription = { __typename?: 'Subscription', onRecoveryDeviceStatusRecievedPayload: { __typename?: 'RecoveryDeviceStatusRecievedPayload', deviceId: any, recoveryDeviceStatus: RecoveryDeviceStatus, progress?: number | null } };

export type OnDeviceWifiNetworksReceivedSubscriptionVariables = Exact<{
  deviceId: Scalars['UUID'];
}>;


export type OnDeviceWifiNetworksReceivedSubscription = { __typename?: 'Subscription', onDeviceWifiNetworksReceived: { __typename?: 'DeviceWifiNetworksReceivedPayload', wifiNetworks: Array<{ __typename?: 'DeviceWifiNetworkPayload', remembered: boolean, rssi: number, ssid: string }> } };

export type OnDeviceConnectedToSsidUpdatedSubscriptionVariables = Exact<{
  deviceId: Scalars['UUID'];
}>;


export type OnDeviceConnectedToSsidUpdatedSubscription = { __typename?: 'Subscription', onDeviceConnectedToSsidUpdated: { __typename?: 'DeviceConnectedToSsidUpdatedPayload', connectedToSsid: string, deviceId: any } };

export type OnOptimizerConfigurationUpdatedPayloadSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnOptimizerConfigurationUpdatedPayloadSubscription = { __typename?: 'Subscription', onOptimizerConfigurationUpdatedPayload: { __typename?: 'OptimizerConfigurationUpdatedPayload', channelId: any } };

export type OnGateCalibrateStatusChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnGateCalibrateStatusChangeSubscription = { __typename?: 'Subscription', onGateCalibrateStatusChange: { __typename?: 'GateCalibrateStatusChangePayload', channelId: any, progress?: number | null, status: GateCalibrateStatusTypePayload, openingMilliseconds: any, closingMilliseconds: any, error?: GateChannelCalibrateErrorInternal | null } };

export type OnGenericInputStateChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnGenericInputStateChangeSubscription = { __typename?: 'Subscription', onGenericInputStateChange: { __typename?: 'GenericInputStateChangePayload', channelId: any, bistableMode?: GenericInputBistableModeInternal | null, monostableMode?: GenericInputMonostableModeInternal | null, genericInputType: GenericInputTypeInternal } };

export type OnGenericInputStatusChangedSubscriptionVariables = Exact<{
  deviceId: Scalars['UUID'];
}>;


export type OnGenericInputStatusChangedSubscription = { __typename?: 'Subscription', onGenericInputStatusChanged: { __typename?: 'GenericInputStatusChangedPayload', value: boolean, channelId: any, installationId: any, deviceId: any } };

export type OnSupplyReturnBehaviorChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnSupplyReturnBehaviorChangeSubscription = { __typename?: 'Subscription', onSupplyReturnBehaviorChange: { __typename?: 'SupplyReturnBehaviorChangePayload', channelId: any, supplyReturnBehavior: SupplyReturnBehaviorInternal } };

export type OnGateConfigurationChangeSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnGateConfigurationChangeSubscription = { __typename?: 'Subscription', onGateConfigurationChange: { __typename?: 'GateConfigurationChangePayload', channelId: any, supportedGateFeatures: Array<GateFeatureTypeInternal> } };

export type OnConfigurationTaintedSubscriptionVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type OnConfigurationTaintedSubscription = { __typename?: 'Subscription', onConfigurationTaintedPayload: { __typename?: 'ConfigurationTaintedPayload', failures: Array<string>, channelId: any, channelType: ChannelTypeInternal, installationId: any, deviceId: any } };

export type OnDeviceErrorSubscriptionVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type OnDeviceErrorSubscription = { __typename?: 'Subscription', onDeviceError: { __typename?: 'DeviceErrorPayload', code: string, description: string, installationId: any, deviceId: any } };

export type OnPartialConfigChangedSubscriptionVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type OnPartialConfigChangedSubscription = { __typename?: 'Subscription', onPartialConfigChanged: { __typename?: 'PartialConfigChangedPayload', updatedProperties: Array<string>, channelId: any, deviceId: any, installationId: any, stringProperties: Array<{ __typename?: 'PartialConfigProperty', property: string, value?: string | null }>, numericalProperties: Array<{ __typename?: 'PartialConfigProperty', property: string, value?: string | null }> } };

export type OnDeviceNameChangedSubscriptionVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type OnDeviceNameChangedSubscription = { __typename?: 'Subscription', onDeviceNameChanged: { __typename?: 'DeviceNameChangedPayload', deviceId: any, name: string } };

export type OnInstallationDetachSubscriptionVariables = Exact<{
  installationId: Scalars['UUID'];
}>;


export type OnInstallationDetachSubscription = { __typename?: 'Subscription', onInstallationDetach: { __typename?: 'InstallationDetachPayload', installationId: any, newBrokerUrl: string } };

export type OnMeasurementSubscriptionVariables = Exact<{
  input: SubscribeForMeasurementInput;
}>;


export type OnMeasurementSubscription = { __typename?: 'Subscription', onMeasurement: { __typename?: 'MeasurementSubResponse', data: { __typename?: 'MeasurementSubscriptionDeviceConnected' } | { __typename?: 'MeasurementSubscriptionDeviceDisconnected' } | { __typename?: 'MeasurementSubscriptionError', unixTimestamp: any, errorCode: string, description: string } | { __typename?: 'MeasurementSubscriptionResponse', unixTimestamp: any, scalarMeasurements: Array<{ __typename?: 'ScalarMeasurementResponseItem', type: number, value: number }>, vectorMeasurements: Array<{ __typename?: 'VectorMeasurementResponseItem', type: number, index: number, value: number }> } } };

export type OnNotifiedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotifiedSubscription = { __typename?: 'Subscription', onNotified: { __typename?: 'Notification', correlationId: any, code: NotificationCode, wasDisplayed: boolean, isHidden: boolean, createdAt: any, params: Array<{ __typename?: 'NotificationParam', name: string, value?: string | null }> } };

export const IntValidationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IntValidationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntValidation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"step"}}]}}]} as unknown as DocumentNode<IntValidationFragmentFragment, unknown>;
export const FloatValidationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FloatValidationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FloatValidation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"step"}}]}}]} as unknown as DocumentNode<FloatValidationFragmentFragment, unknown>;
export const RelayConfigFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelayConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RelayConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdValue"}},{"kind":"Field","name":{"kind":"Name","value":"timeOff"}},{"kind":"Field","name":{"kind":"Name","value":"timeOn"}}]}}]} as unknown as DocumentNode<RelayConfigFragmentFragment, unknown>;
export const VoltageThresholdFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoltageThresholdFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoltageThreshold"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<VoltageThresholdFragmentFragment, unknown>;
export const WorkingHoursFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]} as unknown as DocumentNode<WorkingHoursFragmentFragment, unknown>;
export const TariffFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TariffFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tariff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hoursRanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneKind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholeWeekendCheaper"}},{"kind":"Field","name":{"kind":"Name","value":"wholeHolidaysCheaper"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreSummerTimeChanges"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]} as unknown as DocumentNode<TariffFragmentFragment, unknown>;
export const SetFavouriteActionPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetFavouriteActionPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetActionFavouritePositionRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setFavouriteActionPositions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<SetFavouriteActionPositionsMutation, SetFavouriteActionPositionsMutationVariables>;
export const CreateBasicActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBasicAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBasicActionRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBasicAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateBasicActionMutation, CreateBasicActionMutationVariables>;
export const CreateAdvancedActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAdvancedAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAdvancedActionRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdvancedAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAdvancedActionMutation, CreateAdvancedActionMutationVariables>;
export const EditActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditActionMutation, EditActionMutationVariables>;
export const DeleteActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteActionMutation, DeleteActionMutationVariables>;
export const ChangeChannelsVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeChannelsVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeChannelsVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeChannelsVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeChannelsVisibilityMutation, ChangeChannelsVisibilityMutationVariables>;
export const SetFavouriteChannelPositionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetFavouriteChannelPositions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetChannelFavouritePositionRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setFavouriteChannelPositions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<SetFavouriteChannelPositionsMutation, SetFavouriteChannelPositionsMutationVariables>;
export const SetChannelIconNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetChannelIconName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iconName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setChannelIconName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"iconName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iconName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<SetChannelIconNameMutation, SetChannelIconNameMutationVariables>;
export const EditUserChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditUserChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditUserChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editUserChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditUserChannelMutation, EditUserChannelMutationVariables>;
export const SetQuickControlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetQuickControl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetQuickControlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setQuickControl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetQuickControlMutation, SetQuickControlMutationVariables>;
export const UpdateTariffConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTariffConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTariffConfigurationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTariffConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterSharedChannelSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tariffConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTariffConfigurationsMutation, UpdateTariffConfigurationsMutationVariables>;
export const ChangeOnEventActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOnEventAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOnEventActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOnEventAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeOnEventActionMutation, ChangeOnEventActionMutationVariables>;
export const RemoveDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveDeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveDeviceMutation, RemoveDeviceMutationVariables>;
export const ChangeDeviceNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeDeviceName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeDeviceName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"correlationId"}}]}}]}}]} as unknown as DocumentNode<ChangeDeviceNameMutation, ChangeDeviceNameMutationVariables>;
export const CreateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupMutation, CreateGroupMutationVariables>;
export const AddToFavouritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToFavourites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavouritesItemRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addToFavourites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddToFavouritesMutation, AddToFavouritesMutationVariables>;
export const RemoveFromFavouritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveFromFavourites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavouritesItemRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFromFavourites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveFromFavouritesMutation, RemoveFromFavouritesMutationVariables>;
export const UpdateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const RemoveGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveGroupMutation, RemoveGroupMutationVariables>;
export const ChangeGroupsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeGroupsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeGroupOrderRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeGroupsOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeGroupsOrderMutation, ChangeGroupsOrderMutationVariables>;
export const ChangeGroupItemsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeGroupItemsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeGroupItemsOrderRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeGroupItemsOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeGroupItemsOrderMutation, ChangeGroupItemsOrderMutationVariables>;
export const ModifyGroupItemInMultipleGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModifyGroupItemInMultipleGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModifyGroupItemInMultipleGroupsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modifyGroupItemInMultipleGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ModifyGroupItemInMultipleGroupsMutation, ModifyGroupItemInMultipleGroupsMutationVariables>;
export const CreateInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInstallationRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationModelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExalusInstallationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateInstallationMutation, CreateInstallationMutationVariables>;
export const AddMultipleInstallationsAfterMigrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMultipleInstallationsAfterMigration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInstallationRequestInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMultipleInstallationsAfterMigration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationModelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExalusInstallationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddMultipleInstallationsAfterMigrationMutation, AddMultipleInstallationsAfterMigrationMutationVariables>;
export const ChangeInstallationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeInstallationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeInstallationNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeInstallationName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeInstallationNameMutation, ChangeInstallationNameMutationVariables>;
export const ChangeInstallationIconDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeInstallationIcon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeInstallationIconInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeInstallationIcon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeInstallationIconMutation, ChangeInstallationIconMutationVariables>;
export const ChangeInstallationColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeInstallationColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeInstallationColorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeInstallationColor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeInstallationColorMutation, ChangeInstallationColorMutationVariables>;
export const DeleteInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteInstallationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteInstallationMutation, DeleteInstallationMutationVariables>;
export const RemoveUserFromInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveUserFromInstallationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserFromInstallationMutation, RemoveUserFromInstallationMutationVariables>;
export const SelectInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"brokerUrl"}}]}}]}}]} as unknown as DocumentNode<SelectInstallationMutation, SelectInstallationMutationVariables>;
export const ChangeInstallationOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeInstallationOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeInstallationsOrderRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeInstallationOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ChangeInstallationOrderMutation, ChangeInstallationOrderMutationVariables>;
export const ChangeGeolocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeGeolocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeGeolocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeGeolocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationAttachmentError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"validBrokerUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeGeolocationMutation, ChangeGeolocationMutationVariables>;
export const ChangeTimeZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeTimeZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeTimeZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeTimeZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationAttachmentError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"validBrokerUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeTimeZoneMutation, ChangeTimeZoneMutationVariables>;
export const IntroduceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Introduce"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introduce"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IntroduceMutation, IntroduceMutationVariables>;
export const AcceptInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const RejectInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RejectInvitationMutation, RejectInvitationMutationVariables>;
export const CancelInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CancelInvitationMutation, CancelInvitationMutationVariables>;
export const PushBluetoothLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PushBluetoothLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PushBluetoothLogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pushBluetoothLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}}]}}]}}]} as unknown as DocumentNode<PushBluetoothLogMutation, PushBluetoothLogMutationVariables>;
export const NotificationMarkAsDisplayedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMarkAsDisplayed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsDisplayed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"correlationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<NotificationMarkAsDisplayedMutation, NotificationMarkAsDisplayedMutationVariables>;
export const NotificationMarkAllAsDisplayedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMarkAllAsDisplayed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllAsDisplayed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<NotificationMarkAllAsDisplayedMutation, NotificationMarkAllAsDisplayedMutationVariables>;
export const NotificationMarkAsHiddenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMarkAsHidden"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsHidden"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"correlationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<NotificationMarkAsHiddenMutation, NotificationMarkAsHiddenMutationVariables>;
export const NotificationMarkAllAsHiddenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMarkAllAsHidden"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllAsHidden"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<NotificationMarkAllAsHiddenMutation, NotificationMarkAllAsHiddenMutationVariables>;
export const RegisterPushNotificationReceiverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegisterPushNotificationReceiver"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterPushReceiverRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerPushNotificationReceiver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RegisterPushNotificationReceiverMutation, RegisterPushNotificationReceiverMutationVariables>;
export const DemoPushDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemoPush"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demoPush"}}]}}]} as unknown as DocumentNode<DemoPushMutation, DemoPushMutationVariables>;
export const ShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Share"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShareMutation, ShareMutationVariables>;
export const PassOwnershipToInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PassOwnershipToInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PassOwnershipToInstallationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passOwnershipToInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PassOwnershipToInstallationMutation, PassOwnershipToInstallationMutationVariables>;
export const ChangeUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeUserRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeUserRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeUserRoleMutation, ChangeUserRoleMutationVariables>;
export const ModifyUserAccessesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ModifyUserAccesses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModifyUserAccessesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modifyUserAccesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ModifyUserAccessesMutation, ModifyUserAccessesMutationVariables>;
export const CreateTimeTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTimeTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTimeTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateTimeTriggerMutation, CreateTimeTriggerMutationVariables>;
export const CreateStateTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStateTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateStateTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStateTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateStateTriggerMutation, CreateStateTriggerMutationVariables>;
export const CreatePriceAndTimeTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePriceAndTimeTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePriceAndTimeTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPriceAndTimeTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePriceAndTimeTriggerMutation, CreatePriceAndTimeTriggerMutationVariables>;
export const ActivateTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivateTriggerMutation, ActivateTriggerMutationVariables>;
export const DeactivateTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeactivateTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateTriggerMutation, DeactivateTriggerMutationVariables>;
export const DeleteTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export const EditTimeTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditTimeTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditTimeTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editTimeTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditTimeTriggerMutation, EditTimeTriggerMutationVariables>;
export const EditStateTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditStateTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditStateTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editStateTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditStateTriggerMutation, EditStateTriggerMutationVariables>;
export const EditPriceAndTimeTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPriceAndTimeTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditPriceAndTimeTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPriceAndTimeTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditPriceAndTimeTriggerMutation, EditPriceAndTimeTriggerMutationVariables>;
export const UpdateTriggerNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTriggerName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTriggerNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTriggerName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTriggerNameMutation, UpdateTriggerNameMutationVariables>;
export const RunTriggerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunTrigger"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RunTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RunTriggerMutation, RunTriggerMutationVariables>;
export const ChangeUserNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeUserName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeUserNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeUserName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserServiceError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeUserNameMutation, ChangeUserNameMutationVariables>;
export const RemoveProfileImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProfileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProfileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RemoveProfileImageMutation, RemoveProfileImageMutationVariables>;
export const MarkActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<MarkActivityMutation, MarkActivityMutationVariables>;
export const UpdateNotificationPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationPermissionsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationPermissionsMutation, UpdateNotificationPermissionsMutationVariables>;
export const DeregisterPushNotificationReceiverByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeregisterPushNotificationReceiverByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deregisterPushNotificationReceiverByName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeregisterPushNotificationReceiverByNameMutation, DeregisterPushNotificationReceiverByNameMutationVariables>;
export const UpdateUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserLanguageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserLanguage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const MarkLearningScenarioAsViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkLearningScenarioAsViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkLearningScenarioAsViewedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markLearningScenarioAsViewed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MarkLearningScenarioAsViewedMutation, MarkLearningScenarioAsViewedMutationVariables>;
export const UpdateNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotificationSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const AllActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favouritePositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PositionFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightsFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"blue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"channelActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cacheInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]} as unknown as DocumentNode<AllActionsQuery, AllActionsQueryVariables>;
export const ActionDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"favouritePositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PositionFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightsFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"blue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"channelActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActionDetailsQuery, ActionDetailsQueryVariables>;
export const ChannelsGetAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChannelsGetAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUserChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"usesCounter"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"currentFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"favouritePositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PositionFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightsFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"blue"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetOnTimeFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"personalization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NoPersonalization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GatePersonalization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isQuickControl"}},{"kind":"Field","name":{"kind":"Name","value":"onEventAction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceConnectionState"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwitchChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"measuredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlindChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"measuredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"calibrateState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","alias":{"kind":"Name","value":"calibrateBlindError"},"name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeterChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterType"}},{"kind":"Field","name":{"kind":"Name","value":"supportedVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedScalarParameters"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveSupportedAggregateVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DefaultMeterTypeMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandaloneMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"InlineFragment","directives":[{"kind":"Directive","name":{"kind":"Name","value":"defer"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"maxActivePower"}},{"kind":"Field","name":{"kind":"Name","value":"averageActivePower"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedModes"}},{"kind":"Field","name":{"kind":"Name","value":"toggleValue"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptimizerChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"supportedVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedScalarParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedAggregateVectorParameters"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GateChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateKind"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"partialControlModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dailyModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lockStatus"}},{"kind":"Field","alias":{"kind":"Name","value":"gateDirection"},"name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"gateMode"}},{"kind":"Field","name":{"kind":"Name","value":"supportedGateFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"dependantChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calibrateState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","alias":{"kind":"Name","value":"calibrateGateError"},"name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericInputChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"genericInputType"}},{"kind":"Field","name":{"kind":"Name","value":"bistableMode"}},{"kind":"Field","name":{"kind":"Name","value":"monostableMode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChannelsGetAllQuery, ChannelsGetAllQueryVariables>;
export const ChannelsDetailsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChannelsDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"usesCounter"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"currentFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"favouritePositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PositionFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightsFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"blue"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetOnTimeFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"personalization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NoPersonalization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GatePersonalization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isQuickControl"}},{"kind":"Field","name":{"kind":"Name","value":"isPartialControlModeVisible"}},{"kind":"Field","name":{"kind":"Name","value":"isDailyModeVisible"}},{"kind":"Field","name":{"kind":"Name","value":"onEventAction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceConnectionState"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwitchChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"supplyReturnBehavior"}},{"kind":"Field","name":{"kind":"Name","value":"measuredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlindChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"measuredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterChannelId"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"calibrateState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","alias":{"kind":"Name","value":"calibrateBlindError"},"name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeterChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterType"}},{"kind":"Field","name":{"kind":"Name","value":"ampTransformers"}},{"kind":"Field","name":{"kind":"Name","value":"validationRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"hysteresis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"step"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"step"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meterPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"measuredChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"wholeWeekendCheaper"}},{"kind":"Field","name":{"kind":"Name","value":"wholeHolidaysCheaper"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreSummerTimeChanges"}},{"kind":"Field","name":{"kind":"Name","value":"hoursRanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"timeZoneKind"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DefaultMeterTypeMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandaloneMeasurementPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"InlineFragment","directives":[{"kind":"Directive","name":{"kind":"Name","value":"defer"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"maxActivePower"}},{"kind":"Field","name":{"kind":"Name","value":"averageActivePower"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportedVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedScalarParameters"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveSupportedAggregateVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"eventing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedRelaysIndices"}},{"kind":"Field","name":{"kind":"Name","value":"supportedSourceThresholds"}},{"kind":"Field","name":{"kind":"Name","value":"supportedControlModes"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"controlMode"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"deadTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"hysteresis"}},{"kind":"Field","name":{"kind":"Name","value":"minValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"cheapestPeriods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultAction"}},{"kind":"Field","name":{"kind":"Name","value":"isNotifyAction"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedModes"}},{"kind":"Field","name":{"kind":"Name","value":"supplyReturnBehavior"}},{"kind":"Field","name":{"kind":"Name","value":"toggleValue"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptimizerChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"supportedVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedScalarParameters"}},{"kind":"Field","name":{"kind":"Name","value":"supportedAggregateVectorParameters"}},{"kind":"Field","name":{"kind":"Name","value":"selfConsumptionWithPowerLimit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempMin"}},{"kind":"Field","name":{"kind":"Name","value":"heaterPowerLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tempMax"}},{"kind":"Field","name":{"kind":"Name","value":"tempMinEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"tempSelfConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"powerLimit"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voltageThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoltageThresholdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relaysConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelayConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TariffFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfConsumptionWithRelays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relaysConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelayConfigFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullSelfConsumption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempMin"}},{"kind":"Field","name":{"kind":"Name","value":"heaterPowerLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tempMax"}},{"kind":"Field","name":{"kind":"Name","value":"tempMinEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"tempSelfConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voltageThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoltageThresholdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relaysConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelayConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TariffFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comfort"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempMax"}},{"kind":"Field","name":{"kind":"Name","value":"heaterPowerLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tempMin"}},{"kind":"Field","name":{"kind":"Name","value":"voltageThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoltageThresholdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relaysConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelayConfigFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TariffFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempMax"}},{"kind":"Field","name":{"kind":"Name","value":"voltageThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoltageThresholdFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relaysConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelayConfigFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configValidation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thresholdPercent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thresholdPower"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeOn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeOff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voltageThreshold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tempMax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tempMin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tempSelfConsumptionMin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heaterPowerLimit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"powerLimit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FloatValidationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GateChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gateKind"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"partialControlModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dailyModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lockStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isNegativeOutput"}},{"kind":"Field","name":{"kind":"Name","value":"alertConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"barrierAlertEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"misdirectionAlertEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"externalSourceTriggeredAlertEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"openedIntervalToNotifyInMs"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"gateDirection"},"name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"gateMode"}},{"kind":"Field","name":{"kind":"Name","value":"sbsSignalTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"partialSbsTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"tiltTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"supportedGateFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"dependantChannels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calibrateState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"started"}},{"kind":"Field","alias":{"kind":"Name","value":"calibrateGateError"},"name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericInputChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"genericInputType"}},{"kind":"Field","name":{"kind":"Name","value":"bistableMode"}},{"kind":"Field","name":{"kind":"Name","value":"monostableMode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedChannelSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeterSharedChannelSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariffConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tariff"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingTier"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]}}]}},...WorkingHoursFragmentFragmentDoc.definitions,...VoltageThresholdFragmentFragmentDoc.definitions,...RelayConfigFragmentFragmentDoc.definitions,...TariffFragmentFragmentDoc.definitions,...FloatValidationFragmentFragmentDoc.definitions,...IntValidationFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ChannelsDetailsQuery, ChannelsDetailsQueryVariables>;
export const GateHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GateHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonNegativeInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonNegativeInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gateUserChannel"},"name":{"kind":"Name","value":"userChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GateChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","directives":[{"kind":"Directive","name":{"kind":"Name","value":"defer"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"occuredAt"}},{"kind":"Field","name":{"kind":"Name","value":"controlledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"controlSource"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GateHistoryQuery, GateHistoryQueryVariables>;
export const DashboardItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultGroup"}},{"kind":"Field","name":{"kind":"Name","value":"isPublicGroup"}},{"kind":"Field","name":{"kind":"Name","value":"groupItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}},{"kind":"Field","name":{"kind":"Name","value":"usesCounter"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favouritePositions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PositionFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightsFavourites"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"red"}},{"kind":"Field","name":{"kind":"Name","value":"green"}},{"kind":"Field","name":{"kind":"Name","value":"blue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"action"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cacheInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardItemsQuery, DashboardItemsQueryVariables>;
export const DevicesGetAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DevicesGetAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUserDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"connectedToSsid"}},{"kind":"Field","name":{"kind":"Name","value":"currentFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"macAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"newestFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"channelInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DevicesGetAllQuery, DevicesGetAllQueryVariables>;
export const DeviceDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDevice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"connectedToSsid"}},{"kind":"Field","name":{"kind":"Name","value":"currentFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"macAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"newestFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"channelInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeviceDetailsQuery, DeviceDetailsQueryVariables>;
export const DeviceGetBindingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceGetBindings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channelBindings"},"name":{"kind":"Name","value":"allUserChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericInputChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"genericInputType"}},{"kind":"Field","name":{"kind":"Name","value":"areCloudActionsSupported"}},{"kind":"Field","name":{"kind":"Name","value":"actionBindings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefaultAction"}},{"kind":"Field","name":{"kind":"Name","value":"inputTrigger"}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwitchActionConfigResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"switchSlot"},"name":{"kind":"Name","value":"slot"}},{"kind":"Field","name":{"kind":"Name","value":"setOnTimeValue"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightActionConfigResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lightSlot"},"name":{"kind":"Name","value":"slot"}},{"kind":"Field","name":{"kind":"Name","value":"setOnTimeValue"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlindActionConfigResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blindSlot"},"name":{"kind":"Name","value":"slot"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GateActionConfigResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gateSlot"},"name":{"kind":"Name","value":"slot"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"dir"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CloudActionConfigResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onSignalActionId"}},{"kind":"Field","name":{"kind":"Name","value":"offSignalActionId"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwitchChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"switchSupportedSlots"},"name":{"kind":"Name","value":"supportedSlots"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlindChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blindSupportedSlots"},"name":{"kind":"Name","value":"supportedSlots"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LightChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lightSupportedSlots"},"name":{"kind":"Name","value":"supportedSlots"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GateChannelStateResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gateSupportedSlots"},"name":{"kind":"Name","value":"supportedSlots"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeviceGetBindingsQuery, DeviceGetBindingsQueryVariables>;
export const VersionMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VersionMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versionMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"versionedFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"build"}},{"kind":"Field","name":{"kind":"Name","value":"asString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VersionMapQuery, VersionMapQueryVariables>;
export const RssiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Rssi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rssi"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rssi"}}]}}]}}]} as unknown as DocumentNode<RssiQuery, RssiQueryVariables>;
export const InstallationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstallationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationModelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExalusInstallationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InstallationSettingsQuery, InstallationSettingsQueryVariables>;
export const InstallationGetAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstallationGetAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userInstallations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"externalPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExalusInstallationPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cacheInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]} as unknown as DocumentNode<InstallationGetAllQuery, InstallationGetAllQueryVariables>;
export const CurrentInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentInstallation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentInstallation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"brokerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstallationModelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cacheResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementMapCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installationsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentInstallationQuery, CurrentInstallationQueryVariables>;
export const AllInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCreatedByMe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInvitedMe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allInvitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeCreatedByMe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCreatedByMe"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeInvitedMe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInvitedMe"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"invitedUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"invitedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sharingPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholeInstallationShare"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"sharedItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllInvitationsQuery, AllInvitationsQueryVariables>;
export const MeterAggregatedMeasurementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeterAggregatedMeasurements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAggregateMeasurementsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterAggregatedMeasurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateVectorMeasurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"range"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"tariff"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<MeterAggregatedMeasurementsQuery, MeterAggregatedMeasurementsQueryVariables>;
export const PersistedMeterAggregatedMeasurementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersistedMeterAggregatedMeasurements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPersistedAggregateMeasurementsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persistedMeterAggregatedMeasurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"oldestAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"dateAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"measurements"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<PersistedMeterAggregatedMeasurementsQuery, PersistedMeterAggregatedMeasurementsQueryVariables>;
export const MeterCommonMeasurementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeterCommonMeasurements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCommonMeasurementsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meterCommonMeasurements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vectorMeasurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scalarMeasurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<MeterCommonMeasurementsQuery, MeterCommonMeasurementsQueryVariables>;
export const MeasurementMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeasurementMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"scalars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vectors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"optimizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"scalars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vectors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cacheInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}}]}}]}}]} as unknown as DocumentNode<MeasurementMapQuery, MeasurementMapQueryVariables>;
export const DynamicMarketPricesWithBucketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DynamicMarketPricesWithBuckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dynamicMarketPricesWithBuckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromPriceInKWh"}},{"kind":"Field","name":{"kind":"Name","value":"toPriceInKWh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"priceInMWh"}},{"kind":"Field","name":{"kind":"Name","value":"priceInkWh"}},{"kind":"Field","name":{"kind":"Name","value":"startingHour"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DynamicMarketPricesWithBucketsQuery, DynamicMarketPricesWithBucketsQueryVariables>;
export const SeasonPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SeasonPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"workingDayEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"priceInMWh"}},{"kind":"Field","name":{"kind":"Name","value":"priceInkWh"}},{"kind":"Field","name":{"kind":"Name","value":"startingHour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offFromWorkDayEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"priceInMWh"}},{"kind":"Field","name":{"kind":"Name","value":"priceInkWh"}},{"kind":"Field","name":{"kind":"Name","value":"startingHour"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"winter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"workingDayEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"priceInMWh"}},{"kind":"Field","name":{"kind":"Name","value":"priceInkWh"}},{"kind":"Field","name":{"kind":"Name","value":"startingHour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offFromWorkDayEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"priceInMWh"}},{"kind":"Field","name":{"kind":"Name","value":"priceInkWh"}},{"kind":"Field","name":{"kind":"Name","value":"startingHour"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"staticHolidays"}},{"kind":"Field","name":{"kind":"Name","value":"movableHolidays"}},{"kind":"Field","name":{"kind":"Name","value":"bucketInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromPriceInKWh"}},{"kind":"Field","name":{"kind":"Name","value":"toPriceInKWh"}}]}}]}}]}}]} as unknown as DocumentNode<SeasonPricesQuery, SeasonPricesQueryVariables>;
export const AllUserNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllUserNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"wasDisplayed"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllUserNotificationsQuery, AllUserNotificationsQueryVariables>;
export const UserNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"correlationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"correlationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"wasDisplayed"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UserNotificationQuery, UserNotificationQueryVariables>;
export const BluetoothLoggingEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BluetoothLoggingEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bluetoothLoggingEnabled"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}]}]}}]} as unknown as DocumentNode<BluetoothLoggingEnabledQuery, BluetoothLoggingEnabledQueryVariables>;
export const UserSharingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSharingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharingInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sharedToUserId"}},{"kind":"Field","name":{"kind":"Name","value":"sharingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedToUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastActivity"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedToUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastActivity"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"wholeInstallationShare"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}}]}}]}}]} as unknown as DocumentNode<UserSharingInfoQuery, UserSharingInfoQueryVariables>;
export const SharingInfosByInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SharingInfosByInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharingInfosByInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedToUserId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedToUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastActivity"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedUses"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"wholeInstallationShare"}},{"kind":"Field","name":{"kind":"Name","value":"sharedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUntil"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SharingInfosByInstallationQuery, SharingInfosByInstallationQueryVariables>;
export const CalculateNextTriggerFireTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculateNextTriggerFireTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerTimeConditionRequestInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateNextTriggerFireTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trigger"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}}},{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextFireTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<CalculateNextTriggerFireTimeQuery, CalculateNextTriggerFireTimeQueryVariables>;
export const CalculateFutureFireTimesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculateFutureFireTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerPriceAndTimeConditionRequestInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateFutureFireTimes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trigger"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trigger"}}},{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"futureFires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<CalculateFutureFireTimesQuery, CalculateFutureFireTimesQueryVariables>;
export const AllTriggersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllTriggers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTriggers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"timeCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atSunrise"}},{"kind":"Field","name":{"kind":"Name","value":"sunriseAdvance"}},{"kind":"Field","name":{"kind":"Name","value":"sunriseDelay"}},{"kind":"Field","name":{"kind":"Name","value":"atSunset"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetAdvance"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetDelay"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDay"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"everyMonth"}},{"kind":"Field","name":{"kind":"Name","value":"everyYear"}},{"kind":"Field","name":{"kind":"Name","value":"currentExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"nextFireTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booleanValue"}},{"kind":"Field","name":{"kind":"Name","value":"integerValue"}},{"kind":"Field","name":{"kind":"Name","value":"conditionType"}},{"kind":"Field","name":{"kind":"Name","value":"timeIntervalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeFrom"}},{"kind":"Field","name":{"kind":"Name","value":"timeTo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceAndTimeCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceGreaterThanOrEqual"}},{"kind":"Field","name":{"kind":"Name","value":"priceLesserThanOrEqual"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCheapestPeriodsInDay"}},{"kind":"Field","name":{"kind":"Name","value":"betweenHoursFromInclusive"}},{"kind":"Field","name":{"kind":"Name","value":"betweenHoursToInclusive"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"nextFireTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"integerValue"}},{"kind":"Field","name":{"kind":"Name","value":"booleanValue"}},{"kind":"Field","name":{"kind":"Name","value":"lightColorValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onFailureMode"}},{"kind":"Field","name":{"kind":"Name","value":"executionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executedAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedExecutionAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"actionsResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSuccessful"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"errorType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<AllTriggersQuery, AllTriggersQueryVariables>;
export const TriggerDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TriggerDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"timeCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holidaysHandling"}},{"kind":"Field","name":{"kind":"Name","value":"atSunrise"}},{"kind":"Field","name":{"kind":"Name","value":"sunriseAdvance"}},{"kind":"Field","name":{"kind":"Name","value":"sunriseDelay"}},{"kind":"Field","name":{"kind":"Name","value":"atSunset"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetAdvance"}},{"kind":"Field","name":{"kind":"Name","value":"sunsetDelay"}},{"kind":"Field","name":{"kind":"Name","value":"timeOfDay"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"everyMonth"}},{"kind":"Field","name":{"kind":"Name","value":"everyYear"}},{"kind":"Field","name":{"kind":"Name","value":"currentExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"nextFireTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"booleanValue"}},{"kind":"Field","name":{"kind":"Name","value":"integerValue"}},{"kind":"Field","name":{"kind":"Name","value":"conditionType"}},{"kind":"Field","name":{"kind":"Name","value":"timeIntervalValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeFrom"}},{"kind":"Field","name":{"kind":"Name","value":"timeTo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceAndTimeCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subType"}},{"kind":"Field","name":{"kind":"Name","value":"holidaysHandling"}},{"kind":"Field","name":{"kind":"Name","value":"priceGreaterThanOrEqual"}},{"kind":"Field","name":{"kind":"Name","value":"priceLesserThanOrEqual"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCheapestPeriodsInDay"}},{"kind":"Field","name":{"kind":"Name","value":"betweenHoursFromInclusive"}},{"kind":"Field","name":{"kind":"Name","value":"betweenHoursToInclusive"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"targetExecutionCount"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"nextFireTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"integerValue"}},{"kind":"Field","name":{"kind":"Name","value":"booleanValue"}},{"kind":"Field","name":{"kind":"Name","value":"lightColorValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onFailureMode"}},{"kind":"Field","name":{"kind":"Name","value":"executionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executedAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedExecutionAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isSuccessful"}},{"kind":"Field","name":{"kind":"Name","value":"actionsResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSuccessful"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partType"}},{"kind":"Field","name":{"kind":"Name","value":"errorType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<TriggerDetailsQuery, TriggerDetailsQueryVariables>;
export const UserMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"}}]}}]}}]}}]} as unknown as DocumentNode<UserMeQuery, UserMeQueryVariables>;
export const UserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"automationEmailNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"automationInAppNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"automationPushNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"channelsEmailNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"channelsInAppNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"channelsPushNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"sharingEmailNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"sharingPushNotificationPermission"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"displayedLearningScenarios"}},{"kind":"Field","name":{"kind":"Name","value":"appScopedNotificationsPermission"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAppScopedValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultInstallationScopedValue"}},{"kind":"Field","name":{"kind":"Name","value":"pushNotificationsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"emailNotificationsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"countOfUnreadNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"currentInstallationScopedNotificationsPermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}]}]}}]}}]} as unknown as DocumentNode<UserProfileQuery, UserProfileQueryVariables>;
export const OnSwitchStateChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onSwitchStateChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onSwitchStateChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<OnSwitchStateChangeSubscription, OnSwitchStateChangeSubscriptionVariables>;
export const OnBlindPositionChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onBlindPositionChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onBlindPositionChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"predictedTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"targetPosition"}},{"kind":"Field","name":{"kind":"Name","value":"slatsPredictedTimeInMs"}}]}}]}}]} as unknown as DocumentNode<OnBlindPositionChangeSubscription, OnBlindPositionChangeSubscriptionVariables>;
export const OnGateStatusChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onGateStatusChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onGateStatusChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"dailyModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"lockStatus"}},{"kind":"Field","name":{"kind":"Name","value":"partialControlModeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"predictedTimeInMs"}},{"kind":"Field","name":{"kind":"Name","value":"targetPosition"}}]}}]}}]} as unknown as DocumentNode<OnGateStatusChangedSubscription, OnGateStatusChangedSubscriptionVariables>;
export const OnLightStateChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onLightStateChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onLightStateChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"toggleValue"}},{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"r"}},{"kind":"Field","name":{"kind":"Name","value":"g"}},{"kind":"Field","name":{"kind":"Name","value":"b"}}]}}]}}]}}]} as unknown as DocumentNode<OnLightStateChangedSubscription, OnLightStateChangedSubscriptionVariables>;
export const OnRequestAckReceivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"onRequestAckReceived"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelOrDeviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onRequestAckReceived"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelOrDeviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelOrDeviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OnRequestAckReceivedSubscription, OnRequestAckReceivedSubscriptionVariables>;
export const OnDeviceConnectionStateChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceConnectionStateChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceConnectionStateChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceConnectionState"}}]}}]}}]} as unknown as DocumentNode<OnDeviceConnectionStateChangeSubscription, OnDeviceConnectionStateChangeSubscriptionVariables>;
export const OnBlindCalibrateStatusChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnBlindCalibrateStatusChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onBlindCalibrateStatusChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<OnBlindCalibrateStatusChangeSubscription, OnBlindCalibrateStatusChangeSubscriptionVariables>;
export const OnDeviceFirmwareUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceFirmwareUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceFirmwareUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentFirmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<OnDeviceFirmwareUpdatedSubscription, OnDeviceFirmwareUpdatedSubscriptionVariables>;
export const OnRecoveryDeviceStatusReceivedPayloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnRecoveryDeviceStatusReceivedPayload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onRecoveryDeviceStatusRecievedPayload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"recoveryDeviceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]} as unknown as DocumentNode<OnRecoveryDeviceStatusReceivedPayloadSubscription, OnRecoveryDeviceStatusReceivedPayloadSubscriptionVariables>;
export const OnDeviceWifiNetworksReceivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceWifiNetworksReceived"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceWifiNetworksReceived"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wifiNetworks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remembered"}},{"kind":"Field","name":{"kind":"Name","value":"rssi"}},{"kind":"Field","name":{"kind":"Name","value":"ssid"}}]}}]}}]}}]} as unknown as DocumentNode<OnDeviceWifiNetworksReceivedSubscription, OnDeviceWifiNetworksReceivedSubscriptionVariables>;
export const OnDeviceConnectedToSsidUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceConnectedToSsidUpdated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceConnectedToSsidUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedToSsid"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<OnDeviceConnectedToSsidUpdatedSubscription, OnDeviceConnectedToSsidUpdatedSubscriptionVariables>;
export const OnOptimizerConfigurationUpdatedPayloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnOptimizerConfigurationUpdatedPayload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onOptimizerConfigurationUpdatedPayload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<OnOptimizerConfigurationUpdatedPayloadSubscription, OnOptimizerConfigurationUpdatedPayloadSubscriptionVariables>;
export const OnGateCalibrateStatusChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnGateCalibrateStatusChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onGateCalibrateStatusChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"openingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"closingMilliseconds"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<OnGateCalibrateStatusChangeSubscription, OnGateCalibrateStatusChangeSubscriptionVariables>;
export const OnGenericInputStateChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnGenericInputStateChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onGenericInputStateChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"bistableMode"}},{"kind":"Field","name":{"kind":"Name","value":"monostableMode"}},{"kind":"Field","name":{"kind":"Name","value":"genericInputType"}}]}}]}}]} as unknown as DocumentNode<OnGenericInputStateChangeSubscription, OnGenericInputStateChangeSubscriptionVariables>;
export const OnGenericInputStatusChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnGenericInputStatusChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onGenericInputStatusChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<OnGenericInputStatusChangedSubscription, OnGenericInputStatusChangedSubscriptionVariables>;
export const OnSupplyReturnBehaviorChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnSupplyReturnBehaviorChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onSupplyReturnBehaviorChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"supplyReturnBehavior"}}]}}]}}]} as unknown as DocumentNode<OnSupplyReturnBehaviorChangeSubscription, OnSupplyReturnBehaviorChangeSubscriptionVariables>;
export const OnGateConfigurationChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnGateConfigurationChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onGateConfigurationChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"supportedGateFeatures"}}]}}]}}]} as unknown as DocumentNode<OnGateConfigurationChangeSubscription, OnGateConfigurationChangeSubscriptionVariables>;
export const OnConfigurationTaintedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnConfigurationTainted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onConfigurationTaintedPayload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failures"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<OnConfigurationTaintedSubscription, OnConfigurationTaintedSubscriptionVariables>;
export const OnDeviceErrorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceError"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceError"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}}]}}]}}]} as unknown as DocumentNode<OnDeviceErrorSubscription, OnDeviceErrorSubscriptionVariables>;
export const OnPartialConfigChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnPartialConfigChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onPartialConfigChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numericalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedProperties"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"installationId"}}]}}]}}]} as unknown as DocumentNode<OnPartialConfigChangedSubscription, OnPartialConfigChangedSubscriptionVariables>;
export const OnDeviceNameChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnDeviceNameChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onDeviceNameChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OnDeviceNameChangedSubscription, OnDeviceNameChangedSubscriptionVariables>;
export const OnInstallationDetachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnInstallationDetach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onInstallationDetach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installationId"}},{"kind":"Field","name":{"kind":"Name","value":"newBrokerUrl"}}]}}]}}]} as unknown as DocumentNode<OnInstallationDetachSubscription, OnInstallationDetachSubscriptionVariables>;
export const OnMeasurementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnMeasurement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscribeForMeasurementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onMeasurement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeasurementSubscriptionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unixTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeasurementSubscriptionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unixTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"scalarMeasurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vectorMeasurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnMeasurementSubscription, OnMeasurementSubscriptionVariables>;
export const OnNotifiedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnNotified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onNotified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"wasDisplayed"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"params"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<OnNotifiedSubscription, OnNotifiedSubscriptionVariables>;